function tamingselect() {
        function t(t, e) {
            return new RegExp("\\b" + e + "\\b").test(t.className)
        }

        function e(e, i, n) {
            var a = e.className;
            e.className = t(e, i) ? a.replace(i, n) : a.replace(n, i)
        }

        function i(e, i) {
            t(e, i) || (e.className += "" == e.className ? i : " " + i)
        }
        if (document.getElementById || document.createTextNode) {
            for (var n = "", a = "turnintoselect", r = "dropcontainer", o = "activetrigger", s = "trigger", l = "dropdownhidden", c = "dropdownvisible", u = 0, d = new Array, h = document.getElementsByClassName("select-me"), p = 0; p < h.length; p++)
                if (t(h[p], n)) {
                    var f = document.createElement("input");
                    f.name = h[p].name, f.type = "hidden", f.id = h[p].id, f.value = h[p].options[0].value, h[p].parentNode.insertBefore(f, h[p]);
                    var g = document.createElement("a");
                    i(g, s), g.href = "#", g.onclick = function() {
                        return e(this, s, o), e(this.parentNode.getElementsByTagName("ul")[0], l, c), !1
                    }, g.appendChild(document.createTextNode(h[p].options[0].text)), h[p].parentNode.insertBefore(g, h[p]);
                    for (var m = document.createElement("ul"), v = 0; v < h[p].getElementsByTagName("option").length; v++) {
                        var y = document.createElement("li"),
                            w = document.createElement("a");
                        y.v = h[p].getElementsByTagName("option")[v].value, y.elm = f, y.istrigger = g, w.href = "#", w.appendChild(document.createTextNode(h[p].getElementsByTagName("option")[v].text)), y.onclick = function() {
                            return this.elm.value = this.v, e(this.istrigger, o, s), 
                              e(this.parentNode, c, l), 
                              this.istrigger.firstChild.nodeValue = this.firstChild.firstChild.nodeValue, 
                              $('#sortDanBy').length ? window.location = '?sort_by='+this.elm.value : !1
                            
                        }, y.appendChild(w), m.appendChild(y)
                    }
                    i(m, l);
                    var b = document.createElement("div");
                    b.appendChild(m), i(b, r), h[p].parentNode.insertBefore(b, h[p]), d[u] = h[p], u++
                }
            for (p = 0; u > p; p++) d[p].parentNode.removeChild(d[p])
        }
    }! function($) {
        "use strict";
        $.fn.fitVids = function(t) {
            var e = {
                customSelector: null
            };
            if (!document.getElementById("fit-vids-style")) {
                var i = document.head || document.getElementsByTagName("head")[0],
                    n = ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}",
                    a = document.createElement("div");
                a.innerHTML = '<p>x</p><style id="fit-vids-style">' + n + "</style>", i.appendChild(a.childNodes[1])
            }
            return t && $.extend(e, t), this.each(function() {
                var t = ["iframe[src*='player.vimeo.com']", "iframe[src*='youtube.com']", "iframe[src*='youtube-nocookie.com']", "iframe[src*='kickstarter.com'][src*='video.html']", "object", "embed"];
                e.customSelector && t.push(e.customSelector);
                var i = $(this).find(t.join(","));
                i = i.not("object object"), i.each(function() {
                    var t = $(this);
                    if (!("embed" === this.tagName.toLowerCase() && t.parent("object").length || t.parent(".fluid-width-video-wrapper").length)) {
                        var e = "object" === this.tagName.toLowerCase() || t.attr("height") && !isNaN(parseInt(t.attr("height"), 10)) ? parseInt(t.attr("height"), 10) : t.height(),
                            i = isNaN(parseInt(t.attr("width"), 10)) ? t.width() : parseInt(t.attr("width"), 10),
                            n = e / i;
                        if (!t.attr("id")) {
                            var a = "fitvid" + Math.floor(999999 * Math.random());
                            t.attr("id", a)
                        }
                        t.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top", 100 * n + "%"), t.removeAttr("height").removeAttr("width")
                    }
                })
            })
        }
    }(window.jQuery || window.Zepto),
    function(t, e, i, n) {
        var a = i("html"),
            r = i(t),
            o = i(e),
            s = i.fancybox = function() {
                s.open.apply(this, arguments)
            },
            l = navigator.userAgent.match(/msie/i),
            c = null,
            u = e.createTouch !== n,
            d = function(t) {
                return t && t.hasOwnProperty && t instanceof i
            },
            h = function(t) {
                return t && "string" === i.type(t)
            },
            p = function(t) {
                return h(t) && 0 < t.indexOf("%")
            },
            f = function(t, e) {
                var i = parseInt(t, 10) || 0;
                return e && p(t) && (i *= s.getViewport()[e] / 100), Math.ceil(i)
            },
            g = function(t, e) {
                return f(t, e) + "px"
            };
        i.extend(s, {
            version: "2.1.5",
            defaults: {
                padding: 15,
                margin: 20,
                width: 800,
                height: 600,
                minWidth: 100,
                minHeight: 100,
                maxWidth: 9999,
                maxHeight: 9999,
                pixelRatio: 1,
                autoSize: !0,
                autoHeight: !1,
                autoWidth: !1,
                autoResize: !0,
                autoCenter: !u,
                fitToView: !0,
                aspectRatio: !1,
                topRatio: .5,
                leftRatio: .5,
                scrolling: "auto",
                wrapCSS: "",
                arrows: !0,
                closeBtn: !0,
                closeClick: !1,
                nextClick: !1,
                mouseWheel: !0,
                autoPlay: !1,
                playSpeed: 3e3,
                preload: 3,
                modal: !1,
                loop: !0,
                ajax: {
                    dataType: "html",
                    headers: {
                        "X-fancyBox": !0
                    }
                },
                iframe: {
                    scrolling: "auto",
                    preload: !0
                },
                swf: {
                    wmode: "transparent",
                    allowfullscreen: "true",
                    allowscriptaccess: "always"
                },
                keys: {
                    next: {
                        13: "left",
                        34: "up",
                        39: "left",
                        40: "up"
                    },
                    prev: {
                        8: "right",
                        33: "down",
                        37: "right",
                        38: "down"
                    },
                    close: [27],
                    play: [32],
                    toggle: [70]
                },
                direction: {
                    next: "left",
                    prev: "right"
                },
                scrollOutside: !0,
                index: 0,
                type: null,
                href: null,
                content: null,
                title: null,
                tpl: {
                    wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                    image: '<img class="fancybox-image" src="{href}" alt="" />',
                    iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (l ? ' allowtransparency="true"' : "") + "></iframe>",
                    error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                    closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                    next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
                    prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
                },
                openEffect: "fade",
                openSpeed: 250,
                openEasing: "swing",
                openOpacity: !0,
                openMethod: "zoomIn",
                closeEffect: "fade",
                closeSpeed: 250,
                closeEasing: "swing",
                closeOpacity: !0,
                closeMethod: "zoomOut",
                nextEffect: "elastic",
                nextSpeed: 250,
                nextEasing: "swing",
                nextMethod: "changeIn",
                prevEffect: "elastic",
                prevSpeed: 250,
                prevEasing: "swing",
                prevMethod: "changeOut",
                helpers: {
                    overlay: !0,
                    title: !0
                },
                onCancel: i.noop,
                beforeLoad: i.noop,
                afterLoad: i.noop,
                beforeShow: i.noop,
                afterShow: i.noop,
                beforeChange: i.noop,
                beforeClose: i.noop,
                afterClose: i.noop
            },
            group: {},
            opts: {},
            previous: null,
            coming: null,
            current: null,
            isActive: !1,
            isOpen: !1,
            isOpened: !1,
            wrap: null,
            skin: null,
            outer: null,
            inner: null,
            player: {
                timer: null,
                isActive: !1
            },
            ajaxLoad: null,
            imgPreload: null,
            transitions: {},
            helpers: {},
            open: function(t, e) {
                return t && (i.isPlainObject(e) || (e = {}), !1 !== s.close(!0)) ? (i.isArray(t) || (t = d(t) ? i(t).get() : [t]), i.each(t, function(a, r) {
                    var o = {},
                        l, c, u, p, f;
                    "object" === i.type(r) && (r.nodeType && (r = i(r)), d(r) ? (o = {
                        href: r.data("fancybox-href") || r.attr("href"),
                        title: r.data("fancybox-title") || r.attr("title"),
                        isDom: !0,
                        element: r
                    }, i.metadata && i.extend(!0, o, r.metadata())) : o = r), l = e.href || o.href || (h(r) ? r : null), c = e.title !== n ? e.title : o.title || "", p = (u = e.content || o.content) ? "html" : e.type || o.type, !p && o.isDom && (p = r.data("fancybox-type"), p || (p = (p = r.prop("class").match(/fancybox\.(\w+)/)) ? p[1] : null)), h(l) && (p || (s.isImage(l) ? p = "image" : s.isSWF(l) ? p = "swf" : "#" === l.charAt(0) ? p = "inline" : h(r) && (p = "html", u = r)), "ajax" === p && (f = l.split(/\s+/, 2), l = f.shift(), f = f.shift())), u || ("inline" === p ? l ? u = i(h(l) ? l.replace(/.*(?=#[^\s]+$)/, "") : l) : o.isDom && (u = r) : "html" === p ? u = l : !p && !l && o.isDom && (p = "inline", u = r)), i.extend(o, {
                        href: l,
                        type: p,
                        content: u,
                        title: c,
                        selector: f
                    }), t[a] = o
                }), s.opts = i.extend(!0, {}, s.defaults, e), e.keys !== n && (s.opts.keys = e.keys ? i.extend({}, s.defaults.keys, e.keys) : !1), s.group = t, s._start(s.opts.index)) : void 0
            },
            cancel: function() {
                var t = s.coming;
                t && !1 !== s.trigger("onCancel") && (s.hideLoading(), s.ajaxLoad && s.ajaxLoad.abort(), s.ajaxLoad = null, s.imgPreload && (s.imgPreload.onload = s.imgPreload.onerror = null), t.wrap && t.wrap.stop(!0, !0).trigger("onReset").remove(), s.coming = null, s.current || s._afterZoomOut(t))
            },
            close: function(t) {
                s.cancel(), !1 !== s.trigger("beforeClose") && (s.unbindEvents(), s.isActive && (s.isOpen && !0 !== t ? (s.isOpen = s.isOpened = !1, s.isClosing = !0, i(".fancybox-item, .fancybox-nav").remove(), s.wrap.stop(!0, !0).removeClass("fancybox-opened"), s.transitions[s.current.closeMethod]()) : (i(".fancybox-wrap").stop(!0).trigger("onReset").remove(), s._afterZoomOut())))
            },
            play: function(t) {
                var e = function() {
                        clearTimeout(s.player.timer)
                    },
                    i = function() {
                        e(), s.current && s.player.isActive && (s.player.timer = setTimeout(s.next, s.current.playSpeed))
                    },
                    n = function() {
                        e(), o.unbind(".player"), s.player.isActive = !1, s.trigger("onPlayEnd")
                    };
                !0 === t || !s.player.isActive && !1 !== t ? s.current && (s.current.loop || s.current.index < s.group.length - 1) && (s.player.isActive = !0, o.bind({
                    "onCancel.player beforeClose.player": n,
                    "onUpdate.player": i,
                    "beforeLoad.player": e
                }), i(), s.trigger("onPlayStart")) : n()
            },
            next: function(t) {
                var e = s.current;
                e && (h(t) || (t = e.direction.next), s.jumpto(e.index + 1, t, "next"))
            },
            prev: function(t) {
                var e = s.current;
                e && (h(t) || (t = e.direction.prev), s.jumpto(e.index - 1, t, "prev"))
            },
            jumpto: function(t, e, i) {
                var a = s.current;
                a && (t = f(t), s.direction = e || a.direction[t >= a.index ? "next" : "prev"], s.router = i || "jumpto", a.loop && (0 > t && (t = a.group.length + t % a.group.length), t %= a.group.length), a.group[t] !== n && (s.cancel(), s._start(t)))
            },
            reposition: function(t, e) {
                var n = s.current,
                    a = n ? n.wrap : null,
                    r;
                a && (r = s._getPosition(e), t && "scroll" === t.type ? (delete r.position, a.stop(!0, !0).animate(r, 200)) : (a.css(r), n.pos = i.extend({}, n.dim, r)))
            },
            update: function(t) {
                var e = t && t.type,
                    i = !e || "orientationchange" === e;
                i && (clearTimeout(c), c = null), s.isOpen && !c && (c = setTimeout(function() {
                    var n = s.current;
                    n && !s.isClosing && (s.wrap.removeClass("fancybox-tmp"), (i || "load" === e || "resize" === e && n.autoResize) && s._setDimension(), "scroll" === e && n.canShrink || s.reposition(t), s.trigger("onUpdate"), c = null)
                }, i && !u ? 0 : 300))
            },
            toggle: function(t) {
                s.isOpen && (s.current.fitToView = "boolean" === i.type(t) ? t : !s.current.fitToView, u && (s.wrap.removeAttr("style").addClass("fancybox-tmp"), s.trigger("onUpdate")), s.update())
            },
            hideLoading: function() {
                o.unbind(".loading"), i("#fancybox-loading").remove()
            },
            showLoading: function() {
                var t, e;
                s.hideLoading(), t = i('<div id="fancybox-loading"><div></div></div>').click(s.cancel).appendTo("body"), o.bind("keydown.loading", function(t) {
                    27 === (t.which || t.keyCode) && (t.preventDefault(), s.cancel())
                }), s.defaults.fixed || (e = s.getViewport(), t.css({
                    position: "absolute",
                    top: .5 * e.h + e.y,
                    left: .5 * e.w + e.x
                }))
            },
            getViewport: function() {
                var e = s.current && s.current.locked || !1,
                    i = {
                        x: r.scrollLeft(),
                        y: r.scrollTop()
                    };
                return e ? (i.w = e[0].clientWidth, i.h = e[0].clientHeight) : (i.w = u && t.innerWidth ? t.innerWidth : r.width(), i.h = u && t.innerHeight ? t.innerHeight : r.height()), i
            },
            unbindEvents: function() {
                s.wrap && d(s.wrap) && s.wrap.unbind(".fb"), o.unbind(".fb"), r.unbind(".fb")
            },
            bindEvents: function() {
                var t = s.current,
                    e;
                t && (r.bind("orientationchange.fb" + (u ? "" : " resize.fb") + (t.autoCenter && !t.locked ? " scroll.fb" : ""), s.update), (e = t.keys) && o.bind("keydown.fb", function(a) {
                    var r = a.which || a.keyCode,
                        o = a.target || a.srcElement;
                    return 27 === r && s.coming ? !1 : void!(a.ctrlKey || a.altKey || a.shiftKey || a.metaKey || o && (o.type || i(o).is("[contenteditable]")) || !i.each(e, function(e, o) {
                        return 1 < t.group.length && o[r] !== n ? (s[e](o[r]), a.preventDefault(), !1) : -1 < i.inArray(r, o) ? (s[e](), a.preventDefault(), !1) : void 0
                    }))
                }), i.fn.mousewheel && t.mouseWheel && s.wrap.bind("mousewheel.fb", function(e, n, a, r) {
                    for (var o = i(e.target || null), l = !1; o.length && !l && !o.is(".fancybox-skin") && !o.is(".fancybox-wrap");) l = o[0] && !(o[0].style.overflow && "hidden" === o[0].style.overflow) && (o[0].clientWidth && o[0].scrollWidth > o[0].clientWidth || o[0].clientHeight && o[0].scrollHeight > o[0].clientHeight), o = i(o).parent();
                    0 !== n && !l && 1 < s.group.length && !t.canShrink && (r > 0 || a > 0 ? s.prev(r > 0 ? "down" : "left") : (0 > r || 0 > a) && s.next(0 > r ? "up" : "right"), e.preventDefault())
                }))
            },
            trigger: function(t, e) {
                var n, a = e || s.coming || s.current;
                if (a) {
                    if (i.isFunction(a[t]) && (n = a[t].apply(a, Array.prototype.slice.call(arguments, 1))), !1 === n) return !1;
                    a.helpers && i.each(a.helpers, function(e, n) {
                        n && s.helpers[e] && i.isFunction(s.helpers[e][t]) && s.helpers[e][t](i.extend(!0, {}, s.helpers[e].defaults, n), a)
                    }), o.trigger(t)
                }
            },
            isImage: function(t) {
                return h(t) && t.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)
            },
            isSWF: function(t) {
                return h(t) && t.match(/\.(swf)((\?|#).*)?$/i)
            },
            _start: function(t) {
                var e = {},
                    n, a;
                if (t = f(t), n = s.group[t] || null, !n) return !1;
                if (e = i.extend(!0, {}, s.opts, n), n = e.margin, a = e.padding, "number" === i.type(n) && (e.margin = [n, n, n, n]), "number" === i.type(a) && (e.padding = [a, a, a, a]), e.modal && i.extend(!0, e, {
                        closeBtn: !1,
                        closeClick: !1,
                        nextClick: !1,
                        arrows: !1,
                        mouseWheel: !1,
                        keys: null,
                        helpers: {
                            overlay: {
                                closeClick: !1
                            }
                        }
                    }), e.autoSize && (e.autoWidth = e.autoHeight = !0), "auto" === e.width && (e.autoWidth = !0), "auto" === e.height && (e.autoHeight = !0), e.group = s.group, e.index = t, s.coming = e, !1 === s.trigger("beforeLoad")) s.coming = null;
                else {
                    if (a = e.type, n = e.href, !a) return s.coming = null, s.current && s.router && "jumpto" !== s.router ? (s.current.index = t, s[s.router](s.direction)) : !1;
                    if (s.isActive = !0, ("image" === a || "swf" === a) && (e.autoHeight = e.autoWidth = !1, e.scrolling = "visible"), "image" === a && (e.aspectRatio = !0), "iframe" === a && u && (e.scrolling = "scroll"), e.wrap = i(e.tpl.wrap).addClass("fancybox-" + (u ? "mobile" : "desktop") + " fancybox-type-" + a + " fancybox-tmp " + e.wrapCSS).appendTo(e.parent || "body"), i.extend(e, {
                            skin: i(".fancybox-skin", e.wrap),
                            outer: i(".fancybox-outer", e.wrap),
                            inner: i(".fancybox-inner", e.wrap)
                        }), i.each(["Top", "Right", "Bottom", "Left"], function(t, i) {
                            e.skin.css("padding" + i, g(e.padding[t]))
                        }), s.trigger("onReady"), "inline" === a || "html" === a) {
                        if (!e.content || !e.content.length) return s._error("content")
                    } else if (!n) return s._error("href");
                    "image" === a ? s._loadImage() : "ajax" === a ? s._loadAjax() : "iframe" === a ? s._loadIframe() : s._afterLoad()
                }
            },
            _error: function(t) {
                i.extend(s.coming, {
                    type: "html",
                    autoWidth: !0,
                    autoHeight: !0,
                    minWidth: 0,
                    minHeight: 0,
                    scrolling: "no",
                    hasError: t,
                    content: s.coming.tpl.error
                }), s._afterLoad()
            },
            _loadImage: function() {
                var t = s.imgPreload = new Image;
                t.onload = function() {
                    this.onload = this.onerror = null, s.coming.width = this.width / s.opts.pixelRatio, s.coming.height = this.height / s.opts.pixelRatio, s._afterLoad()
                }, t.onerror = function() {
                    this.onload = this.onerror = null, s._error("image")
                }, t.src = s.coming.href, !0 !== t.complete && s.showLoading()
            },
            _loadAjax: function() {
                var t = s.coming;
                s.showLoading(), s.ajaxLoad = i.ajax(i.extend({}, t.ajax, {
                    url: t.href,
                    error: function(t, e) {
                        s.coming && "abort" !== e ? s._error("ajax", t) : s.hideLoading()
                    },
                    success: function(e, i) {
                        "success" === i && (t.content = e, s._afterLoad())
                    }
                }))
            },
            _loadIframe: function() {
                var t = s.coming,
                    e = i(t.tpl.iframe.replace(/\{rnd\}/g, (new Date).getTime())).attr("scrolling", u ? "auto" : t.iframe.scrolling).attr("src", t.href);
                i(t.wrap).bind("onReset", function() {
                    try {
                        i(this).find("iframe").hide().attr("src", "//about:blank").end().empty()
                    } catch (t) {}
                }), t.iframe.preload && (s.showLoading(), e.one("load", function() {
                    i(this).data("ready", 1), u || i(this).bind("load.fb", s.update), i(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show(), s._afterLoad()
                })), t.content = e.appendTo(t.inner), t.iframe.preload || s._afterLoad()
            },
            _preloadImages: function() {
                var t = s.group,
                    e = s.current,
                    i = t.length,
                    n = e.preload ? Math.min(e.preload, i - 1) : 0,
                    a, r;
                for (r = 1; n >= r; r += 1) a = t[(e.index + r) % i], "image" === a.type && a.href && ((new Image).src = a.href)
            },
            _afterLoad: function() {
                var t = s.coming,
                    e = s.current,
                    n, a, r, o, l;
                if (s.hideLoading(), t && !1 !== s.isActive)
                    if (!1 === s.trigger("afterLoad", t, e)) t.wrap.stop(!0).trigger("onReset").remove(), s.coming = null;
                    else {
                        switch (e && (s.trigger("beforeChange", e), e.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove()), s.unbindEvents(), n = t.content, a = t.type, r = t.scrolling, i.extend(s, {
                            wrap: t.wrap,
                            skin: t.skin,
                            outer: t.outer,
                            inner: t.inner,
                            current: t,
                            previous: e
                        }), o = t.href, a) {
                            case "inline":
                            case "ajax":
                            case "html":
                                t.selector ? n = i("<div>").html(n).find(t.selector) : d(n) && (n.data("fancybox-placeholder") || n.data("fancybox-placeholder", i('<div class="fancybox-placeholder"></div>').insertAfter(n).hide()), n = n.show().detach(), t.wrap.bind("onReset", function() {
                                    i(this).find(n).length && n.hide().replaceAll(n.data("fancybox-placeholder")).data("fancybox-placeholder", !1)
                                }));
                                break;
                            case "image":
                                n = t.tpl.image.replace("{href}", o);
                                break;
                            case "swf":
                                n = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + o + '"></param>', l = "", i.each(t.swf, function(t, e) {
                                    n += '<param name="' + t + '" value="' + e + '"></param>', l += " " + t + '="' + e + '"'
                                }), n += '<embed src="' + o + '" type="application/x-shockwave-flash" width="100%" height="100%"' + l + "></embed></object>"
                        }(!d(n) || !n.parent().is(t.inner)) && t.inner.append(n), s.trigger("beforeShow"), t.inner.css("overflow", "yes" === r ? "scroll" : "no" === r ? "hidden" : r), s._setDimension(), s.reposition(), s.isOpen = !1, s.coming = null, s.bindEvents(), s.isOpened ? e.prevMethod && s.transitions[e.prevMethod]() : i(".fancybox-wrap").not(t.wrap).stop(!0).trigger("onReset").remove(), s.transitions[s.isOpened ? t.nextMethod : t.openMethod](), s._preloadImages()
                    }
            },
            _setDimension: function() {
                var t = s.getViewport(),
                    e = 0,
                    n = !1,
                    a = !1,
                    n = s.wrap,
                    r = s.skin,
                    o = s.inner,
                    l = s.current,
                    a = l.width,
                    c = l.height,
                    u = l.minWidth,
                    d = l.minHeight,
                    h = l.maxWidth,
                    m = l.maxHeight,
                    v = l.scrolling,
                    y = l.scrollOutside ? l.scrollbarWidth : 0,
                    w = l.margin,
                    b = f(w[1] + w[3]),
                    x = f(w[0] + w[2]),
                    S, T, C, k, D, P, E, _, O;
                if (n.add(r).add(o).width("auto").height("auto").removeClass("fancybox-tmp"), w = f(r.outerWidth(!0) - r.width()), S = f(r.outerHeight(!0) - r.height()), T = b + w, C = x + S, k = p(a) ? (t.w - T) * f(a) / 100 : a, D = p(c) ? (t.h - C) * f(c) / 100 : c, "iframe" === l.type) {
                    if (O = l.content, l.autoHeight && 1 === O.data("ready")) try {
                        O[0].contentWindow.document.location && (o.width(k).height(9999), P = O.contents().find("body"), y && P.css("overflow-x", "hidden"), D = P.outerHeight(!0))
                    } catch (M) {}
                } else(l.autoWidth || l.autoHeight) && (o.addClass("fancybox-tmp"), l.autoWidth || o.width(k), l.autoHeight || o.height(D), l.autoWidth && (k = o.width()), l.autoHeight && (D = o.height()), o.removeClass("fancybox-tmp"));
                if (a = f(k), c = f(D), _ = k / D, u = f(p(u) ? f(u, "w") - T : u), h = f(p(h) ? f(h, "w") - T : h), d = f(p(d) ? f(d, "h") - C : d), m = f(p(m) ? f(m, "h") - C : m), P = h, E = m, l.fitToView && (h = Math.min(t.w - T, h), m = Math.min(t.h - C, m)), T = t.w - b, x = t.h - x, l.aspectRatio ? (a > h && (a = h, c = f(a / _)), c > m && (c = m, a = f(c * _)), u > a && (a = u, c = f(a / _)), d > c && (c = d, a = f(c * _))) : (a = Math.max(u, Math.min(a, h)), l.autoHeight && "iframe" !== l.type && (o.width(a), c = o.height()), c = Math.max(d, Math.min(c, m))), l.fitToView)
                    if (o.width(a).height(c), n.width(a + w), t = n.width(), b = n.height(), l.aspectRatio)
                        for (;
                            (t > T || b > x) && a > u && c > d && !(19 < e++);) c = Math.max(d, Math.min(m, c - 10)), a = f(c * _), u > a && (a = u, c = f(a / _)), a > h && (a = h, c = f(a / _)), o.width(a).height(c), n.width(a + w), t = n.width(), b = n.height();
                    else a = Math.max(u, Math.min(a, a - (t - T))), c = Math.max(d, Math.min(c, c - (b - x)));
                y && "auto" === v && D > c && T > a + w + y && (a += y), o.width(a).height(c), n.width(a + w), t = n.width(), b = n.height(), n = (t > T || b > x) && a > u && c > d, a = l.aspectRatio ? P > a && E > c && k > a && D > c : (P > a || E > c) && (k > a || D > c), i.extend(l, {
                    dim: {
                        width: g(t),
                        height: g(b)
                    },
                    origWidth: k,
                    origHeight: D,
                    canShrink: n,
                    canExpand: a,
                    wPadding: w,
                    hPadding: S,
                    wrapSpace: b - r.outerHeight(!0),
                    skinSpace: r.height() - c
                }), !O && l.autoHeight && c > d && m > c && !a && o.height("auto")
            },
            _getPosition: function(t) {
                var e = s.current,
                    i = s.getViewport(),
                    n = e.margin,
                    a = s.wrap.width() + n[1] + n[3],
                    r = s.wrap.height() + n[0] + n[2],
                    n = {
                        position: "absolute",
                        top: n[0],
                        left: n[3]
                    };
                return e.autoCenter && e.fixed && !t && r <= i.h && a <= i.w ? n.position = "fixed" : e.locked || (n.top += i.y, n.left += i.x), n.top = g(Math.max(n.top, n.top + (i.h - r) * e.topRatio)), n.left = g(Math.max(n.left, n.left + (i.w - a) * e.leftRatio)), n
            },
            _afterZoomIn: function() {
                var t = s.current;
                t && (s.isOpen = s.isOpened = !0, s.wrap.css("overflow", "visible").addClass("fancybox-opened"), s.update(), (t.closeClick || t.nextClick && 1 < s.group.length) && s.inner.css("cursor", "pointer").bind("click.fb", function(e) {
                    !i(e.target).is("a") && !i(e.target).parent().is("a") && (e.preventDefault(), s[t.closeClick ? "close" : "next"]())
                }), t.closeBtn && i(t.tpl.closeBtn).appendTo(s.skin).bind("click.fb", function(t) {
                    t.preventDefault(), s.close()
                }), t.arrows && 1 < s.group.length && ((t.loop || 0 < t.index) && i(t.tpl.prev).appendTo(s.outer).bind("click.fb", s.prev), (t.loop || t.index < s.group.length - 1) && i(t.tpl.next).appendTo(s.outer).bind("click.fb", s.next)), s.trigger("afterShow"), t.loop || t.index !== t.group.length - 1 ? s.opts.autoPlay && !s.player.isActive && (s.opts.autoPlay = !1, s.play()) : s.play(!1))
            },
            _afterZoomOut: function(t) {
                t = t || s.current, i(".fancybox-wrap").trigger("onReset").remove(), i.extend(s, {
                    group: {},
                    opts: {},
                    router: !1,
                    current: null,
                    isActive: !1,
                    isOpened: !1,
                    isOpen: !1,
                    isClosing: !1,
                    wrap: null,
                    skin: null,
                    outer: null,
                    inner: null
                }), s.trigger("afterClose", t)
            }
        }), s.transitions = {
            getOrigPosition: function() {
                var t = s.current,
                    e = t.element,
                    i = t.orig,
                    n = {},
                    a = 50,
                    r = 50,
                    o = t.hPadding,
                    l = t.wPadding,
                    c = s.getViewport();
                return !i && t.isDom && e.is(":visible") && (i = e.find("img:first"), i.length || (i = e)), d(i) ? (n = i.offset(), i.is("img") && (a = i.outerWidth(), r = i.outerHeight())) : (n.top = c.y + (c.h - r) * t.topRatio, n.left = c.x + (c.w - a) * t.leftRatio), ("fixed" === s.wrap.css("position") || t.locked) && (n.top -= c.y, n.left -= c.x), n = {
                    top: g(n.top - o * t.topRatio),
                    left: g(n.left - l * t.leftRatio),
                    width: g(a + l),
                    height: g(r + o)
                }
            },
            step: function(t, e) {
                var i, n, a = e.prop;
                n = s.current;
                var r = n.wrapSpace,
                    o = n.skinSpace;
                ("width" === a || "height" === a) && (i = e.end === e.start ? 1 : (t - e.start) / (e.end - e.start), s.isClosing && (i = 1 - i), n = "width" === a ? n.wPadding : n.hPadding, n = t - n, s.skin[a](f("width" === a ? n : n - r * i)), s.inner[a](f("width" === a ? n : n - r * i - o * i)))
            },
            zoomIn: function() {
                var t = s.current,
                    e = t.pos,
                    n = t.openEffect,
                    a = "elastic" === n,
                    r = i.extend({
                        opacity: 1
                    }, e);
                delete r.position, a ? (e = this.getOrigPosition(), t.openOpacity && (e.opacity = .1)) : "fade" === n && (e.opacity = .1), s.wrap.css(e).animate(r, {
                    duration: "none" === n ? 0 : t.openSpeed,
                    easing: t.openEasing,
                    step: a ? this.step : null,
                    complete: s._afterZoomIn
                })
            },
            zoomOut: function() {
                var t = s.current,
                    e = t.closeEffect,
                    i = "elastic" === e,
                    n = {
                        opacity: .1
                    };
                i && (n = this.getOrigPosition(), t.closeOpacity && (n.opacity = .1)), s.wrap.animate(n, {
                    duration: "none" === e ? 0 : t.closeSpeed,
                    easing: t.closeEasing,
                    step: i ? this.step : null,
                    complete: s._afterZoomOut
                })
            },
            changeIn: function() {
                var t = s.current,
                    e = t.nextEffect,
                    i = t.pos,
                    n = {
                        opacity: 1
                    },
                    a = s.direction,
                    r;
                i.opacity = .1, "elastic" === e && (r = "down" === a || "up" === a ? "top" : "left", "down" === a || "right" === a ? (i[r] = g(f(i[r]) - 200), n[r] = "+=200px") : (i[r] = g(f(i[r]) + 200), n[r] = "-=200px")), "none" === e ? s._afterZoomIn() : s.wrap.css(i).animate(n, {
                    duration: t.nextSpeed,
                    easing: t.nextEasing,
                    complete: s._afterZoomIn
                })
            },
            changeOut: function() {
                var t = s.previous,
                    e = t.prevEffect,
                    n = {
                        opacity: .1
                    },
                    a = s.direction;
                "elastic" === e && (n["down" === a || "up" === a ? "top" : "left"] = ("up" === a || "left" === a ? "-" : "+") + "=200px"), t.wrap.animate(n, {
                    duration: "none" === e ? 0 : t.prevSpeed,
                    easing: t.prevEasing,
                    complete: function() {
                        i(this).trigger("onReset").remove()
                    }
                })
            }
        }, s.helpers.overlay = {
            defaults: {
                closeClick: !0,
                speedOut: 200,
                showEarly: !0,
                css: {},
                locked: !u,
                fixed: !0
            },
            overlay: null,
            fixed: !1,
            el: i("html"),
            create: function(t) {
                t = i.extend({}, this.defaults, t), this.overlay && this.close(), this.overlay = i('<div class="fancybox-overlay"></div>').appendTo(s.coming ? s.coming.parent : t.parent), this.fixed = !1, t.fixed && s.defaults.fixed && (this.overlay.addClass("fancybox-overlay-fixed"), this.fixed = !0)
            },
            open: function(t) {
                var e = this;
                t = i.extend({}, this.defaults, t), this.overlay ? this.overlay.unbind(".overlay").width("auto").height("auto") : this.create(t), this.fixed || (r.bind("resize.overlay", i.proxy(this.update, this)), this.update()), t.closeClick && this.overlay.bind("click.overlay", function(t) {
                    return i(t.target).hasClass("fancybox-overlay") ? (s.isActive ? s.close() : e.close(), !1) : void 0
                }), this.overlay.css(t.css).show()
            },
            close: function() {
                var t, e;
                r.unbind("resize.overlay"), this.el.hasClass("fancybox-lock") && (i(".fancybox-margin").removeClass("fancybox-margin"), t = r.scrollTop(), e = r.scrollLeft(), this.el.removeClass("fancybox-lock"), r.scrollTop(t).scrollLeft(e)), i(".fancybox-overlay").remove().hide(), i.extend(this, {
                    overlay: null,
                    fixed: !1
                })
            },
            update: function() {
                var t = "100%",
                    i;
                this.overlay.width(t).height("100%"), l ? (i = Math.max(e.documentElement.offsetWidth, e.body.offsetWidth), o.width() > i && (t = o.width())) : o.width() > r.width() && (t = o.width()), this.overlay.width(t).height(o.height())
            },
            onReady: function(t, e) {
                var n = this.overlay;
                i(".fancybox-overlay").stop(!0, !0), n || this.create(t), t.locked && this.fixed && e.fixed && (n || (this.margin = o.height() > r.height() ? i("html").css("margin-right").replace("px", "") : !1), e.locked = this.overlay.append(e.wrap), e.fixed = !1), !0 === t.showEarly && this.beforeShow.apply(this, arguments)
            },
            beforeShow: function(t, e) {
                var n, a;
                e.locked && (!1 !== this.margin && (i("*").filter(function() {
                    return "fixed" === i(this).css("position") && !i(this).hasClass("fancybox-overlay") && !i(this).hasClass("fancybox-wrap")
                }).addClass("fancybox-margin"), this.el.addClass("fancybox-margin")), n = r.scrollTop(), a = r.scrollLeft(), this.el.addClass("fancybox-lock"), r.scrollTop(n).scrollLeft(a)), this.open(t)
            },
            onUpdate: function() {
                this.fixed || this.update()
            },
            afterClose: function(t) {
                this.overlay && !s.coming && this.overlay.fadeOut(t.speedOut, i.proxy(this.close, this))
            }
        }, s.helpers.title = {
            defaults: {
                type: "float",
                position: "bottom"
            },
            beforeShow: function(t) {
                var e = s.current,
                    n = e.title,
                    a = t.type;
                if (i.isFunction(n) && (n = n.call(e.element, e)), h(n) && "" !== i.trim(n)) {
                    switch (e = i('<div class="fancybox-title fancybox-title-' + a + '-wrap">' + n + "</div>"), a) {
                        case "inside":
                            a = s.skin;
                            break;
                        case "outside":
                            a = s.wrap;
                            break;
                        case "over":
                            a = s.inner;
                            break;
                        default:
                            a = s.skin, e.appendTo("body"), l && e.width(e.width()), e.wrapInner('<span class="child"></span>'), s.current.margin[2] += Math.abs(f(e.css("margin-bottom")))
                    }
                    e["top" === t.position ? "prependTo" : "appendTo"](a)
                }
            }
        }, i.fn.fancybox = function(t) {
            var e, n = i(this),
                a = this.selector || "",
                r = function(r) {
                    var o = i(this).blur(),
                        l = e,
                        c, u;
                    !(r.ctrlKey || r.altKey || r.shiftKey || r.metaKey || o.is(".fancybox-wrap") || (c = t.groupAttr || "data-fancybox-group", u = o.attr(c), u || (c = "rel", u = o.get(0)[c]), u && "" !== u && "nofollow" !== u && (o = a.length ? i(a) : n, o = o.filter("[" + c + '="' + u + '"]'), l = o.index(this)), t.index = l, !1 === s.open(o, t) || !r.preventDefault()))
                };
            return t = t || {}, e = t.index || 0, a && !1 !== t.live ? o.undelegate(a, "click.fb-start").delegate(a + ":not('.fancybox-item, .fancybox-nav')", "click.fb-start", r) : n.unbind("click.fb-start").bind("click.fb-start", r), this.filter("[data-fancybox-start=1]").trigger("click"), this
        }, o.ready(function() {
            var e, r;
            if (i.scrollbarWidth === n && (i.scrollbarWidth = function() {
                    var t = i('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),
                        e = t.children(),
                        e = e.innerWidth() - e.height(99).innerWidth();
                    return t.remove(), e
                }), i.support.fixedPosition === n) {
                e = i.support, r = i('<div style="position:fixed;top:20px;"></div>').appendTo("body");
                var o = 20 === r[0].offsetTop || 15 === r[0].offsetTop;
                r.remove(), e.fixedPosition = o
            }
            i.extend(s.defaults, {
                scrollbarWidth: i.scrollbarWidth(),
                fixed: i.support.fixedPosition,
                parent: i("body")
            }), e = i(t).width(), a.addClass("fancybox-lock-test"), r = i(t).width(), a.removeClass("fancybox-lock-test"), i("<style type='text/css'>.fancybox-margin{margin-right:" + (r - e) + "px;}</style>").appendTo("head")
        })
    }(window, document, jQuery), ! function(t) {
        t.flexslider = function(e, i) {
            var n = t(e);
            n.vars = t.extend({}, t.flexslider.defaults, i);
            var a, r = n.vars.namespace,
                o = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
                s = ("ontouchstart" in window || o || window.DocumentTouch && document instanceof DocumentTouch) && n.vars.touch,
                l = "click touchend MSPointerUp",
                c = "",
                u = "vertical" === n.vars.direction,
                d = n.vars.reverse,
                h = n.vars.itemWidth > 0,
                p = "fade" === n.vars.animation,
                f = "" !== n.vars.asNavFor,
                g = {},
                m = !0;
            t.data(e, "flexslider", n), g = {
                init: function() {
                    n.animating = !1, n.currentSlide = parseInt(n.vars.startAt ? n.vars.startAt : 0, 10), isNaN(n.currentSlide) && (n.currentSlide = 0), n.animatingTo = n.currentSlide, n.atEnd = 0 === n.currentSlide || n.currentSlide === n.last, n.containerSelector = n.vars.selector.substr(0, n.vars.selector.search(" ")), n.slides = t(n.vars.selector, n), n.container = t(n.containerSelector, n), n.count = n.slides.length, n.syncExists = t(n.vars.sync).length > 0, "slide" === n.vars.animation && (n.vars.animation = "swing"), n.prop = u ? "top" : "marginLeft", n.args = {}, n.manualPause = !1, n.stopped = !1, n.started = !1, n.startTimeout = null, n.transitions = !n.vars.video && !p && n.vars.useCSS && function() {
                        var t = document.createElement("div"),
                            e = ["perspectiveProperty", "WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];
                        for (var i in e)
                            if (void 0 !== t.style[e[i]]) return n.pfx = e[i].replace("Perspective", "").toLowerCase(), n.prop = "-" + n.pfx + "-transform", !0;
                        return !1
                    }(), n.ensureAnimationEnd = "", "" !== n.vars.controlsContainer && (n.controlsContainer = t(n.vars.controlsContainer).length > 0 && t(n.vars.controlsContainer)), "" !== n.vars.manualControls && (n.manualControls = t(n.vars.manualControls).length > 0 && t(n.vars.manualControls)), n.vars.randomize && (n.slides.sort(function() {
                        return Math.round(Math.random()) - .5
                    }), n.container.empty().append(n.slides)), n.doMath(), n.setup("init"), n.vars.controlNav && g.controlNav.setup(), n.vars.directionNav && g.directionNav.setup(), n.vars.keyboard && (1 === t(n.containerSelector).length || n.vars.multipleKeyboard) && t(document).bind("keyup", function(t) {
                        var e = t.keyCode;
                        if (!n.animating && (39 === e || 37 === e)) {
                            var i = 39 === e ? n.getTarget("next") : 37 === e ? n.getTarget("prev") : !1;
                            n.flexAnimate(i, n.vars.pauseOnAction)
                        }
                    }), n.vars.mousewheel && n.bind("mousewheel", function(t, e) {
                        t.preventDefault();
                        var i = n.getTarget(0 > e ? "next" : "prev");
                        n.flexAnimate(i, n.vars.pauseOnAction)
                    }), n.vars.pausePlay && g.pausePlay.setup(), n.vars.slideshow && n.vars.pauseInvisible && g.pauseInvisible.init(), n.vars.slideshow && (n.vars.pauseOnHover && n.hover(function() {
                        n.manualPlay || n.manualPause || n.pause()
                    }, function() {
                        n.manualPause || n.manualPlay || n.stopped || n.play()
                    }), n.vars.pauseInvisible && g.pauseInvisible.isHidden() || (n.vars.initDelay > 0 ? n.startTimeout = setTimeout(n.play, n.vars.initDelay) : n.play())), f && g.asNav.setup(), s && n.vars.touch && g.touch(), (!p || p && n.vars.smoothHeight) && t(window).bind("resize orientationchange focus", g.resize), n.find("img").attr("draggable", "false"), setTimeout(function() {
                        n.vars.start(n)
                    }, 200)
                },
                asNav: {
                    setup: function() {
                        n.asNav = !0, n.animatingTo = Math.floor(n.currentSlide / n.move), n.currentItem = n.currentSlide, n.slides.removeClass(r + "active-slide").eq(n.currentItem).addClass(r + "active-slide"), o ? (e._slider = n, n.slides.each(function() {
                            var e = this;
                            e._gesture = new MSGesture, e._gesture.target = e, e.addEventListener("MSPointerDown", function(t) {
                                t.preventDefault(), t.currentTarget._gesture && t.currentTarget._gesture.addPointer(t.pointerId)
                            }, !1), e.addEventListener("MSGestureTap", function(e) {
                                e.preventDefault();
                                var i = t(this),
                                    a = i.index();
                                t(n.vars.asNavFor).data("flexslider").animating || i.hasClass("active") || (n.direction = n.currentItem < a ? "next" : "prev", n.flexAnimate(a, n.vars.pauseOnAction, !1, !0, !0))
                            })
                        })) : n.slides.on(l, function(e) {
                            e.preventDefault();
                            var i = t(this),
                                a = i.index(),
                                o = i.offset().left - t(n).scrollLeft();
                            0 >= o && i.hasClass(r + "active-slide") ? n.flexAnimate(n.getTarget("prev"), !0) : t(n.vars.asNavFor).data("flexslider").animating || i.hasClass(r + "active-slide") || (n.direction = n.currentItem < a ? "next" : "prev", n.flexAnimate(a, n.vars.pauseOnAction, !1, !0, !0))
                        })
                    }
                },
                controlNav: {
                    setup: function() {
                        n.manualControls ? g.controlNav.setupManual() : g.controlNav.setupPaging()
                    },
                    setupPaging: function() {
                        var e, i, a = "thumbnails" === n.vars.controlNav ? "control-thumbs" : "control-paging",
                            o = 1;
                        if (n.controlNavScaffold = t('<ol class="' + r + "control-nav " + r + a + '"></ol>'), n.pagingCount > 1)
                            for (var s = 0; s < n.pagingCount; s++) {
                                if (i = n.slides.eq(s), e = "thumbnails" === n.vars.controlNav ? '<img src="' + i.attr("data-thumb") + '"/>' : "<a>" + o + "</a>", "thumbnails" === n.vars.controlNav && !0 === n.vars.thumbCaptions) {
                                    var u = i.attr("data-thumbcaption");
                                    "" != u && void 0 != u && (e += '<span class="' + r + 'caption">' + u + "</span>")
                                }
                                n.controlNavScaffold.append("<li>" + e + "</li>"), o++
                            }
                        n.controlsContainer ? t(n.controlsContainer).append(n.controlNavScaffold) : n.append(n.controlNavScaffold), g.controlNav.set(), g.controlNav.active(), n.controlNavScaffold.delegate("a, img", l, function(e) {
                            if (e.preventDefault(), "" === c || c === e.type) {
                                var i = t(this),
                                    a = n.controlNav.index(i);
                                i.hasClass(r + "active") || (n.direction = a > n.currentSlide ? "next" : "prev", n.flexAnimate(a, n.vars.pauseOnAction))
                            }
                            "" === c && (c = e.type), g.setToClearWatchedEvent()
                        })
                    },
                    setupManual: function() {
                        n.controlNav = n.manualControls, g.controlNav.active(), n.controlNav.bind(l, function(e) {
                            if (e.preventDefault(), "" === c || c === e.type) {
                                var i = t(this),
                                    a = n.controlNav.index(i);
                                i.hasClass(r + "active") || (n.direction = a > n.currentSlide ? "next" : "prev", n.flexAnimate(a, n.vars.pauseOnAction))
                            }
                            "" === c && (c = e.type), g.setToClearWatchedEvent()
                        })
                    },
                    set: function() {
                        var e = "thumbnails" === n.vars.controlNav ? "img" : "a";
                        n.controlNav = t("." + r + "control-nav li " + e, n.controlsContainer ? n.controlsContainer : n)
                    },
                    active: function() {
                        n.controlNav.removeClass(r + "active").eq(n.animatingTo).addClass(r + "active")
                    },
                    update: function(e, i) {
                        n.pagingCount > 1 && "add" === e ? n.controlNavScaffold.append(t("<li><a>" + n.count + "</a></li>")) : 1 === n.pagingCount ? n.controlNavScaffold.find("li").remove() : n.controlNav.eq(i).closest("li").remove(), g.controlNav.set(), n.pagingCount > 1 && n.pagingCount !== n.controlNav.length ? n.update(i, e) : g.controlNav.active()
                    }
                },
                directionNav: {
                    setup: function() {
                        var e = t('<ul class="' + r + 'direction-nav"><li><a class="' + r + 'prev" href="#">' + n.vars.prevText + '</a></li><li><a class="' + r + 'next" href="#">' + n.vars.nextText + "</a></li></ul>");
                        n.controlsContainer ? (t(n.controlsContainer).append(e), n.directionNav = t("." + r + "direction-nav li a", n.controlsContainer)) : (n.append(e), n.directionNav = t("." + r + "direction-nav li a", n)), g.directionNav.update(), n.directionNav.bind(l, function(e) {
                            e.preventDefault();
                            var i;
                            ("" === c || c === e.type) && (i = n.getTarget(t(this).hasClass(r + "next") ? "next" : "prev"), n.flexAnimate(i, n.vars.pauseOnAction)), "" === c && (c = e.type), g.setToClearWatchedEvent()
                        })
                    },
                    update: function() {
                        var t = r + "disabled";
                        1 === n.pagingCount ? n.directionNav.addClass(t).attr("tabindex", "-1") : n.vars.animationLoop ? n.directionNav.removeClass(t).removeAttr("tabindex") : 0 === n.animatingTo ? n.directionNav.removeClass(t).filter("." + r + "prev").addClass(t).attr("tabindex", "-1") : n.animatingTo === n.last ? n.directionNav.removeClass(t).filter("." + r + "next").addClass(t).attr("tabindex", "-1") : n.directionNav.removeClass(t).removeAttr("tabindex")
                    }
                },
                pausePlay: {
                    setup: function() {
                        var e = t('<div class="' + r + 'pauseplay"><a></a></div>');
                        n.controlsContainer ? (n.controlsContainer.append(e), n.pausePlay = t("." + r + "pauseplay a", n.controlsContainer)) : (n.append(e), n.pausePlay = t("." + r + "pauseplay a", n)), g.pausePlay.update(n.vars.slideshow ? r + "pause" : r + "play"), n.pausePlay.bind(l, function(e) {
                            e.preventDefault(), ("" === c || c === e.type) && (t(this).hasClass(r + "pause") ? (n.manualPause = !0, n.manualPlay = !1, n.pause()) : (n.manualPause = !1, n.manualPlay = !0, n.play())), "" === c && (c = e.type), g.setToClearWatchedEvent()
                        })
                    },
                    update: function(t) {
                        "play" === t ? n.pausePlay.removeClass(r + "pause").addClass(r + "play").html(n.vars.playText) : n.pausePlay.removeClass(r + "play").addClass(r + "pause").html(n.vars.pauseText)
                    }
                },
                touch: function() {
                    function t(t) {
                        n.animating ? t.preventDefault() : (window.navigator.msPointerEnabled || 1 === t.touches.length) && (n.pause(), m = u ? n.h : n.w, y = Number(new Date), b = t.touches[0].pageX, x = t.touches[0].pageY, g = h && d && n.animatingTo === n.last ? 0 : h && d ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : h && n.currentSlide === n.last ? n.limit : h ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide : d ? (n.last - n.currentSlide + n.cloneOffset) * m : (n.currentSlide + n.cloneOffset) * m, c = u ? x : b, f = u ? b : x, e.addEventListener("touchmove", i, !1), e.addEventListener("touchend", a, !1))
                    }

                    function i(t) {
                        b = t.touches[0].pageX, x = t.touches[0].pageY, v = u ? c - x : c - b, w = u ? Math.abs(v) < Math.abs(b - f) : Math.abs(v) < Math.abs(x - f);
                        var e = 500;
                        (!w || Number(new Date) - y > e) && (t.preventDefault(), !p && n.transitions && (n.vars.animationLoop || (v /= 0 === n.currentSlide && 0 > v || n.currentSlide === n.last && v > 0 ? Math.abs(v) / m + 2 : 1), n.setProps(g + v, "setTouch")))
                    }

                    function a() {
                        if (e.removeEventListener("touchmove", i, !1), n.animatingTo === n.currentSlide && !w && null !== v) {
                            var t = d ? -v : v,
                                r = n.getTarget(t > 0 ? "next" : "prev");
                            n.canAdvance(r) && (Number(new Date) - y < 550 && Math.abs(t) > 50 || Math.abs(t) > m / 2) ? n.flexAnimate(r, n.vars.pauseOnAction) : p || n.flexAnimate(n.currentSlide, n.vars.pauseOnAction, !0)
                        }
                        e.removeEventListener("touchend", a, !1), c = null, f = null, v = null, g = null
                    }

                    function r(t) {
                        t.stopPropagation(), n.animating ? t.preventDefault() : (n.pause(), e._gesture.addPointer(t.pointerId), S = 0, m = u ? n.h : n.w, y = Number(new Date), g = h && d && n.animatingTo === n.last ? 0 : h && d ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : h && n.currentSlide === n.last ? n.limit : h ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide : d ? (n.last - n.currentSlide + n.cloneOffset) * m : (n.currentSlide + n.cloneOffset) * m)
                    }

                    function s(t) {
                        t.stopPropagation();
                        var i = t.target._slider;
                        if (i) {
                            var n = -t.translationX,
                                a = -t.translationY;
                            return S += u ? a : n, v = S, w = u ? Math.abs(S) < Math.abs(-n) : Math.abs(S) < Math.abs(-a), t.detail === t.MSGESTURE_FLAG_INERTIA ? void setImmediate(function() {
                                e._gesture.stop()
                            }) : void((!w || Number(new Date) - y > 500) && (t.preventDefault(), !p && i.transitions && (i.vars.animationLoop || (v = S / (0 === i.currentSlide && 0 > S || i.currentSlide === i.last && S > 0 ? Math.abs(S) / m + 2 : 1)), i.setProps(g + v, "setTouch"))))
                        }
                    }

                    function l(t) {
                        t.stopPropagation();
                        var e = t.target._slider;
                        if (e) {
                            if (e.animatingTo === e.currentSlide && !w && null !== v) {
                                var i = d ? -v : v,
                                    n = e.getTarget(i > 0 ? "next" : "prev");
                                e.canAdvance(n) && (Number(new Date) - y < 550 && Math.abs(i) > 50 || Math.abs(i) > m / 2) ? e.flexAnimate(n, e.vars.pauseOnAction) : p || e.flexAnimate(e.currentSlide, e.vars.pauseOnAction, !0)
                            }
                            c = null, f = null, v = null, g = null, S = 0
                        }
                    }
                    var c, f, g, m, v, y, w = !1,
                        b = 0,
                        x = 0,
                        S = 0;
                    o ? (e.style.msTouchAction = "none", e._gesture = new MSGesture, e._gesture.target = e, e.addEventListener("MSPointerDown", r, !1), e._slider = n, e.addEventListener("MSGestureChange", s, !1), e.addEventListener("MSGestureEnd", l, !1)) : e.addEventListener("touchstart", t, !1)
                },
                resize: function() {
                    !n.animating && n.is(":visible") && (h || n.doMath(), p ? g.smoothHeight() : h ? (n.slides.width(n.computedW), n.update(n.pagingCount), n.setProps()) : u ? (n.viewport.height(n.h), n.setProps(n.h, "setTotal")) : (n.vars.smoothHeight && g.smoothHeight(), n.newSlides.width(n.computedW), n.setProps(n.computedW, "setTotal")))
                },
                smoothHeight: function(t) {
                    if (!u || p) {
                        var e = p ? n : n.viewport;
                        t ? e.animate({
                            height: n.slides.eq(n.animatingTo).height()
                        }, t) : e.height(n.slides.eq(n.animatingTo).height())
                    }
                },
                sync: function(e) {
                    var i = t(n.vars.sync).data("flexslider"),
                        a = n.animatingTo;
                    switch (e) {
                        case "animate":
                            i.flexAnimate(a, n.vars.pauseOnAction, !1, !0);
                            break;
                        case "play":
                            i.playing || i.asNav || i.play();
                            break;
                        case "pause":
                            i.pause()
                    }
                },
                uniqueID: function(e) {
                    return e.find("[id]").each(function() {
                        var e = t(this);
                        e.attr("id", e.attr("id") + "_clone")
                    }), e
                },
                pauseInvisible: {
                    visProp: null,
                    init: function() {
                        var t = ["webkit", "moz", "ms", "o"];
                        if ("hidden" in document) return "hidden";
                        for (var e = 0; e < t.length; e++) t[e] + "Hidden" in document && (g.pauseInvisible.visProp = t[e] + "Hidden");
                        if (g.pauseInvisible.visProp) {
                            var i = g.pauseInvisible.visProp.replace(/[H|h]idden/, "") + "visibilitychange";
                            document.addEventListener(i, function() {
                                g.pauseInvisible.isHidden() ? n.startTimeout ? clearTimeout(n.startTimeout) : n.pause() : n.started ? n.play() : n.vars.initDelay > 0 ? setTimeout(n.play, n.vars.initDelay) : n.play()
                            })
                        }
                    },
                    isHidden: function() {
                        return document[g.pauseInvisible.visProp] || !1
                    }
                },
                setToClearWatchedEvent: function() {
                    clearTimeout(a), a = setTimeout(function() {
                        c = ""
                    }, 3e3)
                }
            }, n.flexAnimate = function(e, i, a, o, l) {
                if (n.vars.animationLoop || e === n.currentSlide || (n.direction = e > n.currentSlide ? "next" : "prev"), f && 1 === n.pagingCount && (n.direction = n.currentItem < e ? "next" : "prev"), !n.animating && (n.canAdvance(e, l) || a) && n.is(":visible")) {
                    if (f && o) {
                        var c = t(n.vars.asNavFor).data("flexslider");
                        if (n.atEnd = 0 === e || e === n.count - 1, c.flexAnimate(e, !0, !1, !0, l), n.direction = n.currentItem < e ? "next" : "prev", c.direction = n.direction, Math.ceil((e + 1) / n.visible) - 1 === n.currentSlide || 0 === e) return n.currentItem = e, n.slides.removeClass(r + "active-slide").eq(e).addClass(r + "active-slide"), !1;
                        n.currentItem = e, n.slides.removeClass(r + "active-slide").eq(e).addClass(r + "active-slide"), e = Math.floor(e / n.visible)
                    }
                    if (n.animating = !0, n.animatingTo = e, i && n.pause(), n.vars.before(n), n.syncExists && !l && g.sync("animate"), n.vars.controlNav && g.controlNav.active(), h || n.slides.removeClass(r + "active-slide").eq(e).addClass(r + "active-slide"), n.atEnd = 0 === e || e === n.last, n.vars.directionNav && g.directionNav.update(), e === n.last && (n.vars.end(n), n.vars.animationLoop || n.pause()), p) s ? (n.slides.eq(n.currentSlide).css({
                        opacity: 0,
                        zIndex: 1
                    }), n.slides.eq(e).css({
                        opacity: 1,
                        zIndex: 2
                    }), n.wrapup(w)) : (n.slides.eq(n.currentSlide).css({
                        zIndex: 1
                    }).animate({
                        opacity: 0
                    }, n.vars.animationSpeed, n.vars.easing), n.slides.eq(e).css({
                        zIndex: 2
                    }).animate({
                        opacity: 1
                    }, n.vars.animationSpeed, n.vars.easing, n.wrapup));
                    else {
                        var m, v, y, w = u ? n.slides.filter(":first").height() : n.computedW;
                        h ? (m = n.vars.itemMargin, y = (n.itemW + m) * n.move * n.animatingTo, v = y > n.limit && 1 !== n.visible ? n.limit : y) : v = 0 === n.currentSlide && e === n.count - 1 && n.vars.animationLoop && "next" !== n.direction ? d ? (n.count + n.cloneOffset) * w : 0 : n.currentSlide === n.last && 0 === e && n.vars.animationLoop && "prev" !== n.direction ? d ? 0 : (n.count + 1) * w : d ? (n.count - 1 - e + n.cloneOffset) * w : (e + n.cloneOffset) * w, n.setProps(v, "", n.vars.animationSpeed), n.transitions ? (n.vars.animationLoop && n.atEnd || (n.animating = !1, n.currentSlide = n.animatingTo), n.container.unbind("webkitTransitionEnd transitionend"), n.container.bind("webkitTransitionEnd transitionend", function() {
                            clearTimeout(n.ensureAnimationEnd), n.wrapup(w)
                        }), clearTimeout(n.ensureAnimationEnd), n.ensureAnimationEnd = setTimeout(function() {
                            n.wrapup(w)
                        }, n.vars.animationSpeed + 100)) : n.container.animate(n.args, n.vars.animationSpeed, n.vars.easing, function() {
                            n.wrapup(w)
                        })
                    }
                    n.vars.smoothHeight && g.smoothHeight(n.vars.animationSpeed)
                }
            }, n.wrapup = function(t) {
                p || h || (0 === n.currentSlide && n.animatingTo === n.last && n.vars.animationLoop ? n.setProps(t, "jumpEnd") : n.currentSlide === n.last && 0 === n.animatingTo && n.vars.animationLoop && n.setProps(t, "jumpStart")), n.animating = !1, n.currentSlide = n.animatingTo, n.vars.after(n)
            }, n.animateSlides = function() {
                !n.animating && m && n.flexAnimate(n.getTarget("next"))
            }, n.pause = function() {
                clearInterval(n.animatedSlides), n.animatedSlides = null, n.playing = !1, n.vars.pausePlay && g.pausePlay.update("play"), n.syncExists && g.sync("pause")
            }, n.play = function() {
                n.playing && clearInterval(n.animatedSlides), n.animatedSlides = n.animatedSlides || setInterval(n.animateSlides, n.vars.slideshowSpeed), n.started = n.playing = !0, n.vars.pausePlay && g.pausePlay.update("pause"), n.syncExists && g.sync("play")
            }, n.stop = function() {
                n.pause(), n.stopped = !0
            }, n.canAdvance = function(t, e) {
                var i = f ? n.pagingCount - 1 : n.last;
                return e ? !0 : f && n.currentItem === n.count - 1 && 0 === t && "prev" === n.direction ? !0 : f && 0 === n.currentItem && t === n.pagingCount - 1 && "next" !== n.direction ? !1 : t !== n.currentSlide || f ? n.vars.animationLoop ? !0 : n.atEnd && 0 === n.currentSlide && t === i && "next" !== n.direction ? !1 : n.atEnd && n.currentSlide === i && 0 === t && "next" === n.direction ? !1 : !0 : !1
            }, n.getTarget = function(t) {
                return n.direction = t, "next" === t ? n.currentSlide === n.last ? 0 : n.currentSlide + 1 : 0 === n.currentSlide ? n.last : n.currentSlide - 1
            }, n.setProps = function(t, e, i) {
                var a = function() {
                    var i = t ? t : (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo,
                        a = function() {
                            if (h) return "setTouch" === e ? t : d && n.animatingTo === n.last ? 0 : d ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : n.animatingTo === n.last ? n.limit : i;
                            switch (e) {
                                case "setTotal":
                                    return d ? (n.count - 1 - n.currentSlide + n.cloneOffset) * t : (n.currentSlide + n.cloneOffset) * t;
                                case "setTouch":
                                    return d ? t : t;
                                case "jumpEnd":
                                    return d ? t : n.count * t;
                                case "jumpStart":
                                    return d ? n.count * t : t;
                                default:
                                    return t
                            }
                        }();
                    return -1 * a + "px"
                }();
                n.transitions && (a = u ? "translate3d(0," + a + ",0)" : "translate3d(" + a + ",0,0)", i = void 0 !== i ? i / 1e3 + "s" : "0s", n.container.css("-" + n.pfx + "-transition-duration", i), n.container.css("transition-duration", i)), n.args[n.prop] = a, (n.transitions || void 0 === i) && n.container.css(n.args), n.container.css("transform", a)
            }, n.setup = function(e) {
                if (p) n.slides.css({
                    width: "100%",
                    "float": "left",
                    marginRight: "-100%",
                    position: "relative"
                }), "init" === e && (s ? n.slides.css({
                    opacity: 0,
                    display: "block",
                    webkitTransition: "opacity " + n.vars.animationSpeed / 1e3 + "s ease",
                    zIndex: 1
                }).eq(n.currentSlide).css({
                    opacity: 1,
                    zIndex: 2
                }) : n.slides.css({
                    opacity: 0,
                    display: "block",
                    zIndex: 1
                }).eq(n.currentSlide).css({
                    zIndex: 2
                }).animate({
                    opacity: 1
                }, n.vars.animationSpeed, n.vars.easing)), n.vars.smoothHeight && g.smoothHeight();
                else {
                    var i, a;
                    "init" === e && (n.viewport = t('<div class="' + r + 'viewport"></div>').css({
                        overflow: "hidden",
                        position: "relative"
                    }).appendTo(n).append(n.container), n.cloneCount = 0, n.cloneOffset = 0, d && (a = t.makeArray(n.slides).reverse(), n.slides = t(a), n.container.empty().append(n.slides))), n.vars.animationLoop && !h && (n.cloneCount = 2, n.cloneOffset = 1, "init" !== e && n.container.find(".clone").remove(), g.uniqueID(n.slides.first().clone().addClass("clone").attr("aria-hidden", "true")).appendTo(n.container), g.uniqueID(n.slides.last().clone().addClass("clone").attr("aria-hidden", "true")).prependTo(n.container)), n.newSlides = t(n.vars.selector, n), i = d ? n.count - 1 - n.currentSlide + n.cloneOffset : n.currentSlide + n.cloneOffset, u && !h ? (n.container.height(200 * (n.count + n.cloneCount) + "%").css("position", "absolute").width("100%"), setTimeout(function() {
                        n.newSlides.css({
                            display: "block"
                        }), n.doMath(), n.viewport.height(n.h), n.setProps(i * n.h, "init")
                    }, "init" === e ? 100 : 0)) : (n.container.width(200 * (n.count + n.cloneCount) + "%"), n.setProps(i * n.computedW, "init"), setTimeout(function() {
                        n.doMath(), n.newSlides.css({
                            width: n.computedW,
                            "float": "left",
                            display: "block"
                        }), n.vars.smoothHeight && g.smoothHeight()
                    }, "init" === e ? 100 : 0))
                }
                h || n.slides.removeClass(r + "active-slide").eq(n.currentSlide).addClass(r + "active-slide"), n.vars.init(n)
            }, n.doMath = function() {
                var t = n.slides.first(),
                    e = n.vars.itemMargin,
                    i = n.vars.minItems,
                    a = n.vars.maxItems;
                n.w = void 0 === n.viewport ? n.width() : n.viewport.width(), n.h = t.height(), n.boxPadding = t.outerWidth() - t.width(), h ? (n.itemT = n.vars.itemWidth + e, n.minW = i ? i * n.itemT : n.w, n.maxW = a ? a * n.itemT - e : n.w, n.itemW = n.minW > n.w ? (n.w - e * (i - 1)) / i : n.maxW < n.w ? (n.w - e * (a - 1)) / a : n.vars.itemWidth > n.w ? n.w : n.vars.itemWidth, n.visible = Math.floor(n.w / n.itemW), n.move = n.vars.move > 0 && n.vars.move < n.visible ? n.vars.move : n.visible, n.pagingCount = Math.ceil((n.count - n.visible) / n.move + 1), n.last = n.pagingCount - 1, n.limit = 1 === n.pagingCount ? 0 : n.vars.itemWidth > n.w ? n.itemW * (n.count - 1) + e * (n.count - 1) : (n.itemW + e) * n.count - n.w - e) : (n.itemW = n.w, n.pagingCount = n.count, n.last = n.count - 1), n.computedW = n.itemW - n.boxPadding
            }, n.update = function(t, e) {
                n.doMath(), h || (t < n.currentSlide ? n.currentSlide += 1 : t <= n.currentSlide && 0 !== t && (n.currentSlide -= 1), n.animatingTo = n.currentSlide), n.vars.controlNav && !n.manualControls && ("add" === e && !h || n.pagingCount > n.controlNav.length ? g.controlNav.update("add") : ("remove" === e && !h || n.pagingCount < n.controlNav.length) && (h && n.currentSlide > n.last && (n.currentSlide -= 1, n.animatingTo -= 1), g.controlNav.update("remove", n.last))), n.vars.directionNav && g.directionNav.update()
            }, n.addSlide = function(e, i) {
                var a = t(e);
                n.count += 1, n.last = n.count - 1, u && d ? void 0 !== i ? n.slides.eq(n.count - i).after(a) : n.container.prepend(a) : void 0 !== i ? n.slides.eq(i).before(a) : n.container.append(a), n.update(i, "add"), n.slides = t(n.vars.selector + ":not(.clone)", n), n.setup(), n.vars.added(n)
            }, n.removeSlide = function(e) {
                var i = isNaN(e) ? n.slides.index(t(e)) : e;
                n.count -= 1, n.last = n.count - 1, isNaN(e) ? t(e, n.slides).remove() : u && d ? n.slides.eq(n.last).remove() : n.slides.eq(e).remove(), n.doMath(), n.update(i, "remove"), n.slides = t(n.vars.selector + ":not(.clone)", n), n.setup(), n.vars.removed(n)
            }, g.init()
        }, t(window).blur(function() {
            focused = !1
        }).focus(function() {
            focused = !0
        }), t.flexslider.defaults = {
            namespace: "flex-",
            selector: ".slides > li",
            animation: "fade",
            easing: "swing",
            direction: "horizontal",
            reverse: !1,
            animationLoop: !0,
            smoothHeight: !1,
            startAt: 0,
            slideshow: !0,
            slideshowSpeed: 7e3,
            animationSpeed: 600,
            initDelay: 0,
            randomize: !1,
            thumbCaptions: !1,
            pauseOnAction: !0,
            pauseOnHover: !1,
            pauseInvisible: !0,
            useCSS: !0,
            touch: !0,
            video: !1,
            controlNav: !0,
            directionNav: !0,
            prevText: "Previous",
            nextText: "Next",
            keyboard: !0,
            multipleKeyboard: !1,
            mousewheel: !1,
            pausePlay: !1,
            pauseText: "Pause",
            playText: "Play",
            controlsContainer: "",
            manualControls: "",
            sync: "",
            asNavFor: "",
            itemWidth: 0,
            itemMargin: 0,
            minItems: 1,
            maxItems: 0,
            move: 0,
            allowOneSlide: !0,
            start: function() {},
            before: function() {},
            after: function() {},
            end: function() {},
            added: function() {},
            removed: function() {},
            init: function() {}
        }, t.fn.flexslider = function(e) {
            if (void 0 === e && (e = {}), "object" == typeof e) return this.each(function() {
                var i = t(this),
                    n = e.selector ? e.selector : ".slides > li",
                    a = i.find(n);
                1 === a.length && e.allowOneSlide === !0 || 0 === a.length ? (a.fadeIn(400), e.start && e.start(i)) : void 0 === i.data("flexslider") && new t.flexslider(this, e)
            });
            var i = t(this).data("flexslider");
            switch (e) {
                case "play":
                    i.play();
                    break;
                case "pause":
                    i.pause();
                    break;
                case "stop":
                    i.stop();
                    break;
                case "next":
                    i.flexAnimate(i.getTarget("next"), !0);
                    break;
                case "prev":
                case "previous":
                    i.flexAnimate(i.getTarget("prev"), !0);
                    break;
                default:
                    "number" == typeof e && i.flexAnimate(e, !0)
            }
        }
    }(jQuery),
    function(t) {
        function e() {}

        function i(t) {
            function i(e) {
                e.prototype.option || (e.prototype.option = function(e) {
                    t.isPlainObject(e) && (this.options = t.extend(!0, this.options, e))
                })
            }

            function a(e, i) {
                t.fn[e] = function(a) {
                    if ("string" == typeof a) {
                        for (var o = n.call(arguments, 1), s = 0, l = this.length; l > s; s++) {
                            var c = this[s],
                                u = t.data(c, e);
                            if (u)
                                if (t.isFunction(u[a]) && "_" !== a.charAt(0)) {
                                    var d = u[a].apply(u, o);
                                    if (void 0 !== d) return d
                                } else r("no such method '" + a + "' for " + e + " instance");
                            else r("cannot call methods on " + e + " prior to initialization; attempted to call '" + a + "'")
                        }
                        return this
                    }
                    return this.each(function() {
                        var n = t.data(this, e);
                        n ? (n.option(a), n._init()) : (n = new i(this, a), t.data(this, e, n))
                    })
                }
            }
            if (t) {
                var r = "undefined" == typeof console ? e : function(t) {
                    console.error(t)
                };
                return t.bridget = function(t, e) {
                    i(e), a(t, e)
                }, t.bridget
            }
        }
        var n = Array.prototype.slice;
        "function" == typeof define && define.amd ? define("jquery-bridget/jquery.bridget", ["jquery"], i) : i(t.jQuery)
    }(window),
    function(t) {
        function e(t) {
            return RegExp("(^|\\s+)" + t + "(\\s+|$)")
        }

        function i(t, e) {
            var i = n(t, e) ? r : a;
            i(t, e)
        }
        var n, a, r;
        "classList" in document.documentElement ? (n = function(t, e) {
            return t.classList.contains(e)
        }, a = function(t, e) {
            t.classList.add(e)
        }, r = function(t, e) {
            t.classList.remove(e)
        }) : (n = function(t, i) {
            return e(i).test(t.className)
        }, a = function(t, e) {
            n(t, e) || (t.className = t.className + " " + e)
        }, r = function(t, i) {
            t.className = t.className.replace(e(i), " ")
        });
        var o = {
            hasClass: n,
            addClass: a,
            removeClass: r,
            toggleClass: i,
            has: n,
            add: a,
            remove: r,
            toggle: i
        };
        "function" == typeof define && define.amd ? define("classie/classie", o) : t.classie = o
    }(window),
    function(t) {
        function e(t) {
            if (t) {
                if ("string" == typeof n[t]) return t;
                t = t.charAt(0).toUpperCase() + t.slice(1);
                for (var e, a = 0, r = i.length; r > a; a++)
                    if (e = i[a] + t, "string" == typeof n[e]) return e
            }
        }
        var i = "Webkit Moz ms Ms O".split(" "),
            n = document.documentElement.style;
        "function" == typeof define && define.amd ? define("get-style-property/get-style-property", [], function() {
            return e
        }) : "object" == typeof exports ? module.exports = e : t.getStyleProperty = e
    }(window),
    function(t) {
        function e(t) {
            var e = parseFloat(t),
                i = -1 === t.indexOf("%") && !isNaN(e);
            return i && e
        }

        function i() {
            for (var t = {
                    width: 0,
                    height: 0,
                    innerWidth: 0,
                    innerHeight: 0,
                    outerWidth: 0,
                    outerHeight: 0
                }, e = 0, i = o.length; i > e; e++) {
                var n = o[e];
                t[n] = 0
            }
            return t
        }

        function n(t) {
            function n(t) {
                if ("string" == typeof t && (t = document.querySelector(t)), t && "object" == typeof t && t.nodeType) {
                    var n = r(t);
                    if ("none" === n.display) return i();
                    var a = {};
                    a.width = t.offsetWidth, a.height = t.offsetHeight;
                    for (var u = a.isBorderBox = !(!c || !n[c] || "border-box" !== n[c]), d = 0, h = o.length; h > d; d++) {
                        var p = o[d],
                            f = n[p];
                        f = s(t, f);
                        var g = parseFloat(f);
                        a[p] = isNaN(g) ? 0 : g
                    }
                    var m = a.paddingLeft + a.paddingRight,
                        v = a.paddingTop + a.paddingBottom,
                        y = a.marginLeft + a.marginRight,
                        w = a.marginTop + a.marginBottom,
                        b = a.borderLeftWidth + a.borderRightWidth,
                        x = a.borderTopWidth + a.borderBottomWidth,
                        S = u && l,
                        T = e(n.width);
                    T !== !1 && (a.width = T + (S ? 0 : m + b));
                    var C = e(n.height);
                    return C !== !1 && (a.height = C + (S ? 0 : v + x)), a.innerWidth = a.width - (m + b), a.innerHeight = a.height - (v + x), a.outerWidth = a.width + y, a.outerHeight = a.height + w, a
                }
            }

            function s(t, e) {
                if (a || -1 === e.indexOf("%")) return e;
                var i = t.style,
                    n = i.left,
                    r = t.runtimeStyle,
                    o = r && r.left;
                return o && (r.left = t.currentStyle.left), i.left = e, e = i.pixelLeft, i.left = n, o && (r.left = o), e
            }
            var l, c = t("boxSizing");
            return function() {
                if (c) {
                    var t = document.createElement("div");
                    t.style.width = "200px", t.style.padding = "1px 2px 3px 4px", t.style.borderStyle = "solid", t.style.borderWidth = "1px 2px 3px 4px", t.style[c] = "border-box";
                    var i = document.body || document.documentElement;
                    i.appendChild(t);
                    var n = r(t);
                    l = 200 === e(n.width), i.removeChild(t)
                }
            }(), n
        }
        var a = t.getComputedStyle,
            r = a ? function(t) {
                return a(t, null)
            } : function(t) {
                return t.currentStyle
            },
            o = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"];
        "function" == typeof define && define.amd ? define("get-size/get-size", ["get-style-property/get-style-property"], n) : "object" == typeof exports ? module.exports = n(require("get-style-property")) : t.getSize = n(t.getStyleProperty)
    }(window),
    function(t) {
        function e(e) {
            var i = t.event;
            return i.target = i.target || i.srcElement || e, i
        }
        var i = document.documentElement,
            n = function() {};
        i.addEventListener ? n = function(t, e, i) {
            t.addEventListener(e, i, !1)
        } : i.attachEvent && (n = function(t, i, n) {
            t[i + n] = n.handleEvent ? function() {
                var i = e(t);
                n.handleEvent.call(n, i)
            } : function() {
                var i = e(t);
                n.call(t, i)
            }, t.attachEvent("on" + i, t[i + n])
        });
        var a = function() {};
        i.removeEventListener ? a = function(t, e, i) {
            t.removeEventListener(e, i, !1)
        } : i.detachEvent && (a = function(t, e, i) {
            t.detachEvent("on" + e, t[e + i]);
            try {
                delete t[e + i]
            } catch (n) {
                t[e + i] = void 0
            }
        });
        var r = {
            bind: n,
            unbind: a
        };
        "function" == typeof define && define.amd ? define("eventie/eventie", r) : "object" == typeof exports ? module.exports = r : t.eventie = r
    }(this),
    function(t) {
        function e(t) {
            "function" == typeof t && (e.isReady ? t() : r.push(t))
        }

        function i(t) {
            var i = "readystatechange" === t.type && "complete" !== a.readyState;
            if (!e.isReady && !i) {
                e.isReady = !0;
                for (var n = 0, o = r.length; o > n; n++) {
                    var s = r[n];
                    s()
                }
            }
        }

        function n(n) {
            return n.bind(a, "DOMContentLoaded", i), n.bind(a, "readystatechange", i), n.bind(t, "load", i), e
        }
        var a = t.document,
            r = [];
        e.isReady = !1, "function" == typeof define && define.amd ? (e.isReady = "function" == typeof requirejs, define("doc-ready/doc-ready", ["eventie/eventie"], n)) : t.docReady = n(t.eventie)
    }(this),
    function() {
        function t() {}

        function e(t, e) {
            for (var i = t.length; i--;)
                if (t[i].listener === e) return i;
            return -1
        }

        function i(t) {
            return function() {
                return this[t].apply(this, arguments)
            }
        }
        var n = t.prototype,
            a = this,
            r = a.EventEmitter;
        n.getListeners = function(t) {
            var e, i, n = this._getEvents();
            if (t instanceof RegExp) {
                e = {};
                for (i in n) n.hasOwnProperty(i) && t.test(i) && (e[i] = n[i])
            } else e = n[t] || (n[t] = []);
            return e
        }, n.flattenListeners = function(t) {
            var e, i = [];
            for (e = 0; t.length > e; e += 1) i.push(t[e].listener);
            return i
        }, n.getListenersAsObject = function(t) {
            var e, i = this.getListeners(t);
            return i instanceof Array && (e = {}, e[t] = i), e || i
        }, n.addListener = function(t, i) {
            var n, a = this.getListenersAsObject(t),
                r = "object" == typeof i;
            for (n in a) a.hasOwnProperty(n) && -1 === e(a[n], i) && a[n].push(r ? i : {
                listener: i,
                once: !1
            });
            return this
        }, n.on = i("addListener"), n.addOnceListener = function(t, e) {
            return this.addListener(t, {
                listener: e,
                once: !0
            })
        }, n.once = i("addOnceListener"), n.defineEvent = function(t) {
            return this.getListeners(t), this
        }, n.defineEvents = function(t) {
            for (var e = 0; t.length > e; e += 1) this.defineEvent(t[e]);
            return this
        }, n.removeListener = function(t, i) {
            var n, a, r = this.getListenersAsObject(t);
            for (a in r) r.hasOwnProperty(a) && (n = e(r[a], i), -1 !== n && r[a].splice(n, 1));
            return this
        }, n.off = i("removeListener"), n.addListeners = function(t, e) {
            return this.manipulateListeners(!1, t, e)
        }, n.removeListeners = function(t, e) {
            return this.manipulateListeners(!0, t, e)
        }, n.manipulateListeners = function(t, e, i) {
            var n, a, r = t ? this.removeListener : this.addListener,
                o = t ? this.removeListeners : this.addListeners;
            if ("object" != typeof e || e instanceof RegExp)
                for (n = i.length; n--;) r.call(this, e, i[n]);
            else
                for (n in e) e.hasOwnProperty(n) && (a = e[n]) && ("function" == typeof a ? r.call(this, n, a) : o.call(this, n, a));
            return this
        }, n.removeEvent = function(t) {
            var e, i = typeof t,
                n = this._getEvents();
            if ("string" === i) delete n[t];
            else if (t instanceof RegExp)
                for (e in n) n.hasOwnProperty(e) && t.test(e) && delete n[e];
            else delete this._events;
            return this
        }, n.removeAllListeners = i("removeEvent"), n.emitEvent = function(t, e) {
            var i, n, a, r, o = this.getListenersAsObject(t);
            for (a in o)
                if (o.hasOwnProperty(a))
                    for (n = o[a].length; n--;) i = o[a][n], i.once === !0 && this.removeListener(t, i.listener), r = i.listener.apply(this, e || []), r === this._getOnceReturnValue() && this.removeListener(t, i.listener);
            return this
        }, n.trigger = i("emitEvent"), n.emit = function(t) {
            var e = Array.prototype.slice.call(arguments, 1);
            return this.emitEvent(t, e)
        }, n.setOnceReturnValue = function(t) {
            return this._onceReturnValue = t, this
        }, n._getOnceReturnValue = function() {
            return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0
        }, n._getEvents = function() {
            return this._events || (this._events = {})
        }, t.noConflict = function() {
            return a.EventEmitter = r, t
        }, "function" == typeof define && define.amd ? define("eventEmitter/EventEmitter", [], function() {
            return t
        }) : "object" == typeof module && module.exports ? module.exports = t : this.EventEmitter = t
    }.call(this),
    function(t, e) {
        function i(t, e) {
            return t[s](e)
        }

        function n(t) {
            if (!t.parentNode) {
                var e = document.createDocumentFragment();
                e.appendChild(t)
            }
        }

        function a(t, e) {
            n(t);
            for (var i = t.parentNode.querySelectorAll(e), a = 0, r = i.length; r > a; a++)
                if (i[a] === t) return !0;
            return !1
        }

        function r(t, e) {
            return n(t), i(t, e)
        }
        var o, s = function() {
            if (e.matchesSelector) return "matchesSelector";
            for (var t = ["webkit", "moz", "ms", "o"], i = 0, n = t.length; n > i; i++) {
                var a = t[i],
                    r = a + "MatchesSelector";
                if (e[r]) return r
            }
        }();
        if (s) {
            var l = document.createElement("div"),
                c = i(l, "div");
            o = c ? i : r
        } else o = a;
        "function" == typeof define && define.amd ? define("matches-selector/matches-selector", [], function() {
            return o
        }) : window.matchesSelector = o
    }(this, Element.prototype),
    function(t) {
        function e(t, e) {
            for (var i in e) t[i] = e[i];
            return t
        }

        function i(t) {
            for (var e in t) return !1;
            return e = null, !0
        }

        function n(t) {
            return t.replace(/([A-Z])/g, function(t) {
                return "-" + t.toLowerCase()
            })
        }

        function a(t, a, r) {
            function s(t, e) {
                t && (this.element = t, this.layout = e, this.position = {
                    x: 0,
                    y: 0
                }, this._create())
            }
            var l = r("transition"),
                c = r("transform"),
                u = l && c,
                d = !!r("perspective"),
                h = {
                    WebkitTransition: "webkitTransitionEnd",
                    MozTransition: "transitionend",
                    OTransition: "otransitionend",
                    transition: "transitionend"
                }[l],
                p = ["transform", "transition", "transitionDuration", "transitionProperty"],
                f = function() {
                    for (var t = {}, e = 0, i = p.length; i > e; e++) {
                        var n = p[e],
                            a = r(n);
                        a && a !== n && (t[n] = a)
                    }
                    return t
                }();
            e(s.prototype, t.prototype), s.prototype._create = function() {
                this._transn = {
                    ingProperties: {},
                    clean: {},
                    onEnd: {}
                }, this.css({
                    position: "absolute"
                })
            }, s.prototype.handleEvent = function(t) {
                var e = "on" + t.type;
                this[e] && this[e](t)
            }, s.prototype.getSize = function() {
                this.size = a(this.element)
            }, s.prototype.css = function(t) {
                var e = this.element.style;
                for (var i in t) {
                    var n = f[i] || i;
                    e[n] = t[i]
                }
            }, s.prototype.getPosition = function() {
                var t = o(this.element),
                    e = this.layout.options,
                    i = e.isOriginLeft,
                    n = e.isOriginTop,
                    a = parseInt(t[i ? "left" : "right"], 10),
                    r = parseInt(t[n ? "top" : "bottom"], 10);
                a = isNaN(a) ? 0 : a, r = isNaN(r) ? 0 : r;
                var s = this.layout.size;
                a -= i ? s.paddingLeft : s.paddingRight, r -= n ? s.paddingTop : s.paddingBottom, this.position.x = a, this.position.y = r
            }, s.prototype.layoutPosition = function() {
                var t = this.layout.size,
                    e = this.layout.options,
                    i = {};
                e.isOriginLeft ? (i.left = this.position.x + t.paddingLeft + "px", i.right = "") : (i.right = this.position.x + t.paddingRight + "px", i.left = ""), e.isOriginTop ? (i.top = this.position.y + t.paddingTop + "px", i.bottom = "") : (i.bottom = this.position.y + t.paddingBottom + "px", i.top = ""), this.css(i), this.emitEvent("layout", [this])
            };
            var g = d ? function(t, e) {
                return "translate3d(" + t + "px, " + e + "px, 0)"
            } : function(t, e) {
                return "translate(" + t + "px, " + e + "px)"
            };
            s.prototype._transitionTo = function(t, e) {
                this.getPosition();
                var i = this.position.x,
                    n = this.position.y,
                    a = parseInt(t, 10),
                    r = parseInt(e, 10),
                    o = a === this.position.x && r === this.position.y;
                if (this.setPosition(t, e), o && !this.isTransitioning) return void this.layoutPosition();
                var s = t - i,
                    l = e - n,
                    c = {},
                    u = this.layout.options;
                s = u.isOriginLeft ? s : -s, l = u.isOriginTop ? l : -l, c.transform = g(s, l), this.transition({
                    to: c,
                    onTransitionEnd: {
                        transform: this.layoutPosition
                    },
                    isCleaning: !0
                })
            }, s.prototype.goTo = function(t, e) {
                this.setPosition(t, e), this.layoutPosition()
            }, s.prototype.moveTo = u ? s.prototype._transitionTo : s.prototype.goTo, s.prototype.setPosition = function(t, e) {
                this.position.x = parseInt(t, 10), this.position.y = parseInt(e, 10)
            }, s.prototype._nonTransition = function(t) {
                this.css(t.to), t.isCleaning && this._removeStyles(t.to);
                for (var e in t.onTransitionEnd) t.onTransitionEnd[e].call(this)
            }, s.prototype._transition = function(t) {
                if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(t);
                var e = this._transn;
                for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
                for (i in t.to) e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
                if (t.from) {
                    this.css(t.from);
                    var n = this.element.offsetHeight;
                    n = null
                }
                this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0
            };
            var m = c && n(c) + ",opacity";
            s.prototype.enableTransition = function() {
                this.isTransitioning || (this.css({
                    transitionProperty: m,
                    transitionDuration: this.layout.options.transitionDuration
                }), this.element.addEventListener(h, this, !1))
            }, s.prototype.transition = s.prototype[l ? "_transition" : "_nonTransition"], s.prototype.onwebkitTransitionEnd = function(t) {
                this.ontransitionend(t)
            }, s.prototype.onotransitionend = function(t) {
                this.ontransitionend(t)
            };
            var v = {
                "-webkit-transform": "transform",
                "-moz-transform": "transform",
                "-o-transform": "transform"
            };
            s.prototype.ontransitionend = function(t) {
                if (t.target === this.element) {
                    var e = this._transn,
                        n = v[t.propertyName] || t.propertyName;
                    if (delete e.ingProperties[n], i(e.ingProperties) && this.disableTransition(), n in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[n]), n in e.onEnd) {
                        var a = e.onEnd[n];
                        a.call(this), delete e.onEnd[n]
                    }
                    this.emitEvent("transitionEnd", [this])
                }
            }, s.prototype.disableTransition = function() {
                this.removeTransitionStyles(), this.element.removeEventListener(h, this, !1), this.isTransitioning = !1
            }, s.prototype._removeStyles = function(t) {
                var e = {};
                for (var i in t) e[i] = "";
                this.css(e)
            };
            var y = {
                transitionProperty: "",
                transitionDuration: ""
            };
            return s.prototype.removeTransitionStyles = function() {
                this.css(y)
            }, s.prototype.removeElem = function() {
                this.element.parentNode.removeChild(this.element), this.emitEvent("remove", [this])
            }, s.prototype.remove = function() {
                if (!l || !parseFloat(this.layout.options.transitionDuration)) return void this.removeElem();
                var t = this;
                this.on("transitionEnd", function() {
                    return t.removeElem(), !0
                }), this.hide()
            }, s.prototype.reveal = function() {
                delete this.isHidden, this.css({
                    display: ""
                });
                var t = this.layout.options;
                this.transition({
                    from: t.hiddenStyle,
                    to: t.visibleStyle,
                    isCleaning: !0
                })
            }, s.prototype.hide = function() {
                this.isHidden = !0, this.css({
                    display: ""
                });
                var t = this.layout.options;
                this.transition({
                    from: t.visibleStyle,
                    to: t.hiddenStyle,
                    isCleaning: !0,
                    onTransitionEnd: {
                        opacity: function() {
                            this.isHidden && this.css({
                                display: "none"
                            })
                        }
                    }
                })
            }, s.prototype.destroy = function() {
                this.css({
                    position: "",
                    left: "",
                    right: "",
                    top: "",
                    bottom: "",
                    transition: "",
                    transform: ""
                })
            }, s
        }
        var r = document.defaultView,
            o = r && r.getComputedStyle ? function(t) {
                return r.getComputedStyle(t, null)
            } : function(t) {
                return t.currentStyle
            };
        "function" == typeof define && define.amd ? define("outlayer/item", ["eventEmitter/EventEmitter", "get-size/get-size", "get-style-property/get-style-property"], a) : (t.Outlayer = {}, t.Outlayer.Item = a(t.EventEmitter, t.getSize, t.getStyleProperty))
    }(window),
    function(t) {
        function e(t, e) {
            for (var i in e) t[i] = e[i];
            return t
        }

        function i(t) {
            return "[object Array]" === d.call(t)
        }

        function n(t) {
            var e = [];
            if (i(t)) e = t;
            else if (t && "number" == typeof t.length)
                for (var n = 0, a = t.length; a > n; n++) e.push(t[n]);
            else e.push(t);
            return e
        }

        function a(t, e) {
            var i = p(e, t); - 1 !== i && e.splice(i, 1)
        }

        function r(t) {
            return t.replace(/(.)([A-Z])/g, function(t, e, i) {
                return e + "-" + i
            }).toLowerCase()
        }

        function o(i, o, d, p, f, g) {
            function m(t, i) {
                if ("string" == typeof t && (t = s.querySelector(t)), !t || !h(t)) return void(l && l.error("Bad " + this.constructor.namespace + " element: " + t));
                this.element = t, this.options = e({}, this.options), this.option(i);
                var n = ++y;
                this.element.outlayerGUID = n, w[n] = this, this._create(), this.options.isInitLayout && this.layout()
            }

            function v(t, i) {
                t.prototype[i] = e({}, m.prototype[i])
            }
            var y = 0,
                w = {};
            return m.namespace = "outlayer", m.Item = g, m.prototype.options = {
                containerStyle: {
                    position: "relative"
                },
                isInitLayout: !0,
                isOriginLeft: !0,
                isOriginTop: !0,
                isResizeBound: !0,
                transitionDuration: "0.4s",
                hiddenStyle: {
                    opacity: 0,
                    transform: "scale(0.001)"
                },
                visibleStyle: {
                    opacity: 1,
                    transform: "scale(1)"
                }
            }, e(m.prototype, d.prototype), m.prototype.option = function(t) {
                e(this.options, t)
            }, m.prototype._create = function() {
                this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), e(this.element.style, this.options.containerStyle), this.options.isResizeBound && this.bindResize()
            }, m.prototype.reloadItems = function() {
                this.items = this._itemize(this.element.children)
            }, m.prototype._itemize = function(t) {
                for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], a = 0, r = e.length; r > a; a++) {
                    var o = e[a],
                        s = new i(o, this);
                    n.push(s)
                }
                return n
            }, m.prototype._filterFindItemElements = function(t) {
                t = n(t);
                for (var e = this.options.itemSelector, i = [], a = 0, r = t.length; r > a; a++) {
                    var o = t[a];
                    if (h(o))
                        if (e) {
                            f(o, e) && i.push(o);
                            for (var s = o.querySelectorAll(e), l = 0, c = s.length; c > l; l++) i.push(s[l])
                        } else i.push(o)
                }
                return i
            }, m.prototype.getItemElements = function() {
                for (var t = [], e = 0, i = this.items.length; i > e; e++) t.push(this.items[e].element);
                return t
            }, m.prototype.layout = function() {
                this._resetLayout(), this._manageStamps();
                var t = void 0 !== this.options.isLayoutInstant ? this.options.isLayoutInstant : !this._isLayoutInited;
                this.layoutItems(this.items, t), this._isLayoutInited = !0
            }, m.prototype._init = m.prototype.layout, m.prototype._resetLayout = function() {
                this.getSize()
            }, m.prototype.getSize = function() {
                this.size = p(this.element)
            }, m.prototype._getMeasurement = function(t, e) {
                var i, n = this.options[t];
                n ? ("string" == typeof n ? i = this.element.querySelector(n) : h(n) && (i = n), this[t] = i ? p(i)[e] : n) : this[t] = 0
            }, m.prototype.layoutItems = function(t, e) {
                t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout()
            }, m.prototype._getItemsForLayout = function(t) {
                for (var e = [], i = 0, n = t.length; n > i; i++) {
                    var a = t[i];
                    a.isIgnored || e.push(a)
                }
                return e
            }, m.prototype._layoutItems = function(t, e) {
                function i() {
                    n.emitEvent("layoutComplete", [n, t])
                }
                var n = this;
                if (!t || !t.length) return void i();
                this._itemsOn(t, "layout", i);
                for (var a = [], r = 0, o = t.length; o > r; r++) {
                    var s = t[r],
                        l = this._getItemLayoutPosition(s);
                    l.item = s, l.isInstant = e || s.isLayoutInstant, a.push(l)
                }
                this._processLayoutQueue(a)
            }, m.prototype._getItemLayoutPosition = function() {
                return {
                    x: 0,
                    y: 0
                }
            }, m.prototype._processLayoutQueue = function(t) {
                for (var e = 0, i = t.length; i > e; e++) {
                    var n = t[e];
                    this._positionItem(n.item, n.x, n.y, n.isInstant)
                }
            }, m.prototype._positionItem = function(t, e, i, n) {
                n ? t.goTo(e, i) : t.moveTo(e, i)
            }, m.prototype._postLayout = function() {
                var t = this._getContainerSize();
                t && (this._setContainerMeasure(t.width, !0), this._setContainerMeasure(t.height, !1))
            }, m.prototype._getContainerSize = u, m.prototype._setContainerMeasure = function(t, e) {
                if (void 0 !== t) {
                    var i = this.size;
                    i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px"
                }
            }, m.prototype._itemsOn = function(t, e, i) {
                function n() {
                    return a++, a === r && i.call(o), !0
                }
                for (var a = 0, r = t.length, o = this, s = 0, l = t.length; l > s; s++) {
                    var c = t[s];
                    c.on(e, n)
                }
            }, m.prototype.ignore = function(t) {
                var e = this.getItem(t);
                e && (e.isIgnored = !0)
            }, m.prototype.unignore = function(t) {
                var e = this.getItem(t);
                e && delete e.isIgnored
            }, m.prototype.stamp = function(t) {
                if (t = this._find(t)) {
                    this.stamps = this.stamps.concat(t);
                    for (var e = 0, i = t.length; i > e; e++) {
                        var n = t[e];
                        this.ignore(n)
                    }
                }
            }, m.prototype.unstamp = function(t) {
                if (t = this._find(t))
                    for (var e = 0, i = t.length; i > e; e++) {
                        var n = t[e];
                        a(n, this.stamps), this.unignore(n)
                    }
            }, m.prototype._find = function(t) {
                return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), t = n(t)) : void 0
            }, m.prototype._manageStamps = function() {
                if (this.stamps && this.stamps.length) {
                    this._getBoundingRect();
                    for (var t = 0, e = this.stamps.length; e > t; t++) {
                        var i = this.stamps[t];
                        this._manageStamp(i)
                    }
                }
            }, m.prototype._getBoundingRect = function() {
                var t = this.element.getBoundingClientRect(),
                    e = this.size;
                this._boundingRect = {
                    left: t.left + e.paddingLeft + e.borderLeftWidth,
                    top: t.top + e.paddingTop + e.borderTopWidth,
                    right: t.right - (e.paddingRight + e.borderRightWidth),
                    bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
                }
            }, m.prototype._manageStamp = u, m.prototype._getElementOffset = function(t) {
                var e = t.getBoundingClientRect(),
                    i = this._boundingRect,
                    n = p(t),
                    a = {
                        left: e.left - i.left - n.marginLeft,
                        top: e.top - i.top - n.marginTop,
                        right: i.right - e.right - n.marginRight,
                        bottom: i.bottom - e.bottom - n.marginBottom
                    };
                return a
            }, m.prototype.handleEvent = function(t) {
                var e = "on" + t.type;
                this[e] && this[e](t)
            }, m.prototype.bindResize = function() {
                this.isResizeBound || (i.bind(t, "resize", this), this.isResizeBound = !0)
            }, m.prototype.unbindResize = function() {
                i.unbind(t, "resize", this), this.isResizeBound = !1
            }, m.prototype.onresize = function() {
                function t() {
                    e.resize(), delete e.resizeTimeout
                }
                this.resizeTimeout && clearTimeout(this.resizeTimeout);
                var e = this;
                this.resizeTimeout = setTimeout(t, 100)
            }, m.prototype.resize = function() {
                var t = p(this.element),
                    e = this.size && t;
                e && t.innerWidth === this.size.innerWidth || this.layout()
            }, m.prototype.addItems = function(t) {
                var e = this._itemize(t);
                return e.length && (this.items = this.items.concat(e)), e
            }, m.prototype.appended = function(t) {
                var e = this.addItems(t);
                e.length && (this.layoutItems(e, !0), this.reveal(e))
            }, m.prototype.prepended = function(t) {
                var e = this._itemize(t);
                if (e.length) {
                    var i = this.items.slice(0);
                    this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i)
                }
            }, m.prototype.reveal = function(t) {
                var e = t && t.length;
                if (e)
                    for (var i = 0; e > i; i++) {
                        var n = t[i];
                        n.reveal()
                    }
            }, m.prototype.hide = function(t) {
                var e = t && t.length;
                if (e)
                    for (var i = 0; e > i; i++) {
                        var n = t[i];
                        n.hide()
                    }
            }, m.prototype.getItem = function(t) {
                for (var e = 0, i = this.items.length; i > e; e++) {
                    var n = this.items[e];
                    if (n.element === t) return n
                }
            }, m.prototype.getItems = function(t) {
                if (t && t.length) {
                    for (var e = [], i = 0, n = t.length; n > i; i++) {
                        var a = t[i],
                            r = this.getItem(a);
                        r && e.push(r)
                    }
                    return e
                }
            }, m.prototype.remove = function(t) {
                t = n(t);
                var e = this.getItems(t);
                if (e && e.length) {
                    this._itemsOn(e, "remove", function() {
                        this.emitEvent("removeComplete", [this, e])
                    });
                    for (var i = 0, r = e.length; r > i; i++) {
                        var o = e[i];
                        o.remove(), a(o, this.items)
                    }
                }
            }, m.prototype.destroy = function() {
                var t = this.element.style;
                t.height = "", t.position = "", t.width = "";
                for (var e = 0, i = this.items.length; i > e; e++) {
                    var n = this.items[e];
                    n.destroy()
                }
                this.unbindResize(), delete this.element.outlayerGUID, c && c.removeData(this.element, this.constructor.namespace)
            }, m.data = function(t) {
                var e = t && t.outlayerGUID;
                return e && w[e]
            }, m.create = function(t, i) {
                function n() {
                    m.apply(this, arguments)
                }
                return Object.create ? n.prototype = Object.create(m.prototype) : e(n.prototype, m.prototype), n.prototype.constructor = n, v(n, "options"), e(n.prototype.options, i), n.namespace = t, n.data = m.data, n.Item = function() {
                    g.apply(this, arguments)
                }, n.Item.prototype = new g, o(function() {
                    for (var e = r(t), i = s.querySelectorAll(".js-" + e), a = "data-" + e + "-options", o = 0, u = i.length; u > o; o++) {
                        var d, h = i[o],
                            p = h.getAttribute(a);
                        try {
                            d = p && JSON.parse(p)
                        } catch (f) {
                            l && l.error("Error parsing " + a + " on " + h.nodeName.toLowerCase() + (h.id ? "#" + h.id : "") + ": " + f);
                            continue
                        }
                        var g = new n(h, d);
                        c && c.data(h, t, g)
                    }
                }), c && c.bridget && c.bridget(t, n), n
            }, m.Item = g, m
        }
        var s = t.document,
            l = t.console,
            c = t.jQuery,
            u = function() {},
            d = Object.prototype.toString,
            h = "object" == typeof HTMLElement ? function(t) {
                return t instanceof HTMLElement
            } : function(t) {
                return t && "object" == typeof t && 1 === t.nodeType && "string" == typeof t.nodeName
            },
            p = Array.prototype.indexOf ? function(t, e) {
                return t.indexOf(e)
            } : function(t, e) {
                for (var i = 0, n = t.length; n > i; i++)
                    if (t[i] === e) return i;
                return -1
            };
        "function" == typeof define && define.amd ? define("outlayer/outlayer", ["eventie/eventie", "doc-ready/doc-ready", "eventEmitter/EventEmitter", "get-size/get-size", "matches-selector/matches-selector", "./item"], o) : t.Outlayer = o(t.eventie, t.docReady, t.EventEmitter, t.getSize, t.matchesSelector, t.Outlayer.Item)
    }(window),
    function(t) {
        function e() {
            function t(e) {
                for (var i in t.defaults) this[i] = t.defaults[i];
                for (i in e) this[i] = e[i]
            }
            return i.Rect = t, t.defaults = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }, t.prototype.contains = function(t) {
                var e = t.width || 0,
                    i = t.height || 0;
                return this.x <= t.x && this.y <= t.y && this.x + this.width >= t.x + e && this.y + this.height >= t.y + i
            }, t.prototype.overlaps = function(t) {
                var e = this.x + this.width,
                    i = this.y + this.height,
                    n = t.x + t.width,
                    a = t.y + t.height;
                return n > this.x && e > t.x && a > this.y && i > t.y
            }, t.prototype.getMaximalFreeRects = function(e) {
                if (!this.overlaps(e)) return !1;
                var i, n = [],
                    a = this.x + this.width,
                    r = this.y + this.height,
                    o = e.x + e.width,
                    s = e.y + e.height;
                return this.y < e.y && (i = new t({
                    x: this.x,
                    y: this.y,
                    width: this.width,
                    height: e.y - this.y
                }), n.push(i)), a > o && (i = new t({
                    x: o,
                    y: this.y,
                    width: a - o,
                    height: this.height
                }), n.push(i)), r > s && (i = new t({
                    x: this.x,
                    y: s,
                    width: this.width,
                    height: r - s
                }), n.push(i)), this.x < e.x && (i = new t({
                    x: this.x,
                    y: this.y,
                    width: e.x - this.x,
                    height: this.height
                }), n.push(i)), n
            }, t.prototype.canFit = function(t) {
                return this.width >= t.width && this.height >= t.height
            }, t
        }
        var i = t.Packery = function() {};
        "function" == typeof define && define.amd ? define("packery/js/rect", e) : (t.Packery = t.Packery || {}, t.Packery.Rect = e())
    }(window),
    function(t) {
        function e(t) {
            function e(t, e, i) {
                this.width = t || 0, this.height = e || 0, this.sortDirection = i || "downwardLeftToRight", this.reset()
            }
            e.prototype.reset = function() {
                this.spaces = [], this.newSpaces = [];
                var e = new t({
                    x: 0,
                    y: 0,
                    width: this.width,
                    height: this.height
                });
                this.spaces.push(e), this.sorter = i[this.sortDirection] || i.downwardLeftToRight
            }, e.prototype.pack = function(t) {
                for (var e = 0, i = this.spaces.length; i > e; e++) {
                    var n = this.spaces[e];
                    if (n.canFit(t)) {
                        this.placeInSpace(t, n);
                        break
                    }
                }
            }, e.prototype.placeInSpace = function(t, e) {
                t.x = e.x, t.y = e.y, this.placed(t)
            }, e.prototype.placed = function(t) {
                for (var i = [], n = 0, a = this.spaces.length; a > n; n++) {
                    var r = this.spaces[n],
                        o = r.getMaximalFreeRects(t);
                    o ? i.push.apply(i, o) : i.push(r)
                }
                this.spaces = i, e.mergeRects(this.spaces), this.spaces.sort(this.sorter)
            }, e.mergeRects = function(t) {
                for (var e = 0, i = t.length; i > e; e++) {
                    var n = t[e];
                    if (n) {
                        var a = t.slice(0);
                        a.splice(e, 1);
                        for (var r = 0, o = 0, s = a.length; s > o; o++) {
                            var l = a[o],
                                c = e > o ? 0 : 1;
                            n.contains(l) && (t.splice(o + c - r, 1), r++)
                        }
                    }
                }
                return t
            };
            var i = {
                downwardLeftToRight: function(t, e) {
                    return t.y - e.y || t.x - e.x
                },
                rightwardTopToBottom: function(t, e) {
                    return t.x - e.x || t.y - e.y
                }
            };
            return e
        }
        if ("function" == typeof define && define.amd) define("packery/js/packer", ["./rect"], e);
        else {
            var i = t.Packery = t.Packery || {};
            i.Packer = e(i.Rect)
        }
    }(window),
    function(t) {
        function e(t, e, i) {
            var n = t("transform"),
                a = function() {
                    e.Item.apply(this, arguments)
                };
            a.prototype = new e.Item;
            var r = a.prototype._create;
            return a.prototype._create = function() {
                r.call(this), this.rect = new i, this.placeRect = new i
            }, a.prototype.dragStart = function() {
                this.getPosition(), this.removeTransitionStyles(), this.isTransitioning && n && (this.element.style[n] = "none"), this.getSize(), this.isPlacing = !0, this.needsPositioning = !1, this.positionPlaceRect(this.position.x, this.position.y), this.isTransitioning = !1, this.didDrag = !1
            }, a.prototype.dragMove = function(t, e) {
                this.didDrag = !0;
                var i = this.layout.size;
                t -= i.paddingLeft, e -= i.paddingTop, this.positionPlaceRect(t, e)
            }, a.prototype.dragStop = function() {
                this.getPosition();
                var t = this.position.x !== this.placeRect.x,
                    e = this.position.y !== this.placeRect.y;
                this.needsPositioning = t || e, this.didDrag = !1
            }, a.prototype.positionPlaceRect = function(t, e, i) {
                this.placeRect.x = this.getPlaceRectCoord(t, !0), this.placeRect.y = this.getPlaceRectCoord(e, !1, i)
            }, a.prototype.getPlaceRectCoord = function(t, e, i) {
                var n = e ? "Width" : "Height",
                    a = this.size["outer" + n],
                    r = this.layout[e ? "columnWidth" : "rowHeight"],
                    o = this.layout.size["inner" + n];
                e || (o = Math.max(o, this.layout.maxY), this.layout.rowHeight || (o -= this.layout.gutter));
                var s;
                if (r) {
                    r += this.layout.gutter, o += e ? this.layout.gutter : 0, t = Math.round(t / r);
                    var l;
                    l = this.layout.options.isHorizontal ? e ? "ceil" : "floor" : e ? "floor" : "ceil";
                    var c = Math[l](o / r);
                    c -= Math.ceil(a / r), s = c
                } else s = o - a;
                return t = i ? t : Math.min(t, s), t *= r || 1, Math.max(0, t)
            }, a.prototype.copyPlaceRectPosition = function() {
                this.rect.x = this.placeRect.x, this.rect.y = this.placeRect.y
            }, a
        }
        "function" == typeof define && define.amd ? define("packery/js/item", ["get-style-property/get-style-property", "outlayer/outlayer", "./rect"], e) : t.Packery.Item = e(t.getStyleProperty, t.Outlayer, t.Packery.Rect)
    }(window),
    function(t) {
        function e(t, e, i, n, a, r) {
            function o(t, e) {
                return t.position.y - e.position.y || t.position.x - e.position.x
            }

            function s(t, e) {
                return t.position.x - e.position.x || t.position.y - e.position.y
            }
            var l = i.create("packery");
            return l.Item = r, l.prototype._create = function() {
                i.prototype._create.call(this), this.packer = new a, this.stamp(this.options.stamped);
                var t = this;
                this.handleDraggabilly = {
                    dragStart: function(e) {
                        t.itemDragStart(e.element)
                    },
                    dragMove: function(e) {
                        t.itemDragMove(e.element, e.position.x, e.position.y)
                    },
                    dragEnd: function(e) {
                        t.itemDragEnd(e.element)
                    }
                }, this.handleUIDraggable = {
                    start: function(e) {
                        t.itemDragStart(e.currentTarget)
                    },
                    drag: function(e, i) {
                        t.itemDragMove(e.currentTarget, i.position.left, i.position.top)
                    },
                    stop: function(e) {
                        t.itemDragEnd(e.currentTarget)
                    }
                }
            }, l.prototype._resetLayout = function() {
                this.getSize(), this._getMeasurements();
                var t = this.packer;
                this.options.isHorizontal ? (t.width = Number.POSITIVE_INFINITY, t.height = this.size.innerHeight + this.gutter, t.sortDirection = "rightwardTopToBottom") : (t.width = this.size.innerWidth + this.gutter, t.height = Number.POSITIVE_INFINITY, t.sortDirection = "downwardLeftToRight"), t.reset(), this.maxY = 0, this.maxX = 0
            }, l.prototype._getMeasurements = function() {
                this._getMeasurement("columnWidth", "width"), this._getMeasurement("rowHeight", "height"), this._getMeasurement("gutter", "width")
            }, l.prototype._getItemLayoutPosition = function(t) {
                return this._packItem(t), t.rect
            }, l.prototype._packItem = function(t) {
                this._setRectSize(t.element, t.rect), this.packer.pack(t.rect), this._setMaxXY(t.rect)
            }, l.prototype._setMaxXY = function(t) {
                this.maxX = Math.max(t.x + t.width, this.maxX), this.maxY = Math.max(t.y + t.height, this.maxY)
            }, l.prototype._setRectSize = function(t, i) {
                var n = e(t),
                    a = n.outerWidth,
                    r = n.outerHeight;
                if (a || r) {
                    var o = this.columnWidth + this.gutter,
                        s = this.rowHeight + this.gutter;
                    a = this.columnWidth ? Math.ceil(a / o) * o : a + this.gutter, r = this.rowHeight ? Math.ceil(r / s) * s : r + this.gutter
                }
                i.width = Math.min(a, this.packer.width), i.height = Math.min(r, this.packer.height)
            }, l.prototype._getContainerSize = function() {
                return this.options.isHorizontal ? {
                    width: this.maxX - this.gutter
                } : {
                    height: this.maxY - this.gutter
                }
            }, l.prototype._manageStamp = function(t) {
                var e, i = this.getItem(t);
                if (i && i.isPlacing) e = i.placeRect;
                else {
                    var a = this._getElementOffset(t);
                    e = new n({
                        x: this.options.isOriginLeft ? a.left : a.right,
                        y: this.options.isOriginTop ? a.top : a.bottom
                    })
                }
                this._setRectSize(t, e), this.packer.placed(e), this._setMaxXY(e)
            }, l.prototype.sortItemsByPosition = function() {
                var t = this.options.isHorizontal ? s : o;
                this.items.sort(t)
            }, l.prototype.fit = function(t, e, i) {
                var n = this.getItem(t);
                n && (this._getMeasurements(), this.stamp(n.element), n.getSize(), n.isPlacing = !0, e = void 0 === e ? n.rect.x : e, i = void 0 === i ? n.rect.y : i, n.positionPlaceRect(e, i, !0), this._bindFitEvents(n), n.moveTo(n.placeRect.x, n.placeRect.y), this.layout(), this.unstamp(n.element), this.sortItemsByPosition(), n.isPlacing = !1, n.copyPlaceRectPosition())
            }, l.prototype._bindFitEvents = function(t) {
                function e() {
                    n++, 2 === n && i.emitEvent("fitComplete", [i, t])
                }
                var i = this,
                    n = 0;
                t.on("layout", function() {
                    return e(), !0
                }), this.on("layoutComplete", function() {
                    return e(), !0
                })
            }, l.prototype.resize = function() {
                var t = e(this.element),
                    i = this.size && t,
                    n = this.options.isHorizontal ? "innerHeight" : "innerWidth";
                i && t[n] === this.size[n] || this.layout()
            }, l.prototype.itemDragStart = function(t) {
                this.stamp(t);
                var e = this.getItem(t);
                e && e.dragStart()
            }, l.prototype.itemDragMove = function(t, e, i) {
                function n() {
                    r.layout(), delete r.dragTimeout
                }
                var a = this.getItem(t);
                a && a.dragMove(e, i);
                var r = this;
                this.clearDragTimeout(), this.dragTimeout = setTimeout(n, 40)
            }, l.prototype.clearDragTimeout = function() {
                this.dragTimeout && clearTimeout(this.dragTimeout)
            }, l.prototype.itemDragEnd = function(e) {
                var i, n = this.getItem(e);
                if (n && (i = n.didDrag, n.dragStop()), !n || !i && !n.needsPositioning) return void this.unstamp(e);
                t.add(n.element, "is-positioning-post-drag");
                var a = this._getDragEndLayoutComplete(e, n);
                n.needsPositioning ? (n.on("layout", a), n.moveTo(n.placeRect.x, n.placeRect.y)) : n && n.copyPlaceRectPosition(), this.clearDragTimeout(), this.on("layoutComplete", a), this.layout()
            }, l.prototype._getDragEndLayoutComplete = function(e, i) {
                var n = i && i.needsPositioning,
                    a = 0,
                    r = n ? 2 : 1,
                    o = this;
                return function() {
                    return a++, a !== r ? !0 : (i && (t.remove(i.element, "is-positioning-post-drag"), i.isPlacing = !1, i.copyPlaceRectPosition()), o.unstamp(e), o.sortItemsByPosition(), n && o.emitEvent("dragItemPositioned", [o, i]), !0)
                }
            }, l.prototype.bindDraggabillyEvents = function(t) {
                t.on("dragStart", this.handleDraggabilly.dragStart), t.on("dragMove", this.handleDraggabilly.dragMove), t.on("dragEnd", this.handleDraggabilly.dragEnd)
            }, l.prototype.bindUIDraggableEvents = function(t) {
                t.on("dragstart", this.handleUIDraggable.start).on("drag", this.handleUIDraggable.drag).on("dragstop", this.handleUIDraggable.stop)
            }, l.Rect = n, l.Packer = a, l
        }
        "function" == typeof define && define.amd ? define(["classie/classie", "get-size/get-size", "outlayer/outlayer", "packery/js/rect", "packery/js/packer", "packery/js/item"], e) : t.Packery = e(t.classie, t.getSize, t.Outlayer, t.Packery.Rect, t.Packery.Packer, t.Packery.Item)
    }(window),
    function() {
        function t() {}

        function e(t, e) {
            for (var i = t.length; i--;)
                if (t[i].listener === e) return i;
            return -1
        }

        function i(t) {
            return function() {
                return this[t].apply(this, arguments)
            }
        }
        var n = t.prototype,
            a = this,
            r = a.EventEmitter;
        n.getListeners = function(t) {
            var e, i, n = this._getEvents();
            if ("object" == typeof t) {
                e = {};
                for (i in n) n.hasOwnProperty(i) && t.test(i) && (e[i] = n[i])
            } else e = n[t] || (n[t] = []);
            return e
        }, n.flattenListeners = function(t) {
            var e, i = [];
            for (e = 0; t.length > e; e += 1) i.push(t[e].listener);
            return i
        }, n.getListenersAsObject = function(t) {
            var e, i = this.getListeners(t);
            return i instanceof Array && (e = {}, e[t] = i), e || i
        }, n.addListener = function(t, i) {
            var n, a = this.getListenersAsObject(t),
                r = "object" == typeof i;
            for (n in a) a.hasOwnProperty(n) && -1 === e(a[n], i) && a[n].push(r ? i : {
                listener: i,
                once: !1
            });
            return this
        }, n.on = i("addListener"), n.addOnceListener = function(t, e) {
            return this.addListener(t, {
                listener: e,
                once: !0
            })
        }, n.once = i("addOnceListener"), n.defineEvent = function(t) {
            return this.getListeners(t), this
        }, n.defineEvents = function(t) {
            for (var e = 0; t.length > e; e += 1) this.defineEvent(t[e]);
            return this
        }, n.removeListener = function(t, i) {
            var n, a, r = this.getListenersAsObject(t);
            for (a in r) r.hasOwnProperty(a) && (n = e(r[a], i), -1 !== n && r[a].splice(n, 1));
            return this
        }, n.off = i("removeListener"), n.addListeners = function(t, e) {
            return this.manipulateListeners(!1, t, e)
        }, n.removeListeners = function(t, e) {
            return this.manipulateListeners(!0, t, e)
        }, n.manipulateListeners = function(t, e, i) {
            var n, a, r = t ? this.removeListener : this.addListener,
                o = t ? this.removeListeners : this.addListeners;
            if ("object" != typeof e || e instanceof RegExp)
                for (n = i.length; n--;) r.call(this, e, i[n]);
            else
                for (n in e) e.hasOwnProperty(n) && (a = e[n]) && ("function" == typeof a ? r.call(this, n, a) : o.call(this, n, a));
            return this
        }, n.removeEvent = function(t) {
            var e, i = typeof t,
                n = this._getEvents();
            if ("string" === i) delete n[t];
            else if ("object" === i)
                for (e in n) n.hasOwnProperty(e) && t.test(e) && delete n[e];
            else delete this._events;
            return this
        }, n.removeAllListeners = i("removeEvent"), n.emitEvent = function(t, e) {
            var i, n, a, r, o = this.getListenersAsObject(t);
            for (a in o)
                if (o.hasOwnProperty(a))
                    for (n = o[a].length; n--;) i = o[a][n], i.once === !0 && this.removeListener(t, i.listener), r = i.listener.apply(this, e || []), r === this._getOnceReturnValue() && this.removeListener(t, i.listener);
            return this
        }, n.trigger = i("emitEvent"), n.emit = function(t) {
            var e = Array.prototype.slice.call(arguments, 1);
            return this.emitEvent(t, e)
        }, n.setOnceReturnValue = function(t) {
            return this._onceReturnValue = t, this
        }, n._getOnceReturnValue = function() {
            return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0
        }, n._getEvents = function() {
            return this._events || (this._events = {})
        }, t.noConflict = function() {
            return a.EventEmitter = r, t
        }, "function" == typeof define && define.amd ? define("eventEmitter/EventEmitter", [], function() {
            return t
        }) : "object" == typeof module && module.exports ? module.exports = t : this.EventEmitter = t
    }.call(this),
    function(t) {
        function e(e) {
            var i = t.event;
            return i.target = i.target || i.srcElement || e, i
        }
        var i = document.documentElement,
            n = function() {};
        i.addEventListener ? n = function(t, e, i) {
            t.addEventListener(e, i, !1)
        } : i.attachEvent && (n = function(t, i, n) {
            t[i + n] = n.handleEvent ? function() {
                var i = e(t);
                n.handleEvent.call(n, i)
            } : function() {
                var i = e(t);
                n.call(t, i)
            }, t.attachEvent("on" + i, t[i + n])
        });
        var a = function() {};
        i.removeEventListener ? a = function(t, e, i) {
            t.removeEventListener(e, i, !1)
        } : i.detachEvent && (a = function(t, e, i) {
            t.detachEvent("on" + e, t[e + i]);
            try {
                delete t[e + i]
            } catch (n) {
                t[e + i] = void 0
            }
        });
        var r = {
            bind: n,
            unbind: a
        };
        "function" == typeof define && define.amd ? define("eventie/eventie", r) : t.eventie = r
    }(this),
    function(t, e) {
        "function" == typeof define && define.amd ? define(["eventEmitter/EventEmitter", "eventie/eventie"], function(i, n) {
            return e(t, i, n)
        }) : "object" == typeof exports ? module.exports = e(t, require("wolfy87-eventemitter"), require("eventie")) : t.imagesLoaded = e(t, t.EventEmitter, t.eventie)
    }(window, function(t, e, i) {
        function n(t, e) {
            for (var i in e) t[i] = e[i];
            return t
        }

        function a(t) {
            return "[object Array]" === h.call(t)
        }

        function r(t) {
            var e = [];
            if (a(t)) e = t;
            else if ("number" == typeof t.length)
                for (var i = 0, n = t.length; n > i; i++) e.push(t[i]);
            else e.push(t);
            return e
        }

        function o(t, e, i) {
            if (!(this instanceof o)) return new o(t, e);
            "string" == typeof t && (t = document.querySelectorAll(t)), this.elements = r(t), this.options = n({}, this.options), "function" == typeof e ? i = e : n(this.options, e), i && this.on("always", i), this.getImages(), c && (this.jqDeferred = new c.Deferred);
            var a = this;
            setTimeout(function() {
                a.check()
            })
        }

        function s(t) {
            this.img = t
        }

        function l(t) {
            this.src = t, p[t] = this
        }
        var c = t.jQuery,
            u = t.console,
            d = void 0 !== u,
            h = Object.prototype.toString;
        o.prototype = new e, o.prototype.options = {}, o.prototype.getImages = function() {
            this.images = [];
            for (var t = 0, e = this.elements.length; e > t; t++) {
                var i = this.elements[t];
                "IMG" === i.nodeName && this.addImage(i);
                var n = i.nodeType;
                if (n && (1 === n || 9 === n || 11 === n))
                    for (var a = i.querySelectorAll("img"), r = 0, o = a.length; o > r; r++) {
                        var s = a[r];
                        this.addImage(s)
                    }
            }
        }, o.prototype.addImage = function(t) {
            var e = new s(t);
            this.images.push(e)
        }, o.prototype.check = function() {
            function t(t, a) {
                return e.options.debug && d && u.log("confirm", t, a), e.progress(t), i++, i === n && e.complete(), !0
            }
            var e = this,
                i = 0,
                n = this.images.length;
            if (this.hasAnyBroken = !1, !n) return void this.complete();
            for (var a = 0; n > a; a++) {
                var r = this.images[a];
                r.on("confirm", t), r.check()
            }
        }, o.prototype.progress = function(t) {
            this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded;
            var e = this;
            setTimeout(function() {
                e.emit("progress", e, t), e.jqDeferred && e.jqDeferred.notify && e.jqDeferred.notify(e, t)
            })
        }, o.prototype.complete = function() {
            var t = this.hasAnyBroken ? "fail" : "done";
            this.isComplete = !0;
            var e = this;
            setTimeout(function() {
                if (e.emit(t, e), e.emit("always", e), e.jqDeferred) {
                    var i = e.hasAnyBroken ? "reject" : "resolve";
                    e.jqDeferred[i](e)
                }
            })
        }, c && (c.fn.imagesLoaded = function(t, e) {
            var i = new o(this, t, e);
            return i.jqDeferred.promise(c(this))
        }), s.prototype = new e, s.prototype.check = function() {
            var t = p[this.img.src] || new l(this.img.src);
            if (t.isConfirmed) return void this.confirm(t.isLoaded, "cached was confirmed");
            if (this.img.complete && void 0 !== this.img.naturalWidth) return void this.confirm(0 !== this.img.naturalWidth, "naturalWidth");
            var e = this;
            t.on("confirm", function(t, i) {
                return e.confirm(t.isLoaded, i), !0
            }), t.check()
        }, s.prototype.confirm = function(t, e) {
            this.isLoaded = t, this.emit("confirm", this, e)
        };
        var p = {};
        return l.prototype = new e, l.prototype.check = function() {
            if (!this.isChecked) {
                var t = new Image;
                i.bind(t, "load", this), i.bind(t, "error", this), t.src = this.src, this.isChecked = !0
            }
        }, l.prototype.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }, l.prototype.onload = function(t) {
            this.confirm(!0, "onload"), this.unbindProxyEvents(t)
        }, l.prototype.onerror = function(t) {
            this.confirm(!1, "onerror"), this.unbindProxyEvents(t)
        }, l.prototype.confirm = function(t, e) {
            this.isConfirmed = !0, this.isLoaded = t, this.emit("confirm", this, e)
        }, l.prototype.unbindProxyEvents = function(t) {
            i.unbind(t.target, "load", this), i.unbind(t.target, "error", this)
        }, o
    }),

    /*!
     * Velocity.js: Accelerated JavaScript animation.
     * @version 0.8.0
     * @docs http://velocityjs.org
     * @license Copyright 2014 Julian Shapiro. MIT License: http://en.wikipedia.org/wiki/MIT_License
     */


! function(t, e, i, n) {
    function a(t) {
        for (var e = -1, i = t ? t.length : 0, n = []; ++e < i;) {
            var a = t[e];
            a && n.push(a)
        }
        return n
    }

    function r(t) {
        var e = v.data(t, u);
        return null === e ? n : e
    }

    function o(t) {
        return function(e) {
            return Math.round(e * t) * (1 / t)
        }
    }

    function s(t, e) {
        var i = t;
        return m.isString(t) ? y.Easings[t] || (i = !1) : i = m.isArray(t) && 1 === t.length ? o.apply(null, t) : m.isArray(t) && 2 === t.length ? b.apply(null, t.concat([e])) : m.isArray(t) && 4 === t.length ? w.apply(null, t) : !1, i === !1 && (i = y.Easings[y.defaults.easing] ? y.defaults.easing : h), i
    }

    function l(t) {
        if (t)
            for (var e = (new Date).getTime(), i = 0, a = y.State.calls.length; a > i; i++)
                if (y.State.calls[i]) {
                    var o = y.State.calls[i],
                        s = o[0],
                        u = o[2],
                        d = o[3];
                    d || (d = y.State.calls[i][3] = e - 16);
                    for (var h = Math.min((e - d) / u.duration, 1), p = 0, f = s.length; f > p; p++) {
                        var v = s[p],
                            w = v.element;
                        if (r(w)) {
                            var b = !1;
                            u.display && "none" !== u.display && x.setPropertyValue(w, "display", u.display), u.visibility && "hidden" !== u.visibility && x.setPropertyValue(w, "visibility", u.visibility);
                            for (var S in v)
                                if ("element" !== S) {
                                    var T, C = v[S],
                                        k = m.isString(C.easing) ? y.Easings[C.easing] : C.easing;
                                    if (T = 1 === h ? C.endValue : C.startValue + (C.endValue - C.startValue) * k(h), C.currentValue = T, x.Hooks.registered[S]) {
                                        var D = x.Hooks.getRoot(S),
                                            P = r(w).rootPropertyValueCache[D];
                                        P && (C.rootPropertyValue = P)
                                    }
                                    var E = x.setPropertyValue(w, S, C.currentValue + (0 === parseFloat(T) ? "" : C.unitType), C.rootPropertyValue, C.scrollData);
                                    x.Hooks.registered[S] && (r(w).rootPropertyValueCache[D] = x.Normalizations.registered[D] ? x.Normalizations.registered[D]("extract", null, E[1]) : E[1]), "transform" === E[0] && (b = !0)
                                }
                            u.mobileHA && r(w).transformCache.translate3d === n && (r(w).transformCache.translate3d = "(0px, 0px, 0px)", b = !0), b && x.flushTransformCache(w)
                        }
                    }
                    u.display && "none" !== u.display && (y.State.calls[i][2].display = !1), u.visibility && "hidden" !== u.visibility && (y.State.calls[i][2].visibility = !1), u.progress && u.progress.call(o[1], o[1], h, Math.max(0, d + u.duration - e), d), 1 === h && c(i)
                }
        y.State.isTicking && g(l)
    }

    function c(t, e) {
        if (!y.State.calls[t]) return !1;
        for (var i = y.State.calls[t][0], a = y.State.calls[t][1], o = y.State.calls[t][2], s = y.State.calls[t][4], l = !1, c = 0, u = i.length; u > c; c++) {
            var d = i[c].element;
            if (e || o.loop || ("none" === o.display && x.setPropertyValue(d, "display", o.display), "hidden" === o.visibility && x.setPropertyValue(d, "visibility", o.visibility)), (v.queue(d)[1] === n || !/\.velocityQueueEntryFlag/i.test(v.queue(d)[1])) && r(d)) {
                r(d).isAnimating = !1, r(d).rootPropertyValueCache = {};
                var h = !1;
                v.each(r(d).transformCache, function(t, e) {
                    var i = /^scale/.test(t) ? 1 : 0;
                    new RegExp("^\\(" + i + "[^.]").test(e) && (h = !0, delete r(d).transformCache[t])
                }), o.mobileHA && (h = !0, delete r(d).transformCache.translate3d), h && x.flushTransformCache(d), x.Values.removeClass(d, "animating")
            }
            if (!e && o.complete && !o.loop && c === u - 1) try {
                o.complete.call(a, a)
            } catch (p) {
                setTimeout(function() {
                    throw p
                }, 1)
            }
            s && s(a), o.queue !== !1 && v.dequeue(d, o.queue)
        }
        y.State.calls[t] = !1;
        for (var f = 0, g = y.State.calls.length; g > f; f++)
            if (y.State.calls[f] !== !1) {
                l = !0;
                break
            }
        l === !1 && (y.State.isTicking = !1, delete y.State.calls, y.State.calls = [])
    }
    var u = "velocity",
        d = 400,
        h = "swing",
        p = function() {
            if (i.documentMode) return i.documentMode;
            for (var t = 7; t > 4; t--) {
                var e = i.createElement("div");
                if (e.innerHTML = "<!--[if IE " + t + "]><span></span><![endif]-->", e.getElementsByTagName("span").length) return e = null, t
            }
            return n
        }(),
        f = function() {
            var t = 0;
            return e.webkitRequestAnimationFrame || e.mozRequestAnimationFrame || function(e) {
                var i, n = (new Date).getTime();
                return i = Math.max(0, 16 - (n - t)), t = n + i, setTimeout(function() {
                    e(n + i)
                }, i)
            }
        }(),
        g = e.requestAnimationFrame || f,
        m = {
            isString: function(t) {
                return "string" == typeof t
            },
            isArray: Array.isArray || function(t) {
                return "[object Array]" === Object.prototype.toString.call(t)
            },
            isFunction: function(t) {
                return "[object Function]" === Object.prototype.toString.call(t)
            },
            isNode: function(t) {
                return t && t.nodeType
            },
            isNodeList: function(t) {
                return "object" == typeof t && /^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(t)) && t.length !== n && (0 === t.length || "object" == typeof t[0] && t[0].nodeType > 0)
            },
            isWrapped: function(t) {
                return t && (t.jquery || e.Zepto && e.Zepto.zepto.isZ(t))
            },
            isSVG: function(t) {
                return e.SVGElement && t instanceof SVGElement
            }
        },
        v = e.jQuery || t.Velocity && t.Velocity.Utilities;
    if (!v) throw new Error("Velocity: Either jQuery or Velocity's jQuery shim must first be loaded.");
    if (t.Velocity !== n && !t.Velocity.Utilities) throw new Error("Velocity: Namespace is occupied.");
    if (7 >= p) {
        if (e.jQuery) return void(e.jQuery.fn.velocity = e.jQuery.fn.animate);
        throw new Error("Velocity: For IE<=7, Velocity falls back to jQuery, which must first be loaded.")
    }
    if (8 === p && !e.jQuery) throw new Error("Velocity: For IE8, Velocity requires jQuery to be loaded. (Velocity's jQuery shim does not work with IE8.)");
    var y = t.Velocity = t.velocity = {
        State: {
            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
            isAndroid: /Android/i.test(navigator.userAgent),
            isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
            isChrome: e.chrome,
            prefixElement: i.createElement("div"),
            prefixMatches: {},
            scrollAnchor: null,
            scrollPropertyLeft: null,
            scrollPropertyTop: null,
            isTicking: !1,
            calls: []
        },
        CSS: {},
        Utilities: e.jQuery,
        Sequences: {},
        Easings: {},
        Promise: e.Promise,
        defaults: {
            queue: "",
            duration: d,
            easing: h,
            begin: null,
            complete: null,
            progress: null,
            display: null,
            loop: !1,
            delay: !1,
            mobileHA: !0,
            _cacheValues: !0
        },
        animate: function() {},
        mock: !1,
        version: {
            major: 0,
            minor: 8,
            patch: 0
        },
        debug: !1
    };
    e.pageYOffset !== n ? (y.State.scrollAnchor = e, y.State.scrollPropertyLeft = "pageXOffset", y.State.scrollPropertyTop = "pageYOffset") : (y.State.scrollAnchor = i.documentElement || i.body.parentNode || i.body, y.State.scrollPropertyLeft = "scrollLeft", y.State.scrollPropertyTop = "scrollTop"), y.State.isMobile || i.hidden === n || i.addEventListener("visibilitychange", function() {
        i.hidden ? (g = function(t) {
            return setTimeout(function() {
                t(!0)
            }, 16)
        }, l()) : g = e.requestAnimationFrame || f
    });
    var w = function() {
            function t(t, e) {
                return 1 - 3 * e + 3 * t
            }

            function e(t, e) {
                return 3 * e - 6 * t
            }

            function i(t) {
                return 3 * t
            }

            function n(n, a, r) {
                return ((t(a, r) * n + e(a, r)) * n + i(a)) * n
            }

            function a(n, a, r) {
                return 3 * t(a, r) * n * n + 2 * e(a, r) * n + i(a)
            }
            return function(t, e, i, r) {
                function o(e) {
                    for (var r = e, o = 0; 8 > o; ++o) {
                        var s = a(r, t, i);
                        if (0 === s) return r;
                        var l = n(r, t, i) - e;
                        r -= l / s
                    }
                    return r
                }
                if (4 !== arguments.length) return !1;
                for (var s = 0; 4 > s; ++s)
                    if ("number" != typeof arguments[s] || isNaN(arguments[s]) || !isFinite(arguments[s])) return !1;
                return t = Math.min(t, 1), i = Math.min(i, 1), t = Math.max(t, 0), i = Math.max(i, 0),
                    function(a) {
                        return t === e && i === r ? a : n(o(a), e, r)
                    }
            }
        }(),
        b = function() {
            function t(t) {
                return -t.tension * t.x - t.friction * t.v
            }

            function e(e, i, n) {
                var a = {
                    x: e.x + n.dx * i,
                    v: e.v + n.dv * i,
                    tension: e.tension,
                    friction: e.friction
                };
                return {
                    dx: a.v,
                    dv: t(a)
                }
            }

            function i(i, n) {
                var a = {
                        dx: i.v,
                        dv: t(i)
                    },
                    r = e(i, .5 * n, a),
                    o = e(i, .5 * n, r),
                    s = e(i, n, o),
                    l = 1 / 6 * (a.dx + 2 * (r.dx + o.dx) + s.dx),
                    c = 1 / 6 * (a.dv + 2 * (r.dv + o.dv) + s.dv);
                return i.x = i.x + l * n, i.v = i.v + c * n, i
            }
            return function n(t, e, a) {
                var r, o, s, l = {
                        x: -1,
                        v: 0,
                        tension: null,
                        friction: null
                    },
                    c = [0],
                    u = 0,
                    d = 1e-4,
                    h = .016;
                for (t = parseFloat(t) || 500, e = parseFloat(e) || 20, a = a || null, l.tension = t, l.friction = e, r = null !== a, r ? (u = n(t, e), o = u / a * h) : o = h; s = i(s || l, o), c.push(1 + s.x), u += 16, Math.abs(s.x) > d && Math.abs(s.v) > d;);
                return r ? function(t) {
                    return c[t * (c.length - 1) | 0]
                } : u
            }
        }();
    ! function() {
        y.Easings.linear = function(t) {
            return t
        }, y.Easings.swing = function(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        }, y.Easings.spring = function(t) {
            return 1 - Math.cos(4.5 * t * Math.PI) * Math.exp(6 * -t)
        }, y.Easings.ease = w(.25, .1, .25, 1), y.Easings["ease-in"] = w(.42, 0, 1, 1), y.Easings["ease-out"] = w(0, 0, .58, 1), y.Easings["ease-in-out"] = w(.42, 0, .58, 1);
        var t = {};
        v.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function(e, i) {
            t[i] = function(t) {
                return Math.pow(t, e + 2)
            }
        }), v.extend(t, {
            Sine: function(t) {
                return 1 - Math.cos(t * Math.PI / 2)
            },
            Circ: function(t) {
                return 1 - Math.sqrt(1 - t * t)
            },
            Elastic: function(t) {
                return 0 === t || 1 === t ? t : -Math.pow(2, 8 * (t - 1)) * Math.sin((80 * (t - 1) - 7.5) * Math.PI / 15)
            },
            Back: function(t) {
                return t * t * (3 * t - 2)
            },
            Bounce: function(t) {
                for (var e, i = 4; t < ((e = Math.pow(2, --i)) - 1) / 11;);
                return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((3 * e - 2) / 22 - t, 2)
            }
        }), v.each(t, function(t, e) {
            y.Easings["easeIn" + t] = e, y.Easings["easeOut" + t] = function(t) {
                return 1 - e(1 - t)
            }, y.Easings["easeInOut" + t] = function(t) {
                return .5 > t ? e(2 * t) / 2 : 1 - e(-2 * t + 2) / 2
            }
        })
    }();
    var x = y.CSS = {
        RegEx: {
            valueUnwrap: /^[A-z]+\((.*)\)$/i,
            wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
            valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi
        },
        Hooks: {
            templates: {
                color: ["Red Green Blue Alpha", "255 255 255 1"],
                backgroundColor: ["Red Green Blue Alpha", "255 255 255 1"],
                borderColor: ["Red Green Blue Alpha", "255 255 255 1"],
                borderTopColor: ["Red Green Blue Alpha", "255 255 255 1"],
                borderRightColor: ["Red Green Blue Alpha", "255 255 255 1"],
                borderBottomColor: ["Red Green Blue Alpha", "255 255 255 1"],
                borderLeftColor: ["Red Green Blue Alpha", "255 255 255 1"],
                outlineColor: ["Red Green Blue Alpha", "255 255 255 1"],
                fill: ["Red Green Blue Alpha", "255 255 255 1"],
                stroke: ["Red Green Blue Alpha", "255 255 255 1"],
                stopColor: ["Red Green Blue Alpha", "255 255 255 1"],
                textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
                boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
                clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
                backgroundPosition: ["X Y", "0% 0%"],
                transformOrigin: ["X Y Z", "50% 50% 0px"],
                perspectiveOrigin: ["X Y", "50% 50%"]
            },
            registered: {},
            register: function() {
                var t, e, i;
                if (p)
                    for (t in x.Hooks.templates) {
                        e = x.Hooks.templates[t], i = e[0].split(" ");
                        var n = e[1].match(x.RegEx.valueSplit);
                        "Color" === i[0] && (i.push(i.shift()), n.push(n.shift()), x.Hooks.templates[t] = [i.join(" "), n.join(" ")])
                    }
                for (t in x.Hooks.templates) {
                    e = x.Hooks.templates[t], i = e[0].split(" ");
                    for (var a in i) {
                        var r = t + i[a],
                            o = a;
                        x.Hooks.registered[r] = [t, o]
                    }
                }
            },
            getRoot: function(t) {
                var e = x.Hooks.registered[t];
                return e ? e[0] : t
            },
            cleanRootPropertyValue: function(t, e) {
                return x.RegEx.valueUnwrap.test(e) && (e = e.match(x.Hooks.RegEx.valueUnwrap)[1]), x.Values.isCSSNullValue(e) && (e = x.Hooks.templates[t][1]), e
            },
            extractValue: function(t, e) {
                var i = x.Hooks.registered[t];
                if (i) {
                    var n = i[0],
                        a = i[1];
                    return e = x.Hooks.cleanRootPropertyValue(n, e), e.toString().match(x.RegEx.valueSplit)[a]
                }
                return e
            },
            injectValue: function(t, e, i) {
                var n = x.Hooks.registered[t];
                if (n) {
                    var a, r, o = n[0],
                        s = n[1];
                    return i = x.Hooks.cleanRootPropertyValue(o, i), a = i.toString().match(x.RegEx.valueSplit), a[s] = e, r = a.join(" ")
                }
                return i
            }
        },
        Normalizations: {
            registered: {
                clip: function(t, e, i) {
                    switch (t) {
                        case "name":
                            return "clip";
                        case "extract":
                            var n;
                            return x.RegEx.wrappedValueAlreadyExtracted.test(i) ? n = i : (n = i.toString().match(x.RegEx.valueUnwrap), n = n ? n[1].replace(/,(\s+)?/g, " ") : i), n;
                        case "inject":
                            return "rect(" + i + ")"
                    }
                },
                opacity: function(t, e, i) {
                    if (8 >= p) switch (t) {
                        case "name":
                            return "filter";
                        case "extract":
                            var n = i.toString().match(/alpha\(opacity=(.*)\)/i);
                            return i = n ? n[1] / 100 : 1;
                        case "inject":
                            return e.style.zoom = 1, parseFloat(i) >= 1 ? "" : "alpha(opacity=" + parseInt(100 * parseFloat(i), 10) + ")"
                    } else switch (t) {
                        case "name":
                            return "opacity";
                        case "extract":
                            return i;
                        case "inject":
                            return i
                    }
                }
            },
            register: function() {
                function t(t) {
                    var e, i = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
                        n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
                    return t = t.replace(i, function(t, e, i, n) {
                        return e + e + i + i + n + n
                    }), e = n.exec(t), e ? "rgb(" + (parseInt(e[1], 16) + " " + parseInt(e[2], 16) + " " + parseInt(e[3], 16)) + ")" : "rgb(0 0 0)"
                }
                var e = ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"];
                9 >= p || y.State.isGingerbread || (e = e.concat(["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"]));
                for (var i = 0, a = e.length; a > i; i++) ! function() {
                    var t = e[i];
                    x.Normalizations.registered[t] = function(e, i, a) {
                        switch (e) {
                            case "name":
                                return "transform";
                            case "extract":
                                return r(i).transformCache[t] === n ? /^scale/i.test(t) ? 1 : 0 : r(i).transformCache[t].replace(/[()]/g, "");
                            case "inject":
                                var o = !1;
                                switch (t.substr(0, t.length - 1)) {
                                    case "translate":
                                        o = !/(%|px|em|rem|\d)$/i.test(a);
                                        break;
                                    case "scal":
                                    case "scale":
                                        y.State.isAndroid && r(i).transformCache[t] === n && 1 > a && (a = 1), o = !/(\d)$/i.test(a);
                                        break;
                                    case "skew":
                                        o = !/(deg|\d)$/i.test(a);
                                        break;
                                    case "rotate":
                                        o = !/(deg|\d)$/i.test(a)
                                }
                                return o || (r(i).transformCache[t] = "(" + a + ")"), r(i).transformCache[t]
                        }
                    }
                }();
                for (var o = ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"], i = 0, s = o.length; s > i; i++) ! function() {
                    var e = o[i];
                    x.Normalizations.registered[e] = function(i, a, r) {
                        switch (i) {
                            case "name":
                                return e;
                            case "extract":
                                var o;
                                if (x.RegEx.wrappedValueAlreadyExtracted.test(r)) o = r;
                                else {
                                    var s, l = {
                                        aqua: "rgb(0, 255, 255);",
                                        black: "rgb(0, 0, 0)",
                                        blue: "rgb(0, 0, 255)",
                                        fuchsia: "rgb(255, 0, 255)",
                                        gray: "rgb(128, 128, 128)",
                                        green: "rgb(0, 128, 0)",
                                        lime: "rgb(0, 255, 0)",
                                        maroon: "rgb(128, 0, 0)",
                                        navy: "rgb(0, 0, 128)",
                                        olive: "rgb(128, 128, 0)",
                                        purple: "rgb(128, 0, 128)",
                                        red: "rgb(255, 0, 0)",
                                        silver: "rgb(192, 192, 192)",
                                        teal: "rgb(0, 128, 128)",
                                        white: "rgb(255, 255, 255)",
                                        yellow: "rgb(255, 255, 0)"
                                    };
                                    /^[A-z]+$/i.test(r) ? s = l[r] !== n ? l[r] : l.black : /^#([A-f\d]{3}){1,2}$/i.test(r) ? s = t(r) : /^rgba?\(/i.test(r) || (s = l.black), o = (s || r).toString().match(x.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ")
                                }
                                return 8 >= p || 3 !== o.split(" ").length || (o += " 1"), o;
                            case "inject":
                                return 8 >= p ? 4 === r.split(" ").length && (r = r.split(/\s+/).slice(0, 3).join(" ")) : 3 === r.split(" ").length && (r += " 1"), (8 >= p ? "rgb" : "rgba") + "(" + r.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")"
                        }
                    }
                }()
            }
        },
        Names: {
            camelCase: function(t) {
                return t.replace(/-(\w)/g, function(t, e) {
                    return e.toUpperCase()
                })
            },
            SVGAttribute: function(t) {
                var e = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y1";
                return (p || y.State.isAndroid && !y.State.isChrome) && (e += "|transform"), new RegExp("^(" + e + ")$", "i").test(t)
            },
            prefixCheck: function(t) {
                if (y.State.prefixMatches[t]) return [y.State.prefixMatches[t], !0];
                for (var e = ["", "Webkit", "Moz", "ms", "O"], i = 0, n = e.length; n > i; i++) {
                    var a;
                    if (a = 0 === i ? t : e[i] + t.replace(/^\w/, function(t) {
                            return t.toUpperCase()
                        }), m.isString(y.State.prefixElement.style[a])) return y.State.prefixMatches[t] = a, [a, !0]
                }
                return [t, !1]
            }
        },
        Values: {
            isCSSNullValue: function(t) {
                return 0 == t || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(t)
            },
            getUnitType: function(t) {
                return /^(rotate|skew)/i.test(t) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(t) ? "" : "px"
            },
            getDisplayType: function(t) {
                var e = t.tagName.toString().toLowerCase();
                return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(e) ? "inline" : /^(li)$/i.test(e) ? "list-item" : /^(tr)$/i.test(e) ? "table-row" : "block"
            },
            addClass: function(t, e) {
                t.classList ? t.classList.add(e) : t.className += (t.className.length ? " " : "") + e
            },
            removeClass: function(t, e) {
                t.classList ? t.classList.remove(e) : t.className = t.className.toString().replace(new RegExp("(^|\\s)" + e.split(" ").join("|") + "(\\s|$)", "gi"), " ")
            }
        },
        getPropertyValue: function(t, i, a, o) {
            function s(t, i) {
                function a() {
                    c && x.setPropertyValue(t, "display", "none")
                }
                var l = 0;
                if (8 >= p) l = v.css(t, i);
                else {
                    var c = !1;
                    if (/^(width|height)$/.test(i) && 0 === x.getPropertyValue(t, "display") && (c = !0, x.setPropertyValue(t, "display", x.Values.getDisplayType(t))), !o) {
                        if ("height" === i && "border-box" !== x.getPropertyValue(t, "boxSizing").toString().toLowerCase()) {
                            var u = t.offsetHeight - (parseFloat(x.getPropertyValue(t, "borderTopWidth")) || 0) - (parseFloat(x.getPropertyValue(t, "borderBottomWidth")) || 0) - (parseFloat(x.getPropertyValue(t, "paddingTop")) || 0) - (parseFloat(x.getPropertyValue(t, "paddingBottom")) || 0);
                            return a(), u
                        }
                        if ("width" === i && "border-box" !== x.getPropertyValue(t, "boxSizing").toString().toLowerCase()) {
                            var d = t.offsetWidth - (parseFloat(x.getPropertyValue(t, "borderLeftWidth")) || 0) - (parseFloat(x.getPropertyValue(t, "borderRightWidth")) || 0) - (parseFloat(x.getPropertyValue(t, "paddingLeft")) || 0) - (parseFloat(x.getPropertyValue(t, "paddingRight")) || 0);
                            return a(), d
                        }
                    }
                    var h;
                    h = r(t) === n ? e.getComputedStyle(t, null) : r(t).computedStyle ? r(t).computedStyle : r(t).computedStyle = e.getComputedStyle(t, null), p && "borderColor" === i && (i = "borderTopColor"), l = 9 === p && "filter" === i ? h.getPropertyValue(i) : h[i], ("" === l || null === l) && (l = t.style[i]), a()
                }
                if ("auto" === l && /^(top|right|bottom|left)$/i.test(i)) {
                    var f = s(t, "position");
                    ("fixed" === f || "absolute" === f && /top|left/i.test(i)) && (l = v(t).position()[i] + "px")
                }
                return l
            }
            var l;
            if (x.Hooks.registered[i]) {
                var c = i,
                    u = x.Hooks.getRoot(c);
                a === n && (a = x.getPropertyValue(t, x.Names.prefixCheck(u)[0])), x.Normalizations.registered[u] && (a = x.Normalizations.registered[u]("extract", t, a)), l = x.Hooks.extractValue(c, a)
            } else if (x.Normalizations.registered[i]) {
                var d, h;
                d = x.Normalizations.registered[i]("name", t), "transform" !== d && (h = s(t, x.Names.prefixCheck(d)[0]), x.Values.isCSSNullValue(h) && x.Hooks.templates[i] && (h = x.Hooks.templates[i][1])), l = x.Normalizations.registered[i]("extract", t, h)
            }
            return /^[\d-]/.test(l) || (l = r(t) && r(t).isSVG && x.Names.SVGAttribute(i) ? /^(height|width)$/i.test(i) ? t.getBBox()[i] : t.getAttribute(i) : s(t, x.Names.prefixCheck(i)[0])), x.Values.isCSSNullValue(l) && (l = 0), y.debug >= 2 && console.log("Get " + i + ": " + l), l
        },
        setPropertyValue: function(t, i, n, a, o) {
            var s = i;
            if ("scroll" === i) o.container ? o.container["scroll" + o.direction] = n : "Left" === o.direction ? e.scrollTo(n, o.alternateValue) : e.scrollTo(o.alternateValue, n);
            else if (x.Normalizations.registered[i] && "transform" === x.Normalizations.registered[i]("name", t)) x.Normalizations.registered[i]("inject", t, n), s = "transform", n = r(t).transformCache[i];
            else {
                if (x.Hooks.registered[i]) {
                    var l = i,
                        c = x.Hooks.getRoot(i);
                    a = a || x.getPropertyValue(t, c), n = x.Hooks.injectValue(l, n, a), i = c
                }
                if (x.Normalizations.registered[i] && (n = x.Normalizations.registered[i]("inject", t, n), i = x.Normalizations.registered[i]("name", t)), s = x.Names.prefixCheck(i)[0], 8 >= p) try {
                    t.style[s] = n
                } catch (u) {
                    y.debug && console.log("Browser does not support [" + n + "] for [" + s + "]")
                } else r(t) && r(t).isSVG && x.Names.SVGAttribute(i) ? t.setAttribute(i, n) : t.style[s] = n;
                y.debug >= 2 && console.log("Set " + i + " (" + s + "): " + n)
            }
            return [s, n]
        },
        flushTransformCache: function(t) {
            function e(e) {
                return parseFloat(x.getPropertyValue(t, e))
            }
            var i = "";
            if ((p || y.State.isAndroid && !y.State.isChrome) && r(t).isSVG) {
                var n = {
                    translate: [e("translateX"), e("translateY")],
                    skewX: [e("skewX")],
                    skewY: [e("skewY")],
                    scale: 1 !== e("scale") ? [e("scale"), e("scale")] : [e("scaleX"), e("scaleY")],
                    rotate: [e("rotateZ"), 0, 0]
                };
                v.each(r(t).transformCache, function(t) {
                    /^translate/i.test(t) ? t = "translate" : /^scale/i.test(t) ? t = "scale" : /^rotate/i.test(t) && (t = "rotate"), n[t] && (i += t + "(" + n[t].join(" ") + ") ", delete n[t])
                })
            } else {
                var a, o;
                v.each(r(t).transformCache, function(e) {
                    return a = r(t).transformCache[e], "transformPerspective" === e ? (o = a, !0) : (9 === p && "rotateZ" === e && (e = "rotate"), void(i += e + a + " "))
                }), o && (i = "perspective" + o + " " + i)
            }
            x.setPropertyValue(t, "transform", i)
        }
    };
    x.Hooks.register(), x.Normalizations.register(), y.animate = function() {
        function t() {
            return h ? E.promise || null : f
        }

        function o() {
            function t() {
                function t(t) {
                    var e = n,
                        i = n,
                        a = n;
                    return m.isArray(t) ? (e = t[0], !m.isArray(t[1]) && /^[\d-]/.test(t[1]) || m.isFunction(t[1]) ? a = t[1] : (m.isString(t[1]) || m.isArray(t[1])) && (i = s(t[1], c.duration), t[2] !== n && (a = t[2]))) : e = t, i = i || c.easing, m.isFunction(e) && (e = e.call(o, k, C)), m.isFunction(a) && (a = a.call(o, k, C)), [e || 0, i, a]
                }

                function u(t, e) {
                    var i, n;
                    return n = (e || 0).toString().toLowerCase().replace(/[%A-z]+$/, function(t) {
                        return i = t, ""
                    }), i || (i = x.Values.getUnitType(t)), [n, i]
                }

                function d() {
                    var t = {
                            parent: o.parentNode,
                            position: x.getPropertyValue(o, "position"),
                            fontSize: x.getPropertyValue(o, "fontSize")
                        },
                        n = t.position === L.lastPosition && t.parent === L.lastParent,
                        a = t.fontSize === L.lastFontSize && t.parent === L.lastParent;
                    L.lastParent = t.parent, L.lastPosition = t.position, L.lastFontSize = t.fontSize, null === L.remToPx && (L.remToPx = parseFloat(x.getPropertyValue(i.body, "fontSize")) || 16), null === L.vwToPx && (L.vwToPx = parseFloat(e.innerWidth) / 100, L.vhToPx = parseFloat(e.innerHeight) / 100);
                    var s = {
                            overflowX: null,
                            overflowY: null,
                            boxSizing: null,
                            width: null,
                            minWidth: null,
                            maxWidth: null,
                            height: null,
                            minHeight: null,
                            maxHeight: null,
                            paddingLeft: null
                        },
                        l = {},
                        c = 10;
                    if (l.remToPx = L.remToPx, l.vwToPx = L.vwToPx, l.vhToPx = L.vhToPx, p && !r(o).isSVG) var u = /^auto$/i.test(o.currentStyle.width),
                        d = /^auto$/i.test(o.currentStyle.height);
                    n && a || (r(o).isSVG || (s.overflowX = x.getPropertyValue(o, "overflowX"), s.overflowY = x.getPropertyValue(o, "overflowY"), s.boxSizing = x.getPropertyValue(o, "boxSizing"), s.minWidth = x.getPropertyValue(o, "minWidth"), s.maxWidth = x.getPropertyValue(o, "maxWidth") || "none", s.minHeight = x.getPropertyValue(o, "minHeight"), s.maxHeight = x.getPropertyValue(o, "maxHeight") || "none", s.paddingLeft = x.getPropertyValue(o, "paddingLeft")), s.width = x.getPropertyValue(o, "width", null, !0), s.height = x.getPropertyValue(o, "height", null, !0)), n ? (l.percentToPxRatioWidth = L.lastPercentToPxWidth, l.percentToPxRatioHeight = L.lastPercentToPxHeight) : (r(o).isSVG || (x.setPropertyValue(o, "overflowX", "hidden"), x.setPropertyValue(o, "overflowY", "hidden"), x.setPropertyValue(o, "boxSizing", "content-box"), x.setPropertyValue(o, "minWidth", c + "%"), x.setPropertyValue(o, "maxWidth", c + "%"), x.setPropertyValue(o, "minHeight", c + "%"), x.setPropertyValue(o, "maxHeight", c + "%")), x.setPropertyValue(o, "width", c + "%"), x.setPropertyValue(o, "height", c + "%")), a ? l.emToPx = L.lastEmToPx : r(o).isSVG || x.setPropertyValue(o, "paddingLeft", c + "em"), n || (l.percentToPxRatioWidth = L.lastPercentToPxWidth = (parseFloat(x.getPropertyValue(o, "width", null, !0)) || 1) / c, l.percentToPxRatioHeight = L.lastPercentToPxHeight = (parseFloat(x.getPropertyValue(o, "height", null, !0)) || 1) / c), a || (l.emToPx = L.lastEmToPx = (parseFloat(x.getPropertyValue(o, "paddingLeft")) || 1) / c);
                    for (var h in s) null !== s[h] && x.setPropertyValue(o, h, s[h]);
                    return r(o).isSVG || (p ? (u && x.setPropertyValue(o, "width", "auto"), d && x.setPropertyValue(o, "height", "auto")) : (x.setPropertyValue(o, "height", "auto"), s.height !== x.getPropertyValue(o, "height", null, !0) && x.setPropertyValue(o, "height", s.height), x.setPropertyValue(o, "width", "auto"), s.width !== x.getPropertyValue(o, "width", null, !0) && x.setPropertyValue(o, "width", s.width))), y.debug >= 1 && console.log("Unit ratios: " + JSON.stringify(l), o), l
                }
                if (c.begin && 0 === k) try {
                    c.begin.call(w, w)
                } catch (f) {
                    setTimeout(function() {
                        throw f
                    }, 1)
                }
                if ("scroll" === _) {
                    var g, T, D, P = /^x$/i.test(c.axis) ? "Left" : "Top",
                        O = parseFloat(c.offset) || 0;
                    c.container ? c.container.jquery || m.isNode(c.container) ? (c.container = c.container[0] || c.container, g = c.container["scroll" + P], D = g + v(o).position()[P.toLowerCase()] + O) : c.container = null : (g = y.State.scrollAnchor[y.State["scrollProperty" + P]], T = y.State.scrollAnchor[y.State["scrollProperty" + ("Left" === P ? "Top" : "Left")]], D = v(o).offset()[P.toLowerCase()] + O), h = {
                        scroll: {
                            rootPropertyValue: !1,
                            startValue: g,
                            currentValue: g,
                            endValue: D,
                            unitType: "",
                            easing: c.easing,
                            scrollData: {
                                container: c.container,
                                direction: P,
                                alternateValue: T
                            }
                        },
                        element: o
                    }
                } else if ("reverse" === _) {
                    if (!r(o).tweensContainer) return void v.dequeue(o, c.queue);
                    "none" === r(o).opts.display && (r(o).opts.display = "block"), "hidden" === r(o).opts.visibility && (r(o).opts.visibility = "visible"), r(o).opts.loop = !1, r(o).opts.begin = null, r(o).opts.complete = null, S.easing || delete c.easing, S.duration || delete c.duration, c = v.extend({}, r(o).opts, c);
                    var M = v.extend(!0, {}, r(o).tweensContainer);
                    for (var I in M)
                        if ("element" !== I) {
                            var N = M[I].startValue;
                            M[I].startValue = M[I].currentValue = M[I].endValue, M[I].endValue = N, S && (M[I].easing = c.easing)
                        }
                    h = M
                } else if ("start" === _) {
                    var M;
                    r(o).tweensContainer && r(o).isAnimating === !0 && (M = r(o).tweensContainer);
                    for (var A in b) {
                        var R = t(b[A]),
                            Y = R[0],
                            z = R[1],
                            W = R[2];
                        A = x.Names.camelCase(A);
                        var j = x.Hooks.getRoot(A),
                            U = !1;
                        if (r(o).isSVG || x.Names.prefixCheck(j)[1] !== !1 || x.Normalizations.registered[j] !== n) {
                            (c.display && "none" !== c.display || c.visibility && "hidden" !== c.visibility) && /opacity|filter/.test(A) && !W && 0 !== Y && (W = 0), c._cacheValues && M && M[A] ? (W === n && (W = M[A].endValue + M[A].unitType), U = r(o).rootPropertyValueCache[j]) : x.Hooks.registered[A] ? W === n ? (U = x.getPropertyValue(o, j), W = x.getPropertyValue(o, A, U)) : U = x.Hooks.templates[j][1] : W === n && (W = x.getPropertyValue(o, A));
                            var F, H, X, B = !1;
                            F = u(A, W), W = F[0], X = F[1], F = u(A, Y), Y = F[0].replace(/^([+-\/*])=/, function(t, e) {
                                return B = e, ""
                            }), H = F[1], W = parseFloat(W) || 0, Y = parseFloat(Y) || 0;
                            var q;
                            if ("%" === H && (/^(fontSize|lineHeight)$/.test(A) ? (Y /= 100, H = "em") : /^scale/.test(A) ? (Y /= 100, H = "") : /(Red|Green|Blue)$/i.test(A) && (Y = Y / 100 * 255, H = "")), /[\/*]/.test(B)) H = X;
                            else if (X !== H && 0 !== W)
                                if (0 === Y) H = X;
                                else {
                                    q = q || d();
                                    var Z = /margin|padding|left|right|width|text|word|letter/i.test(A) || /X$/.test(A) ? "x" : "y";
                                    switch (X) {
                                        case "%":
                                            W *= "x" === Z ? q.percentToPxRatioWidth : q.percentToPxRatioHeight;
                                            break;
                                        case "px":
                                            break;
                                        default:
                                            W *= q[X + "ToPx"]
                                    }
                                    switch (H) {
                                        case "%":
                                            W *= 1 / ("x" === Z ? q.percentToPxRatioWidth : q.percentToPxRatioHeight);
                                            break;
                                        case "px":
                                            break;
                                        default:
                                            W *= 1 / q[H + "ToPx"]
                                    }
                                }
                            switch (B) {
                                case "+":
                                    Y = W + Y;
                                    break;
                                case "-":
                                    Y = W - Y;
                                    break;
                                case "*":
                                    Y = W * Y;
                                    break;
                                case "/":
                                    Y = W / Y
                            }
                            h[A] = {
                                rootPropertyValue: U,
                                startValue: W,
                                currentValue: W,
                                endValue: Y,
                                unitType: H,
                                easing: z
                            }, y.debug && console.log("tweensContainer (" + A + "): " + JSON.stringify(h[A]), o)
                        } else y.debug && console.log("Skipping [" + j + "] due to a lack of browser support.")
                    }
                    h.element = o
                }
                h.element && (x.Values.addClass(o, "animating"), V.push(h), r(o).tweensContainer = h, r(o).opts = c, r(o).isAnimating = !0, k === C - 1 ? (y.State.calls.length > 1e4 && (y.State.calls = a(y.State.calls)), y.State.calls.push([V, w, c, null, E.resolver]), y.State.isTicking === !1 && (y.State.isTicking = !0, l())) : k++)
            }
            var o = this,
                c = v.extend({}, y.defaults, S),
                h = {};
            if (r(o) === n && v.data(o, u, {
                    isSVG: m.isSVG(o),
                    isAnimating: !1,
                    computedStyle: null,
                    tweensContainer: null,
                    rootPropertyValueCache: {},
                    transformCache: {}
                }), parseFloat(c.delay) && c.queue !== !1 && v.queue(o, c.queue, function(t) {
                    y.velocityQueueEntryFlag = !0, r(o).delayTimer = {
                        setTimeout: setTimeout(t, parseFloat(c.delay)),
                        next: t
                    }
                }), y.mock === !0) c.duration = 1;
            else switch (c.duration.toString().toLowerCase()) {
                case "fast":
                    c.duration = 200;
                    break;
                case "normal":
                    c.duration = d;
                    break;
                case "slow":
                    c.duration = 600;
                    break;
                default:
                    c.duration = parseFloat(c.duration) || 1
            }
            c.easing = s(c.easing, c.duration), c.begin && !m.isFunction(c.begin) && (c.begin = null), c.progress && !m.isFunction(c.progress) && (c.progress = null), c.complete && !m.isFunction(c.complete) && (c.complete = null), c.display && (c.display = c.display.toString().toLowerCase(), "auto" === c.display && (c.display = y.CSS.Values.getDisplayType(o))), c.visibility && (c.visibility = c.visibility.toString().toLowerCase()), c.mobileHA = c.mobileHA && y.State.isMobile && !y.State.isGingerbread, c.queue === !1 ? c.delay ? setTimeout(t, c.delay) : t() : v.queue(o, c.queue, function(e, i) {
                return i === !0 ? (E.promise && E.resolver(w), !0) : (y.velocityQueueEntryFlag = !0, void t(e))
            }), "" !== c.queue && "fx" !== c.queue || "inprogress" === v.queue(o)[0] || v.dequeue(o)
        }
        var h, f, g, w, b, S, T = arguments[0] && (v.isPlainObject(arguments[0].properties) && !arguments[0].properties.names || m.isString(arguments[0].properties));
        if (m.isWrapped(this) ? (h = !1, g = 0, w = this, f = this) : (h = !0, g = 1, w = T ? arguments[0].elements : arguments[0]), w = m.isWrapped(w) ? [].slice.call(w) : w) {
            T ? (b = arguments[0].properties, S = arguments[0].options) : (b = arguments[g], S = arguments[g + 1]);
            var C = m.isArray(w) || m.isNodeList(w) ? w.length : 1,
                k = 0;
            if ("stop" !== b && !v.isPlainObject(S)) {
                var D = g + 1;
                S = {};
                for (var P = D; P < arguments.length; P++) !m.isArray(arguments[P]) && /^\d/.test(arguments[P]) ? S.duration = parseFloat(arguments[P]) : m.isString(arguments[P]) || m.isArray(arguments[P]) ? S.easing = arguments[P] : m.isFunction(arguments[P]) && (S.complete = arguments[P])
            }
            var E = {
                promise: null,
                resolver: null,
                rejecter: null
            };
            h && y.Promise && (E.promise = new y.Promise(function(t, e) {
                E.resolver = t, E.rejecter = e
            }));
            var _;
            switch (b) {
                case "scroll":
                    _ = "scroll";
                    break;
                case "reverse":
                    _ = "reverse";
                    break;
                case "stop":
                    v.each(m.isNode(w) ? [w] : w, function(t, e) {
                        r(e) && r(e).delayTimer && (clearTimeout(r(e).delayTimer.setTimeout), r(e).delayTimer.next(), delete r(e).delayTimer)
                    });
                    var O = [];
                    return v.each(y.State.calls, function(t, e) {
                        e !== !1 && v.each(m.isNode(e[1]) ? [e[1]] : e[1], function(e, i) {
                            v.each(m.isNode(w) ? [w] : w, function(e, n) {
                                if (n === i) {
                                    if (r(n) && v.each(r(n).tweensContainer, function(t, e) {
                                            e.endValue = e.currentValue
                                        }), S === !0 || m.isString(S)) {
                                        var a = m.isString(S) ? S : "";
                                        v.each(v.queue(n, a), function(t, e) {
                                            m.isFunction(e) && e(null, !0)
                                        }), v.queue(n, a, [])
                                    }
                                    O.push(t)
                                }
                            })
                        })
                    }), v.each(O, function(t, e) {
                        c(e, !0)
                    }), E.promise && E.resolver(w), t();
                default:
                    if (!v.isPlainObject(b) || v.isEmptyObject(b)) {
                        if (m.isString(b) && y.Sequences[b]) {
                            var M = S.duration;
                            return S.backwards === !0 && (w = (w.jquery ? [].slice.call(w) : w).reverse()), v.each(w, function(t, e) {
                                parseFloat(S.stagger) ? S.delay = parseFloat(S.stagger) * t : m.isFunction(S.stagger) && (S.delay = S.stagger.call(e, t, C)), S.drag && (S.duration = parseFloat(M) || (/^(callout|transition)/.test(b) ? 1e3 : d), S.duration = Math.max(S.duration * (S.backwards ? 1 - t / C : (t + 1) / C), .75 * S.duration, 200)), y.Sequences[b].call(e, e, S || {}, t, C, w, E.promise ? E : n)
                            }), t()
                        }
                        var I = "Velocity: First argument (" + b + ") was not a property map, a known action, or a registered sequence. Aborting.";
                        return E.promise ? E.rejecter(new Error(I)) : console.log(I), t()
                    }
                    _ = "start"
            }
            var L = {
                    lastParent: null,
                    lastPosition: null,
                    lastFontSize: null,
                    lastPercentToPxWidth: null,
                    lastPercentToPxHeight: null,
                    lastEmToPx: null,
                    remToPx: null,
                    vwToPx: null,
                    vhToPx: null
                },
                V = [];
            v.each(m.isNode(w) ? [w] : w, function(t, e) {
                m.isNode(e) && o.call(e)
            });
            var N, A = v.extend({}, y.defaults, S);
            if (A.loop = parseInt(A.loop), N = 2 * A.loop - 1, A.loop)
                for (var R = 0; N > R; R++) {
                    var Y = {
                        delay: A.delay
                    };
                    A.complete && R === N - 1 && (Y.complete = A.complete), y.animate(w, "reverse", Y)
                }
            return t()
        }
    };
    var S = e.jQuery || e.Zepto;
    S && (S.fn.velocity = y.animate, S.fn.velocity.defaults = y.defaults), "undefined" != typeof define && define.amd ? define(function() {
        return y
    }) : "undefined" != typeof module && module.exports && (module.exports = y), v.each(["Down", "Up"], function(t, e) {
        y.Sequences["slide" + e] = function(t, i) {
            var n = v.extend({}, i),
                a = {
                    height: null,
                    marginTop: null,
                    marginBottom: null,
                    paddingTop: null,
                    paddingBottom: null,
                    overflow: null,
                    overflowX: null,
                    overflowY: null
                },
                r = n.begin,
                o = n.complete,
                s = !1;
            null !== n.display && (n.display = "Down" === e ? n.display || "auto" : n.display || "none"), n.begin = function() {
                function i() {
                    a.height = parseFloat(y.CSS.getPropertyValue(t, "height")), t.style.height = "auto", y.CSS.getPropertyValue(t, "height") === a.height && (s = !0), y.CSS.setPropertyValue(t, "height", a.height + "px")
                }
                if ("Down" === e) {
                    a.overflow = [y.CSS.getPropertyValue(t, "overflow"), 0], a.overflowX = [y.CSS.getPropertyValue(t, "overflowX"), 0], a.overflowY = [y.CSS.getPropertyValue(t, "overflowY"), 0], t.style.overflow = "hidden", t.style.overflowX = "visible", t.style.overflowY = "hidden", i();
                    for (var n in a)
                        if (!/^overflow/.test(n)) {
                            var o = y.CSS.getPropertyValue(t, n);
                            "height" === n && (o = parseFloat(o)), a[n] = [o, 0]
                        }
                } else {
                    i();
                    for (var n in a) {
                        var o = y.CSS.getPropertyValue(t, n);
                        "height" === n && (o = parseFloat(o)), a[n] = [0, o]
                    }
                    t.style.overflow = "hidden", t.style.overflowX = "visible", t.style.overflowY = "hidden"
                }
                r && r.call(t, t)
            }, n.complete = function(t) {
                var i = "Down" === e ? 0 : 1;
                s === !0 ? a.height[i] = "auto" : a.height[i] += "px";
                for (var n in a) t.style[n] = a[n][i];
                o && o.call(t, t)
            }, y.animate(t, a, n)
        }
    }), v.each(["In", "Out"], function(t, e) {
        y.Sequences["fade" + e] = function(t, i, n, a) {
            var r = v.extend({}, i),
                o = {
                    opacity: "In" === e ? 1 : 0
                };
            n !== a - 1 && (r.complete = r.begin = null), null !== r.display && (r.display = r.display || ("In" === e ? "auto" : "none")), y.animate(this, o, r)
        }
    })
}(window.jQuery || window.Zepto || window, window, document),
/*!
 * velocity.ui.js: UI effects pack for Velocity. Load this file after jquery.velocity.js.
 * @version 4.0.5
 * @docs http://velocityjs.org/#uiPack
 * @support <=IE8: Callouts will have no effect, and transitions will simply fade in/out. IE9/Android 2.3: Most effects are fully supported, the rest fade in/out. All other browsers: Full support.
 * @license Copyright Julian Shapiro. MIT License: http://en.wikipedia.org/wiki/MIT_License
 * @license Indicated portions adapted from Animate.css, copyright Daniel Eden. MIT License: http://en.wikipedia.org/wiki/MIT_License
 * @license Indicated portions adapted from Magic.css, copyright Christian Pucci. MIT License: http://en.wikipedia.org/wiki/MIT_License
 */
! function() {
    var t = window.jQuery || window.Zepto || window;
    if (!t.Velocity || !t.Velocity.Utilities) return void console.log("Velocity UI Pack: Velocity must be loaded first. Aborting.");
    if (!t.Velocity.version || t.Velocity.version.major <= 0 && t.Velocity.version.minor <= 5 && t.Velocity.version.patch <= 2) {
        var e = "Velocity UI Pack: You need to update Velocity (jquery.velocity.js) to a newer version. Visit http://github.com/julianshapiro/velocity.";
        throw alert(e), new Error(e)
    }
    t.Velocity.RegisterUI = function(e, i) {
        function n(e, i, n, a) {
            var r = 0,
                o;
            t.Velocity.Utilities.each(e, function(e, i) {
                a && (n += e * a), o = i.parentNode, t.Velocity.Utilities.each(["height", "paddingTop", "paddingBottom", "marginTop", "marginBottom"], function(e, n) {
                    r += parseFloat(t.Velocity.CSS.getPropertyValue(i, n))
                })
            }), t.Velocity.animate(o, {
                height: ("In" === i ? "+" : "-") + "=" + r
            }, {
                queue: !1,
                easing: "ease-in-out",
                duration: n * ("In" === i ? .6 : 1)
            })
        }
        t.Velocity.Sequences[e] = function(a, r, o, s, l, c) {
            function u() {
                void 0 === r.display && /Out$/.test(e) && t.Velocity.Utilities.each(l, function(e, i) {
                    t.Velocity.CSS.setPropertyValue(i, "display", "none")
                }), r.complete && r.complete.call(l, l), c && c.resolver(l || a)
            }
            for (var d = o === s - 1, h = 0; h < i.calls.length; h++) {
                var p = i.calls[h],
                    f = p[0],
                    g = r.duration || i.defaultDuration || 1e3,
                    m = p[1],
                    v = p[2] || {},
                    y = {};
                if (y.duration = g * (m || 1), y.queue = r.queue || "", y.easing = v.easing || "ease", y.delay = v.delay || 0, 0 === h) {
                    if (y.delay += r.delay || 0, 0 === o && (y.begin = function() {
                            r.begin && r.begin.call(l, l);
                            var t = e.match(/(In|Out)$/);
                            r.animateParentHeight && t && n(l, t[0], g + y.delay, r.stagger)
                        }), null !== r.display)
                        if (r.display && "none" !== r.display) y.display = r.display;
                        else if (/In$/.test(e)) {
                        var w = t.Velocity.CSS.Values.getDisplayType(a);
                        y.display = "inline" === w ? "inline-block" : w
                    }
                    r.visibility && "hidden" !== r.visibility && (y.visibility = r.visibility)
                }
                h === i.calls.length - 1 && (y.complete = function() {
                    if (i.reset) {
                        for (var e in i.reset) {
                            var n = i.reset[e];
                            ("string" == typeof n || "number" == typeof n) && (i.reset[e] = [i.reset[e], i.reset[e]])
                        }
                        var r = {
                            duration: 0,
                            queue: !1
                        };
                        d && (r.complete = u), t.Velocity.animate(a, i.reset, r)
                    } else d && u()
                }, "hidden" === r.visibility && (y.visibility = r.visibility)), t.Velocity.animate(a, f, y)
            }
        }
    }, t.Velocity.RegisterUI.packagedEffects = {
        "callout.bounce": {
            defaultDuration: 550,
            calls: [
                [{
                    translateY: -30
                }, .25],
                [{
                    translateY: 0
                }, .125],
                [{
                    translateY: -15
                }, .125],
                [{
                    translateY: 0
                }, .25]
            ]
        },
        "callout.shake": {
            defaultDuration: 800,
            calls: [
                [{
                    translateX: -11
                }, .125],
                [{
                    translateX: 11
                }, .125],
                [{
                    translateX: -11
                }, .125],
                [{
                    translateX: 11
                }, .125],
                [{
                    translateX: -11
                }, .125],
                [{
                    translateX: 11
                }, .125],
                [{
                    translateX: -11
                }, .125],
                [{
                    translateX: 0
                }, .125]
            ]
        },
        "callout.flash": {
            defaultDuration: 1100,
            calls: [
                [{
                    opacity: [0, "easeInOutQuad", 1]
                }, .25],
                [{
                    opacity: [1, "easeInOutQuad"]
                }, .25],
                [{
                    opacity: [0, "easeInOutQuad"]
                }, .25],
                [{
                    opacity: [1, "easeInOutQuad"]
                }, .25]
            ]
        },
        "callout.pulse": {
            defaultDuration: 825,
            calls: [
                [{
                    scaleX: 1.1,
                    scaleY: 1.1
                }, .5],
                [{
                    scaleX: 1,
                    scaleY: 1
                }, .5]
            ]
        },
        "callout.swing": {
            defaultDuration: 950,
            calls: [
                [{
                    rotateZ: 15
                }, .2],
                [{
                    rotateZ: -10
                }, .2],
                [{
                    rotateZ: 5
                }, .2],
                [{
                    rotateZ: -5
                }, .2],
                [{
                    rotateZ: 0
                }, .2]
            ]
        },
        "callout.tada": {
            defaultDuration: 1e3,
            calls: [
                [{
                    scaleX: .9,
                    scaleY: .9,
                    rotateZ: -3
                }, .1],
                [{
                    scaleX: 1.1,
                    scaleY: 1.1,
                    rotateZ: 3
                }, .1],
                [{
                    scaleX: 1.1,
                    scaleY: 1.1,
                    rotateZ: -3
                }, .1],
                ["reverse", .125],
                ["reverse", .125],
                ["reverse", .125],
                ["reverse", .125],
                ["reverse", .125],
                [{
                    scaleX: 1,
                    scaleY: 1,
                    rotateZ: 0
                }, .2]
            ]
        },
        "transition.fadeIn": {
            defaultDuration: 500,
            calls: [
                [{
                    opacity: [1, 0]
                }]
            ]
        },
        "transition.fadeOut": {
            defaultDuration: 500,
            calls: [
                [{
                    opacity: [0, 1]
                }]
            ]
        },
        "transition.flipXIn": {
            defaultDuration: 700,
            calls: [
                [{
                    opacity: [1, 0],
                    transformPerspective: [800, 800],
                    rotateY: [0, -55]
                }]
            ],
            reset: {
                transformPerspective: 0
            }
        },
        "transition.flipXOut": {
            defaultDuration: 700,
            calls: [
                [{
                    opacity: [0, 1],
                    transformPerspective: [800, 800],
                    rotateY: 55
                }]
            ],
            reset: {
                transformPerspective: 0,
                rotateY: 0
            }
        },
        "transition.flipYIn": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [1, 0],
                    transformPerspective: [800, 800],
                    rotateX: [0, -45]
                }]
            ],
            reset: {
                transformPerspective: 0
            }
        },
        "transition.flipYOut": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [0, 1],
                    transformPerspective: [800, 800],
                    rotateX: 25
                }]
            ],
            reset: {
                transformPerspective: 0,
                rotateX: 0
            }
        },
        "transition.flipBounceXIn": {
            defaultDuration: 900,
            calls: [
                [{
                    opacity: [.725, 0],
                    transformPerspective: [400, 400],
                    rotateY: [-10, 90]
                }, .5],
                [{
                    opacity: .8,
                    rotateY: 10
                }, .25],
                [{
                    opacity: 1,
                    rotateY: 0
                }, .25]
            ],
            reset: {
                transformPerspective: 0
            }
        },
        "transition.flipBounceXOut": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [.9, 1],
                    transformPerspective: [400, 400],
                    rotateY: -10
                }, .5],
                [{
                    opacity: 0,
                    rotateY: 90
                }, .5]
            ],
            reset: {
                transformPerspective: 0,
                rotateY: 0
            }
        },
        "transition.flipBounceYIn": {
            defaultDuration: 850,
            calls: [
                [{
                    opacity: [.725, 0],
                    transformPerspective: [400, 400],
                    rotateX: [-10, 90]
                }, .5],
                [{
                    opacity: .8,
                    rotateX: 10
                }, .25],
                [{
                    opacity: 1,
                    rotateX: 0
                }, .25]
            ],
            reset: {
                transformPerspective: 0
            }
        },
        "transition.flipBounceYOut": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [.9, 1],
                    transformPerspective: [400, 400],
                    rotateX: -15
                }, .5],
                [{
                    opacity: 0,
                    rotateX: 90
                }, .5]
            ],
            reset: {
                transformPerspective: 0,
                rotateX: 0
            }
        },
        "transition.swoopIn": {
            defaultDuration: 850,
            calls: [
                [{
                    opacity: [1, 0],
                    transformOriginX: ["100%", "50%"],
                    transformOriginY: ["100%", "100%"],
                    scaleX: [1, 0],
                    scaleY: [1, 0],
                    translateX: [0, -700],
                    translateZ: 0
                }]
            ],
            reset: {
                transformOriginX: "50%",
                transformOriginY: "50%"
            }
        },
        "transition.swoopOut": {
            defaultDuration: 850,
            calls: [
                [{
                    opacity: [0, 1],
                    transformOriginX: ["50%", "100%"],
                    transformOriginY: ["100%", "100%"],
                    scaleX: 0,
                    scaleY: 0,
                    translateX: -700,
                    translateZ: 0
                }]
            ],
            reset: {
                transformOriginX: "50%",
                transformOriginY: "50%",
                scaleX: 1,
                scaleY: 1,
                translateX: 0
            }
        },
        "transition.whirlIn": {
            defaultDuration: 900,
            calls: [
                [{
                    opacity: [1, 0],
                    transformOriginX: ["50%", "50%"],
                    transformOriginY: ["50%", "50%"],
                    scaleX: [1, 0],
                    scaleY: [1, 0],
                    rotateY: [0, 160]
                }]
            ]
        },
        "transition.whirlOut": {
            defaultDuration: 900,
            calls: [
                [{
                    opacity: [0, 1],
                    transformOriginX: ["50%", "50%"],
                    transformOriginY: ["50%", "50%"],
                    scaleX: 0,
                    scaleY: 0,
                    rotateY: 160
                }]
            ],
            reset: {
                scaleX: 1,
                scaleY: 1,
                rotateY: 0
            }
        },
        "transition.shrinkIn": {
            defaultDuration: 700,
            calls: [
                [{
                    opacity: [1, 0],
                    transformOriginX: ["50%", "50%"],
                    transformOriginY: ["50%", "50%"],
                    scaleX: [1, 1.5],
                    scaleY: [1, 1.5],
                    translateZ: 0
                }]
            ]
        },
        "transition.shrinkOut": {
            defaultDuration: 650,
            calls: [
                [{
                    opacity: [0, 1],
                    transformOriginX: ["50%", "50%"],
                    transformOriginY: ["50%", "50%"],
                    scaleX: 1.3,
                    scaleY: 1.3,
                    translateZ: 0
                }]
            ],
            reset: {
                scaleX: 1,
                scaleY: 1
            }
        },
        "transition.expandIn": {
            defaultDuration: 700,
            calls: [
                [{
                    opacity: [1, 0],
                    transformOriginX: ["50%", "50%"],
                    transformOriginY: ["50%", "50%"],
                    scaleX: [1, .625],
                    scaleY: [1, .625],
                    translateZ: 0
                }]
            ]
        },
        "transition.expandOut": {
            defaultDuration: 700,
            calls: [
                [{
                    opacity: [0, 1],
                    transformOriginX: ["50%", "50%"],
                    transformOriginY: ["50%", "50%"],
                    scaleX: .5,
                    scaleY: .5,
                    translateZ: 0
                }]
            ],
            reset: {
                scaleX: 1,
                scaleY: 1
            }
        },
        "transition.bounceIn": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [1, 0],
                    scaleX: [1.05, .3],
                    scaleY: [1.05, .3]
                }, .4],
                [{
                    scaleX: .9,
                    scaleY: .9,
                    translateZ: 0
                }, .2],
                [{
                    scaleX: 1,
                    scaleY: 1
                }, .5]
            ]
        },
        "transition.bounceOut": {
            defaultDuration: 800,
            calls: [
                [{
                    scaleX: .95,
                    scaleY: .95
                }, .4],
                [{
                    scaleX: 1.1,
                    scaleY: 1.1,
                    translateZ: 0
                }, .4],
                [{
                    opacity: [0, 1],
                    scaleX: .3,
                    scaleY: .3
                }, .2]
            ],
            reset: {
                scaleX: 1,
                scaleY: 1
            }
        },
        "transition.bounceUpIn": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [1, 0],
                    translateY: [-30, 1e3]
                }, .6, {
                    easing: "easeOutCirc"
                }],
                [{
                    translateY: 10
                }, .2],
                [{
                    translateY: 0
                }, .2]
            ]
        },
        "transition.bounceUpOut": {
            defaultDuration: 1e3,
            calls: [
                [{
                    translateY: 20
                }, .2],
                [{
                    opacity: [0, "easeInCirc", 1],
                    translateY: -1e3
                }, .8]
            ],
            reset: {
                translateY: 0
            }
        },
        "transition.bounceDownIn": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [1, 0],
                    translateY: [30, -1e3]
                }, .6, {
                    easing: "easeOutCirc"
                }],
                [{
                    translateY: -10
                }, .2],
                [{
                    translateY: 0
                }, .2]
            ]
        },
        "transition.bounceDownOut": {
            defaultDuration: 1e3,
            calls: [
                [{
                    translateY: -20
                }, .2],
                [{
                    opacity: [0, "easeInCirc", 1],
                    translateY: 1e3
                }, .8]
            ],
            reset: {
                translateY: 0
            }
        },
        "transition.bounceLeftIn": {
            defaultDuration: 750,
            calls: [
                [{
                    opacity: [1, 0],
                    translateX: [30, -1250]
                }, .6, {
                    easing: "easeOutCirc"
                }],
                [{
                    translateX: -10
                }, .2],
                [{
                    translateX: 0
                }, .2]
            ]
        },
        "transition.bounceLeftOut": {
            defaultDuration: 750,
            calls: [
                [{
                    translateX: 30
                }, .2],
                [{
                    opacity: [0, "easeInCirc", 1],
                    translateX: -1250
                }, .8]
            ],
            reset: {
                translateX: 0
            }
        },
        "transition.bounceRightIn": {
            defaultDuration: 750,
            calls: [
                [{
                    opacity: [1, 0],
                    translateX: [-30, 1250]
                }, .6, {
                    easing: "easeOutCirc"
                }],
                [{
                    translateX: 10
                }, .2],
                [{
                    translateX: 0
                }, .2]
            ]
        },
        "transition.bounceRightOut": {
            defaultDuration: 750,
            calls: [
                [{
                    translateX: -30
                }, .2],
                [{
                    opacity: [0, "easeInCirc", 1],
                    translateX: 1250
                }, .8]
            ],
            reset: {
                translateX: 0
            }
        },
        "transition.slideUpIn": {
            defaultDuration: 900,
            calls: [
                [{
                    opacity: [1, 0],
                    translateY: [0, 20],
                    translateZ: 0
                }]
            ]
        },
        "transition.slideUpOut": {
            defaultDuration: 900,
            calls: [
                [{
                    opacity: [0, 1],
                    translateY: -20,
                    translateZ: 0
                }]
            ],
            reset: {
                translateY: 0
            }
        },
        "transition.slideDownIn": {
            defaultDuration: 900,
            calls: [
                [{
                    opacity: [1, 0],
                    translateY: [0, -20],
                    translateZ: 0
                }]
            ]
        },
        "transition.slideDownOut": {
            defaultDuration: 900,
            calls: [
                [{
                    opacity: [0, 1],
                    translateY: 20,
                    translateZ: 0
                }]
            ],
            reset: {
                translateY: 0
            }
        },
        "transition.slideLeftIn": {
            defaultDuration: 1e3,
            calls: [
                [{
                    opacity: [1, 0],
                    translateX: [0, -20],
                    translateZ: 0
                }]
            ]
        },
        "transition.slideLeftOut": {
            defaultDuration: 1050,
            calls: [
                [{
                    opacity: [0, 1],
                    translateX: -20,
                    translateZ: 0
                }]
            ],
            reset: {
                translateX: 0
            }
        },
        "transition.slideRightIn": {
            defaultDuration: 1e3,
            calls: [
                [{
                    opacity: [1, 0],
                    translateX: [0, 20],
                    translateZ: 0
                }]
            ]
        },
        "transition.slideRightOut": {
            defaultDuration: 1050,
            calls: [
                [{
                    opacity: [0, 1],
                    translateX: 20,
                    translateZ: 0
                }]
            ],
            reset: {
                translateX: 0
            }
        },
        "transition.slideUpBigIn": {
            defaultDuration: 850,
            calls: [
                [{
                    opacity: [1, 0],
                    translateY: [0, 75],
                    translateZ: 0
                }]
            ]
        },
        "transition.slideUpBigOut": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [0, 1],
                    translateY: -75,
                    translateZ: 0
                }]
            ],
            reset: {
                translateY: 0
            }
        },
        "transition.slideDownBigIn": {
            defaultDuration: 850,
            calls: [
                [{
                    opacity: [1, 0],
                    translateY: [0, -75],
                    translateZ: 0
                }]
            ]
        },
        "transition.slideDownBigOut": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [0, 1],
                    translateY: 75,
                    translateZ: 0
                }]
            ],
            reset: {
                translateY: 0
            }
        },
        "transition.slideLeftBigIn": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [1, 0],
                    translateX: [0, -75],
                    translateZ: 0
                }]
            ]
        },
        "transition.slideLeftBigOut": {
            defaultDuration: 750,
            calls: [
                [{
                    opacity: [0, 1],
                    translateX: -75,
                    translateZ: 0
                }]
            ],
            reset: {
                translateX: 0
            }
        },
        "transition.slideRightBigIn": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [1, 0],
                    translateX: [0, 75],
                    translateZ: 0
                }]
            ]
        },
        "transition.slideRightBigOut": {
            defaultDuration: 750,
            calls: [
                [{
                    opacity: [0, 1],
                    translateX: 75,
                    translateZ: 0
                }]
            ],
            reset: {
                translateX: 0
            }
        },
        "transition.perspectiveUpIn": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [1, 0],
                    transformPerspective: [800, 800],
                    transformOriginX: [0, 0],
                    transformOriginY: ["100%", "100%"],
                    rotateX: [0, -180]
                }]
            ],
            reset: {
                transformPerspective: 0,
                transformOriginX: "50%",
                transformOriginY: "50%"
            }
        },
        "transition.perspectiveUpOut": {
            defaultDuration: 850,
            calls: [
                [{
                    opacity: [0, 1],
                    transformPerspective: [800, 800],
                    transformOriginX: [0, 0],
                    transformOriginY: ["100%", "100%"],
                    rotateX: -180
                }]
            ],
            reset: {
                transformPerspective: 0,
                transformOriginX: "50%",
                transformOriginY: "50%",
                rotateX: 0
            }
        },
        "transition.perspectiveDownIn": {
            defaultDuration: 800,
            calls: [
                [{
                    opacity: [1, 0],
                    transformPerspective: [800, 800],
                    transformOriginX: [0, 0],
                    transformOriginY: [0, 0],
                    rotateX: [0, 180]
                }]
            ],
            reset: {
                transformPerspective: 0,
                transformOriginX: "50%",
                transformOriginY: "50%"
            }
        },
        "transition.perspectiveDownOut": {
            defaultDuration: 850,
            calls: [
                [{
                    opacity: [0, 1],
                    transformPerspective: [800, 800],
                    transformOriginX: [0, 0],
                    transformOriginY: [0, 0],
                    rotateX: 180
                }]
            ],
            reset: {
                transformPerspective: 0,
                transformOriginX: "50%",
                transformOriginY: "50%",
                rotateX: 0
            }
        },
        "transition.perspectiveLeftIn": {
            defaultDuration: 950,
            calls: [
                [{
                    opacity: [1, 0],
                    transformPerspective: [2e3, 2e3],
                    transformOriginX: [0, 0],
                    transformOriginY: [0, 0],
                    rotateY: [0, -180]
                }]
            ],
            reset: {
                transformPerspective: 0,
                transformOriginX: "50%",
                transformOriginY: "50%"
            }
        },
        "transition.perspectiveLeftOut": {
            defaultDuration: 950,
            calls: [
                [{
                    opacity: [0, 1],
                    transformPerspective: [2e3, 2e3],
                    transformOriginX: [0, 0],
                    transformOriginY: [0, 0],
                    rotateY: -180
                }]
            ],
            reset: {
                transformPerspective: 0,
                transformOriginX: "50%",
                transformOriginY: "50%",
                rotateY: 0
            }
        },
        "transition.perspectiveRightIn": {
            defaultDuration: 950,
            calls: [
                [{
                    opacity: [1, 0],
                    transformPerspective: [2e3, 2e3],
                    transformOriginX: ["100%", "100%"],
                    transformOriginY: [0, 0],
                    rotateY: [0, 180]
                }]
            ],
            reset: {
                transformPerspective: 0,
                transformOriginX: "50%",
                transformOriginY: "50%"
            }
        },
        "transition.perspectiveRightOut": {
            defaultDuration: 950,
            calls: [
                [{
                    opacity: [0, 1],
                    transformPerspective: [2e3, 2e3],
                    transformOriginX: ["100%", "100%"],
                    transformOriginY: [0, 0],
                    rotateY: 180
                }]
            ],
            reset: {
                transformPerspective: 0,
                transformOriginX: "50%",
                transformOriginY: "50%",
                rotateY: 0
            }
        }
    };
    for (var i in t.Velocity.RegisterUI.packagedEffects) t.Velocity.RegisterUI(i, t.Velocity.RegisterUI.packagedEffects[i])
}(), window.onload = function() {
        tamingselect()
    },
    function() {
        var t = [].indexOf || function(t) {
                for (var e = 0, i = this.length; i > e; e++)
                    if (e in this && this[e] === t) return e;
                return -1
            },
            e = [].slice;
        ! function(t, e) {
            return "function" == typeof define && define.amd ? define("waypoints", ["jquery"], function(i) {
                return e(i, t)
            }) : e(t.jQuery, t)
        }(window, function(i, n) {
            var a, r, o, s, l, c, u, d, h, p, f, g, m, v, y, w;
            return a = i(n), d = t.call(n, "ontouchstart") >= 0, s = {
                horizontal: {},
                vertical: {}
            }, l = 1, u = {}, c = "waypoints-context-id", f = "resize.waypoints", g = "scroll.waypoints", m = 1, v = "waypoints-waypoint-ids", y = "waypoint", w = "waypoints", r = function() {
                function t(t) {
                    var e = this;
                    this.$element = t, this.element = t[0], this.didResize = !1, this.didScroll = !1, this.id = "context" + l++, this.oldScroll = {
                        x: t.scrollLeft(),
                        y: t.scrollTop()
                    }, this.waypoints = {
                        horizontal: {},
                        vertical: {}
                    }, this.element[c] = this.id, u[this.id] = this, t.bind(g, function() {
                        var t;
                        return e.didScroll || d ? void 0 : (e.didScroll = !0, t = function() {
                            return e.doScroll(), e.didScroll = !1
                        }, n.setTimeout(t, i[w].settings.scrollThrottle))
                    }), t.bind(f, function() {
                        var t;
                        return e.didResize ? void 0 : (e.didResize = !0, t = function() {
                            return i[w]("refresh"), e.didResize = !1
                        }, n.setTimeout(t, i[w].settings.resizeThrottle))
                    })
                }
                return t.prototype.doScroll = function() {
                    var t, e = this;
                    return t = {
                        horizontal: {
                            newScroll: this.$element.scrollLeft(),
                            oldScroll: this.oldScroll.x,
                            forward: "right",
                            backward: "left"
                        },
                        vertical: {
                            newScroll: this.$element.scrollTop(),
                            oldScroll: this.oldScroll.y,
                            forward: "down",
                            backward: "up"
                        }
                    }, !d || t.vertical.oldScroll && t.vertical.newScroll || i[w]("refresh"), i.each(t, function(t, n) {
                        var a, r, o;
                        return o = [], r = n.newScroll > n.oldScroll, a = r ? n.forward : n.backward, i.each(e.waypoints[t], function(t, e) {
                            var i, a;
                            return n.oldScroll < (i = e.offset) && i <= n.newScroll ? o.push(e) : n.newScroll < (a = e.offset) && a <= n.oldScroll ? o.push(e) : void 0
                        }), o.sort(function(t, e) {
                            return t.offset - e.offset
                        }), r || o.reverse(), i.each(o, function(t, e) {
                            return e.options.continuous || t === o.length - 1 ? e.trigger([a]) : void 0
                        })
                    }), this.oldScroll = {
                        x: t.horizontal.newScroll,
                        y: t.vertical.newScroll
                    }
                }, t.prototype.refresh = function() {
                    var t, e, n, a = this;
                    return n = i.isWindow(this.element), e = this.$element.offset(), this.doScroll(), t = {
                        horizontal: {
                            contextOffset: n ? 0 : e.left,
                            contextScroll: n ? 0 : this.oldScroll.x,
                            contextDimension: this.$element.width(),
                            oldScroll: this.oldScroll.x,
                            forward: "right",
                            backward: "left",
                            offsetProp: "left"
                        },
                        vertical: {
                            contextOffset: n ? 0 : e.top,
                            contextScroll: n ? 0 : this.oldScroll.y,
                            contextDimension: n ? i[w]("viewportHeight") : this.$element.height(),
                            oldScroll: this.oldScroll.y,
                            forward: "down",
                            backward: "up",
                            offsetProp: "top"
                        }
                    }, i.each(t, function(t, e) {
                        return i.each(a.waypoints[t], function(t, n) {
                            var a, r, o, s, l;
                            return a = n.options.offset, o = n.offset, r = i.isWindow(n.element) ? 0 : n.$element.offset()[e.offsetProp], i.isFunction(a) ? a = a.apply(n.element) : "string" == typeof a && (a = parseFloat(a), n.options.offset.indexOf("%") > -1 && (a = Math.ceil(e.contextDimension * a / 100))), n.offset = r - e.contextOffset + e.contextScroll - a, n.options.onlyOnScroll && null != o || !n.enabled ? void 0 : null !== o && o < (s = e.oldScroll) && s <= n.offset ? n.trigger([e.backward]) : null !== o && o > (l = e.oldScroll) && l >= n.offset ? n.trigger([e.forward]) : null === o && e.oldScroll >= n.offset ? n.trigger([e.forward]) : void 0
                        })
                    })
                }, t.prototype.checkEmpty = function() {
                    return i.isEmptyObject(this.waypoints.horizontal) && i.isEmptyObject(this.waypoints.vertical) ? (this.$element.unbind([f, g].join(" ")), delete u[this.id]) : void 0
                }, t
            }(), o = function() {
                function t(t, e, n) {
                    var a, r;
                    "bottom-in-view" === n.offset && (n.offset = function() {
                        var t;
                        return t = i[w]("viewportHeight"), i.isWindow(e.element) || (t = e.$element.height()), t - i(this).outerHeight()
                    }), this.$element = t, this.element = t[0], this.axis = n.horizontal ? "horizontal" : "vertical", this.callback = n.handler, this.context = e, this.enabled = n.enabled, this.id = "waypoints" + m++, this.offset = null, this.options = n, e.waypoints[this.axis][this.id] = this, s[this.axis][this.id] = this, a = null != (r = this.element[v]) ? r : [], a.push(this.id), this.element[v] = a
                }
                return t.prototype.trigger = function(t) {
                    return this.enabled ? (null != this.callback && this.callback.apply(this.element, t), this.options.triggerOnce ? this.destroy() : void 0) : void 0
                }, t.prototype.disable = function() {
                    return this.enabled = !1
                }, t.prototype.enable = function() {
                    return this.context.refresh(), this.enabled = !0
                }, t.prototype.destroy = function() {
                    return delete s[this.axis][this.id], delete this.context.waypoints[this.axis][this.id], this.context.checkEmpty()
                }, t.getWaypointsByElement = function(t) {
                    var e, n;
                    return (n = t[v]) ? (e = i.extend({}, s.horizontal, s.vertical), i.map(n, function(t) {
                        return e[t]
                    })) : []
                }, t
            }(), p = {
                init: function(t, e) {
                    var n;
                    return e = i.extend({}, i.fn[y].defaults, e), null == (n = e.handler) && (e.handler = t), this.each(function() {
                        var t, n, a, s;
                        return t = i(this), a = null != (s = e.context) ? s : i.fn[y].defaults.context, i.isWindow(a) || (a = t.closest(a)), a = i(a), n = u[a[0][c]], n || (n = new r(a)), new o(t, n, e)
                    }), i[w]("refresh"), this
                },
                disable: function() {
                    return p._invoke.call(this, "disable")
                },
                enable: function() {
                    return p._invoke.call(this, "enable")
                },
                destroy: function() {
                    return p._invoke.call(this, "destroy")
                },
                prev: function(t, e) {
                    return p._traverse.call(this, t, e, function(t, e, i) {
                        return e > 0 ? t.push(i[e - 1]) : void 0
                    })
                },
                next: function(t, e) {
                    return p._traverse.call(this, t, e, function(t, e, i) {
                        return e < i.length - 1 ? t.push(i[e + 1]) : void 0
                    })
                },
                _traverse: function(t, e, a) {
                    var r, o;
                    return null == t && (t = "vertical"), null == e && (e = n), o = h.aggregate(e), r = [], this.each(function() {
                        var e;
                        return e = i.inArray(this, o[t]), a(r, e, o[t])
                    }), this.pushStack(r)
                },
                _invoke: function(t) {
                    return this.each(function() {
                        var e;
                        return e = o.getWaypointsByElement(this), i.each(e, function(e, i) {
                            return i[t](), !0
                        })
                    }), this
                }
            }, i.fn[y] = function() {
                var t, n;
                return n = arguments[0], t = 2 <= arguments.length ? e.call(arguments, 1) : [], p[n] ? p[n].apply(this, t) : i.isFunction(n) ? p.init.apply(this, arguments) : i.isPlainObject(n) ? p.init.apply(this, [null, n]) : i.error(n ? "The " + n + " method does not exist in jQuery Waypoints." : "jQuery Waypoints needs a callback function or handler option.")
            }, i.fn[y].defaults = {
                context: n,
                continuous: !0,
                enabled: !0,
                horizontal: !1,
                offset: 0,
                triggerOnce: !1
            }, h = {
                refresh: function() {
                    return i.each(u, function(t, e) {
                        return e.refresh()
                    })
                },
                viewportHeight: function() {
                    var t;
                    return null != (t = n.innerHeight) ? t : a.height()
                },
                aggregate: function(t) {
                    var e, n, a;
                    return e = s, t && (e = null != (a = u[i(t)[0][c]]) ? a.waypoints : void 0), e ? (n = {
                        horizontal: [],
                        vertical: []
                    }, i.each(n, function(t, a) {
                        return i.each(e[t], function(t, e) {
                            return a.push(e)
                        }), a.sort(function(t, e) {
                            return t.offset - e.offset
                        }), n[t] = i.map(a, function(t) {
                            return t.element
                        }), n[t] = i.unique(n[t])
                    }), n) : []
                },
                above: function(t) {
                    return null == t && (t = n), h._filter(t, "vertical", function(t, e) {
                        return e.offset <= t.oldScroll.y
                    })
                },
                below: function(t) {
                    return null == t && (t = n), h._filter(t, "vertical", function(t, e) {
                        return e.offset > t.oldScroll.y
                    })
                },
                left: function(t) {
                    return null == t && (t = n), h._filter(t, "horizontal", function(t, e) {
                        return e.offset <= t.oldScroll.x
                    })
                },
                right: function(t) {
                    return null == t && (t = n), h._filter(t, "horizontal", function(t, e) {
                        return e.offset > t.oldScroll.x
                    })
                },
                enable: function() {
                    return h._invoke("enable")
                },
                disable: function() {
                    return h._invoke("disable")
                },
                destroy: function() {
                    return h._invoke("destroy")
                },
                extendFn: function(t, e) {
                    return p[t] = e
                },
                _invoke: function(t) {
                    var e;
                    return e = i.extend({}, s.vertical, s.horizontal), i.each(e, function(e, i) {
                        return i[t](), !0
                    })
                },
                _filter: function(t, e, n) {
                    var a, r;
                    return (a = u[i(t)[0][c]]) ? (r = [], i.each(a.waypoints[e], function(t, e) {
                        return n(a, e) ? r.push(e) : void 0
                    }), r.sort(function(t, e) {
                        return t.offset - e.offset
                    }), i.map(r, function(t) {
                        return t.element
                    })) : []
                }
            }, i[w] = function() {
                var t, i;
                return i = arguments[0], t = 2 <= arguments.length ? e.call(arguments, 1) : [], h[i] ? h[i].apply(null, t) : h.aggregate.call(null, i)
            }, i[w].settings = {
                resizeThrottle: 100,
                scrollThrottle: 30
            }, a.on("load.waypoints", function() {
                return i[w]("refresh")
            })
        })
    }.call(this),
    function($, t) {
        function e() {
            return new Date(Date.UTC.apply(Date, arguments))
        }

        function i() {
            var t = new Date;
            return e(t.getFullYear(), t.getMonth(), t.getDate())
        }

        function n(t) {
            return function() {
                return this[t].apply(this, arguments)
            }
        }

        function a(t, e) {
            function i(t, e) {
                return e.toLowerCase()
            }
            var n = $(t).data(),
                a = {},
                r, o = new RegExp("^" + e.toLowerCase() + "([A-Z])");
            e = new RegExp("^" + e.toLowerCase());
            for (var s in n) e.test(s) && (r = s.replace(o, i), a[r] = n[s]);
            return a
        }

        function r(t) {
            var e = {};
            if (p[t] || (t = t.split("-")[0], p[t])) {
                var i = p[t];
                return $.each(h, function(t, n) {
                    n in i && (e[n] = i[n])
                }), e
            }
        }
        var o = $(window),
            s = function() {
                var t = {
                    get: function(t) {
                        return this.slice(t)[0]
                    },
                    contains: function(t) {
                        for (var e = t && t.valueOf(), i = 0, n = this.length; n > i; i++)
                            if (this[i].valueOf() === e) return i;
                        return -1
                    },
                    remove: function(t) {
                        this.splice(t, 1)
                    },
                    replace: function(t) {
                        t && ($.isArray(t) || (t = [t]), this.clear(), this.push.apply(this, t))
                    },
                    clear: function() {
                        this.splice(0)
                    },
                    copy: function() {
                        var t = new s;
                        return t.replace(this), t
                    }
                };
                return function() {
                    var e = [];
                    return e.push.apply(e, arguments), $.extend(e, t), e
                }
            }(),
            l = function(t, e) {
                this.dates = new s, this.viewDate = i(), this.focusDate = null, this._process_options(e), this.element = $(t), this.isInline = !1, this.isInput = this.element.is("input"), this.component = this.element.is(".date") ? this.element.find(".add-on, .input-group-addon, .btn") : !1, this.hasInput = this.component && this.element.find("input").length, this.component && 0 === this.component.length && (this.component = !1), this.picker = $(f.template), this._buildEvents(), this._attachEvents(), this.isInline ? this.picker.addClass("datepicker-inline").appendTo(this.element) : this.picker.addClass("datepicker-dropdown dropdown-menu"), this.o.rtl && this.picker.addClass("datepicker-rtl"), this.viewMode = this.o.startView, this.o.calendarWeeks && this.picker.find("tfoot th.today").attr("colspan", function(t, e) {
                    return parseInt(e) + 1
                }), this._allow_update = !1, this.setStartDate(this._o.startDate), this.setEndDate(this._o.endDate), this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled), this.fillDow(), this.fillMonths(), this._allow_update = !0, this.update(), this.showMode(), this.isInline && this.show()
            };
        l.prototype = {
            constructor: l,
            _process_options: function(t) {
                this._o = $.extend({}, this._o, t);
                var e = this.o = $.extend({}, this._o),
                    i = e.language;
                switch (p[i] || (i = i.split("-")[0], p[i] || (i = d.language)), e.language = i, e.startView) {
                    case 2:
                    case "decade":
                        e.startView = 2;
                        break;
                    case 1:
                    case "year":
                        e.startView = 1;
                        break;
                    default:
                        e.startView = 0
                }
                switch (e.minViewMode) {
                    case 1:
                    case "months":
                        e.minViewMode = 1;
                        break;
                    case 2:
                    case "years":
                        e.minViewMode = 2;
                        break;
                    default:
                        e.minViewMode = 0
                }
                e.startView = Math.max(e.startView, e.minViewMode), e.multidate !== !0 && (e.multidate = Number(e.multidate) || !1, e.multidate = e.multidate !== !1 ? Math.max(0, e.multidate) : 1), e.multidateSeparator = String(e.multidateSeparator), e.weekStart %= 7, e.weekEnd = (e.weekStart + 6) % 7;
                var n = f.parseFormat(e.format);
                e.startDate !== -1 / 0 && (e.startDate = e.startDate ? e.startDate instanceof Date ? this._local_to_utc(this._zero_time(e.startDate)) : f.parseDate(e.startDate, n, e.language) : -1 / 0), 1 / 0 !== e.endDate && (e.endDate = e.endDate ? e.endDate instanceof Date ? this._local_to_utc(this._zero_time(e.endDate)) : f.parseDate(e.endDate, n, e.language) : 1 / 0), e.daysOfWeekDisabled = e.daysOfWeekDisabled || [], $.isArray(e.daysOfWeekDisabled) || (e.daysOfWeekDisabled = e.daysOfWeekDisabled.split(/[,\s]*/)), e.daysOfWeekDisabled = $.map(e.daysOfWeekDisabled, function(t) {
                    return parseInt(t, 10)
                });
                var a = String(e.orientation).toLowerCase().split(/\s+/g),
                    r = e.orientation.toLowerCase();
                if (a = $.grep(a, function(t) {
                        return /^auto|left|right|top|bottom$/.test(t)
                    }), e.orientation = {
                        x: "auto",
                        y: "auto"
                    }, r && "auto" !== r)
                    if (1 === a.length) switch (a[0]) {
                        case "top":
                        case "bottom":
                            e.orientation.y = a[0];
                            break;
                        case "left":
                        case "right":
                            e.orientation.x = a[0]
                    } else r = $.grep(a, function(t) {
                        return /^left|right$/.test(t)
                    }), e.orientation.x = r[0] || "auto", r = $.grep(a, function(t) {
                        return /^top|bottom$/.test(t)
                    }), e.orientation.y = r[0] || "auto";
                    else;
            },
            _events: [],
            _secondaryEvents: [],
            _applyEvents: function(e) {
                for (var i = 0, n, a, r; i < e.length; i++) n = e[i][0], 2 === e[i].length ? (a = t, r = e[i][1]) : 3 === e[i].length && (a = e[i][1], r = e[i][2]), n.on(r, a)
            },
            _unapplyEvents: function(e) {
                for (var i = 0, n, a, r; i < e.length; i++) n = e[i][0], 2 === e[i].length ? (r = t, a = e[i][1]) : 3 === e[i].length && (r = e[i][1], a = e[i][2]), n.off(a, r)
            },
            _buildEvents: function() {
                this.isInput ? this._events = [
                    [this.element, {
                        focus: $.proxy(this.show, this),
                        keyup: $.proxy(function(t) {
                            -1 === $.inArray(t.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) && this.update()
                        }, this),
                        keydown: $.proxy(this.keydown, this)
                    }]
                ] : this.component && this.hasInput ? this._events = [
                    [this.element.find("input"), {
                        focus: $.proxy(this.show, this),
                        keyup: $.proxy(function(t) {
                            -1 === $.inArray(t.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) && this.update()
                        }, this),
                        keydown: $.proxy(this.keydown, this)
                    }],
                    [this.component, {
                        click: $.proxy(this.show, this)
                    }]
                ] : this.element.is("div") ? this.isInline = !0 : this._events = [
                    [this.element, {
                        click: $.proxy(this.show, this)
                    }]
                ], this._events.push([this.element, "*", {
                    blur: $.proxy(function(t) {
                        this._focused_from = t.target
                    }, this)
                }], [this.element, {
                    blur: $.proxy(function(t) {
                        this._focused_from = t.target
                    }, this)
                }]), this._secondaryEvents = [
                    [this.picker, {
                        click: $.proxy(this.click, this)
                    }],
                    [$(window), {
                        resize: $.proxy(this.place, this)
                    }],
                    [$(document), {
                        "mousedown touchstart": $.proxy(function(t) {
                            this.element.is(t.target) || this.element.find(t.target).length || this.picker.is(t.target) || this.picker.find(t.target).length || this.hide()
                        }, this)
                    }]
                ]
            },
            _attachEvents: function() {
                this._detachEvents(), this._applyEvents(this._events)
            },
            _detachEvents: function() {
                this._unapplyEvents(this._events)
            },
            _attachSecondaryEvents: function() {
                this._detachSecondaryEvents(), this._applyEvents(this._secondaryEvents)
            },
            _detachSecondaryEvents: function() {
                this._unapplyEvents(this._secondaryEvents)
            },
            _trigger: function(t, e) {
                var i = e || this.dates.get(-1),
                    n = this._utc_to_local(i);
                this.element.trigger({
                    type: t,
                    date: n,
                    dates: $.map(this.dates, this._utc_to_local),
                    format: $.proxy(function(t, e) {
                        0 === arguments.length ? (t = this.dates.length - 1, e = this.o.format) : "string" == typeof t && (e = t, t = this.dates.length - 1), e = e || this.o.format;
                        var i = this.dates.get(t);
                        return f.formatDate(i, e, this.o.language)
                    }, this)
                })
            },
            show: function() {
                this.isInline || this.picker.appendTo("body"), this.picker.show(), this.place(), this._attachSecondaryEvents(), this._trigger("show")
            },
            hide: function() {
                this.isInline || this.picker.is(":visible") && (this.focusDate = null, this.picker.hide().detach(), this._detachSecondaryEvents(), this.viewMode = this.o.startView, this.showMode(), this.o.forceParse && (this.isInput && this.element.val() || this.hasInput && this.element.find("input").val()) && this.setValue(), this._trigger("hide"))
            },
            remove: function() {
                this.hide(), this._detachEvents(), this._detachSecondaryEvents(), this.picker.remove(), delete this.element.data().datepicker, this.isInput || delete this.element.data().date
            },
            _utc_to_local: function(t) {
                return t && new Date(t.getTime() + 6e4 * t.getTimezoneOffset())
            },
            _local_to_utc: function(t) {
                return t && new Date(t.getTime() - 6e4 * t.getTimezoneOffset())
            },
            _zero_time: function(t) {
                return t && new Date(t.getFullYear(), t.getMonth(), t.getDate())
            },
            _zero_utc_time: function(t) {
                return t && new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()))
            },
            getDates: function() {
                return $.map(this.dates, this._utc_to_local)
            },
            getUTCDates: function() {
                return $.map(this.dates, function(t) {
                    return new Date(t)
                })
            },
            getDate: function() {
                return this._utc_to_local(this.getUTCDate())
            },
            getUTCDate: function() {
                return new Date(this.dates.get(-1))
            },
            setDates: function() {
                var t = $.isArray(arguments[0]) ? arguments[0] : arguments;
                this.update.apply(this, t), this._trigger("changeDate"), this.setValue()
            },
            setUTCDates: function() {
                var t = $.isArray(arguments[0]) ? arguments[0] : arguments;
                this.update.apply(this, $.map(t, this._utc_to_local)), this._trigger("changeDate"), this.setValue()
            },
            setDate: n("setDates"),
            setUTCDate: n("setUTCDates"),
            setValue: function() {
                var t = this.getFormattedDate();
                this.isInput ? this.element.val(t).change() : this.component && this.element.find("input").val(t).change()
            },
            getFormattedDate: function(e) {
                e === t && (e = this.o.format);
                var i = this.o.language;
                return $.map(this.dates, function(t) {
                    return f.formatDate(t, e, i)
                }).join(this.o.multidateSeparator)
            },
            setStartDate: function(t) {
                this._process_options({
                    startDate: t
                }), this.update(), this.updateNavArrows()
            },
            setEndDate: function(t) {
                this._process_options({
                    endDate: t
                }), this.update(), this.updateNavArrows()
            },
            setDaysOfWeekDisabled: function(t) {
                this._process_options({
                    daysOfWeekDisabled: t
                }), this.update(), this.updateNavArrows()
            },
            place: function() {
                if (!this.isInline) {
                    var t = this.picker.outerWidth(),
                        e = this.picker.outerHeight(),
                        i = 10,
                        n = o.width(),
                        a = o.height(),
                        r = o.scrollTop(),
                        s = parseInt(this.element.parents().filter(function() {
                            return "auto" !== $(this).css("z-index")
                        }).first().css("z-index")) + 10,
                        l = this.component ? this.component.parent().offset() : this.element.offset(),
                        c = this.component ? this.component.outerHeight(!0) : this.element.outerHeight(!1),
                        u = this.component ? this.component.outerWidth(!0) : this.element.outerWidth(!1),
                        d = l.left,
                        h = l.top;
                    this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left"), "auto" !== this.o.orientation.x ? (this.picker.addClass("datepicker-orient-" + this.o.orientation.x), "right" === this.o.orientation.x && (d -= t - u)) : (this.picker.addClass("datepicker-orient-left"), l.left < 0 ? d -= l.left - i : l.left + t > n && (d = n - t - i));
                    var p = this.o.orientation.y,
                        f, g;
                    "auto" === p && (f = -r + l.top - e, g = r + a - (l.top + c + e), p = Math.max(f, g) === g ? "top" : "bottom"), this.picker.addClass("datepicker-orient-" + p), "top" === p ? h += c : h -= e + parseInt(this.picker.css("padding-top")), this.picker.css({
                        top: h,
                        left: d,
                        zIndex: s
                    })
                }
            },
            _allow_update: !0,
            update: function() {
                if (this._allow_update) {
                    var t = this.dates.copy(),
                        e = [],
                        i = !1;
                    arguments.length ? ($.each(arguments, $.proxy(function(t, i) {
                        i instanceof Date && (i = this._local_to_utc(i)), e.push(i)
                    }, this)), i = !0) : (e = this.isInput ? this.element.val() : this.element.data("date") || this.element.find("input").val(), e = e && this.o.multidate ? e.split(this.o.multidateSeparator) : [e], delete this.element.data().date), e = $.map(e, $.proxy(function(t) {
                        return f.parseDate(t, this.o.format, this.o.language)
                    }, this)), e = $.grep(e, $.proxy(function(t) {
                        return t < this.o.startDate || t > this.o.endDate || !t
                    }, this), !0), this.dates.replace(e), this.dates.length ? this.viewDate = new Date(this.dates.get(-1)) : this.viewDate < this.o.startDate ? this.viewDate = new Date(this.o.startDate) : this.viewDate > this.o.endDate && (this.viewDate = new Date(this.o.endDate)), i ? this.setValue() : e.length && String(t) !== String(this.dates) && this._trigger("changeDate"), !this.dates.length && t.length && this._trigger("clearDate"), this.fill()
                }
            },
            fillDow: function() {
                var t = this.o.weekStart,
                    e = "<tr>";
                if (this.o.calendarWeeks) {
                    var i = '<th class="cw">&nbsp;</th>';
                    e += i, this.picker.find(".datepicker-days thead tr:first-child").prepend(i)
                }
                for (; t < this.o.weekStart + 7;) e += '<th class="dow">' + p[this.o.language].daysMin[t++ % 7] + "</th>";
                e += "</tr>", this.picker.find(".datepicker-days thead").append(e)
            },
            fillMonths: function() {
                for (var t = "", e = 0; 12 > e;) t += '<span class="month">' + p[this.o.language].monthsShort[e++] + "</span>";
                this.picker.find(".datepicker-months td").html(t)
            },
            setRange: function(t) {
                t && t.length ? this.range = $.map(t, function(t) {
                    return t.valueOf()
                }) : delete this.range, this.fill()
            },
            getClassNames: function(t) {
                var e = [],
                    i = this.viewDate.getUTCFullYear(),
                    n = this.viewDate.getUTCMonth(),
                    a = new Date;
                return t.getUTCFullYear() < i || t.getUTCFullYear() === i && t.getUTCMonth() < n ? e.push("old") : (t.getUTCFullYear() > i || t.getUTCFullYear() === i && t.getUTCMonth() > n) && e.push("new"), this.focusDate && t.valueOf() === this.focusDate.valueOf() && e.push("focused"), this.o.todayHighlight && t.getUTCFullYear() === a.getFullYear() && t.getUTCMonth() === a.getMonth() && t.getUTCDate() === a.getDate() && e.push("today"), -1 !== this.dates.contains(t) && e.push("active"), (t.valueOf() < this.o.startDate || t.valueOf() > this.o.endDate || -1 !== $.inArray(t.getUTCDay(), this.o.daysOfWeekDisabled)) && e.push("disabled"), this.range && (t > this.range[0] && t < this.range[this.range.length - 1] && e.push("range"), -1 !== $.inArray(t.valueOf(), this.range) && e.push("selected")), e
            },
            fill: function() {
                var i = new Date(this.viewDate),
                    n = i.getUTCFullYear(),
                    a = i.getUTCMonth(),
                    r = this.o.startDate !== -1 / 0 ? this.o.startDate.getUTCFullYear() : -1 / 0,
                    o = this.o.startDate !== -1 / 0 ? this.o.startDate.getUTCMonth() : -1 / 0,
                    s = 1 / 0 !== this.o.endDate ? this.o.endDate.getUTCFullYear() : 1 / 0,
                    l = 1 / 0 !== this.o.endDate ? this.o.endDate.getUTCMonth() : 1 / 0,
                    c = p[this.o.language].today || p.en.today || "",
                    u = p[this.o.language].clear || p.en.clear || "",
                    d;
                this.picker.find(".datepicker-days thead th.datepicker-switch").text(p[this.o.language].months[a] + " " + n), this.picker.find("tfoot th.today").text(c).toggle(this.o.todayBtn !== !1), this.picker.find("tfoot th.clear").text(u).toggle(this.o.clearBtn !== !1), this.updateNavArrows(), this.fillMonths();
                var h = e(n, a - 1, 28),
                    g = f.getDaysInMonth(h.getUTCFullYear(), h.getUTCMonth());
                h.setUTCDate(g), h.setUTCDate(g - (h.getUTCDay() - this.o.weekStart + 7) % 7);
                var m = new Date(h);
                m.setUTCDate(m.getUTCDate() + 42), m = m.valueOf();
                for (var v = [], y; h.valueOf() < m;) {
                    if (h.getUTCDay() === this.o.weekStart && (v.push("<tr>"), this.o.calendarWeeks)) {
                        var w = new Date(+h + (this.o.weekStart - h.getUTCDay() - 7) % 7 * 864e5),
                            b = new Date(Number(w) + (11 - w.getUTCDay()) % 7 * 864e5),
                            x = new Date(Number(x = e(b.getUTCFullYear(), 0, 1)) + (11 - x.getUTCDay()) % 7 * 864e5),
                            S = (b - x) / 864e5 / 7 + 1;
                        v.push('<td class="cw">' + S + "</td>")
                    }
                    if (y = this.getClassNames(h), y.push("day"), this.o.beforeShowDay !== $.noop) {
                        var T = this.o.beforeShowDay(this._utc_to_local(h));
                        T === t ? T = {} : "boolean" == typeof T ? T = {
                            enabled: T
                        } : "string" == typeof T && (T = {
                            classes: T
                        }), T.enabled === !1 && y.push("disabled"), T.classes && (y = y.concat(T.classes.split(/\s+/))), T.tooltip && (d = T.tooltip)
                    }
                    y = $.unique(y), v.push('<td class="' + y.join(" ") + '"' + (d ? ' title="' + d + '"' : "") + ">" + h.getUTCDate() + "</td>"), h.getUTCDay() === this.o.weekEnd && v.push("</tr>"), h.setUTCDate(h.getUTCDate() + 1)
                }
                this.picker.find(".datepicker-days tbody").empty().append(v.join(""));
                var C = this.picker.find(".datepicker-months").find("th:eq(1)").text(n).end().find("span").removeClass("active");
                $.each(this.dates, function(t, e) {
                    e.getUTCFullYear() === n && C.eq(e.getUTCMonth()).addClass("active")
                }), (r > n || n > s) && C.addClass("disabled"), n === r && C.slice(0, o).addClass("disabled"), n === s && C.slice(l + 1).addClass("disabled"), v = "", n = 10 * parseInt(n / 10, 10);
                var k = this.picker.find(".datepicker-years").find("th:eq(1)").text(n + "-" + (n + 9)).end().find("td");
                n -= 1;
                for (var D = $.map(this.dates, function(t) {
                        return t.getUTCFullYear()
                    }), P, E = -1; 11 > E; E++) P = ["year"], -1 === E ? P.push("old") : 10 === E && P.push("new"), -1 !== $.inArray(n, D) && P.push("active"), (r > n || n > s) && P.push("disabled"), v += '<span class="' + P.join(" ") + '">' + n + "</span>", n += 1;
                k.html(v)
            },
            updateNavArrows: function() {
                if (this._allow_update) {
                    var t = new Date(this.viewDate),
                        e = t.getUTCFullYear(),
                        i = t.getUTCMonth();
                    switch (this.viewMode) {
                        case 0:
                            this.picker.find(".prev").css(this.o.startDate !== -1 / 0 && e <= this.o.startDate.getUTCFullYear() && i <= this.o.startDate.getUTCMonth() ? {
                                visibility: "hidden"
                            } : {
                                visibility: "visible"
                            }), this.picker.find(".next").css(1 / 0 !== this.o.endDate && e >= this.o.endDate.getUTCFullYear() && i >= this.o.endDate.getUTCMonth() ? {
                                visibility: "hidden"
                            } : {
                                visibility: "visible"
                            });
                            break;
                        case 1:
                        case 2:
                            this.picker.find(".prev").css(this.o.startDate !== -1 / 0 && e <= this.o.startDate.getUTCFullYear() ? {
                                visibility: "hidden"
                            } : {
                                visibility: "visible"
                            }), this.picker.find(".next").css(1 / 0 !== this.o.endDate && e >= this.o.endDate.getUTCFullYear() ? {
                                visibility: "hidden"
                            } : {
                                visibility: "visible"
                            })
                    }
                }
            },
            click: function(t) {
                t.preventDefault();
                var i = $(t.target).closest("span, td, th"),
                    n, a, r;
                if (1 === i.length) switch (i[0].nodeName.toLowerCase()) {
                    case "th":
                        switch (i[0].className) {
                            case "datepicker-switch":
                                this.showMode(1);
                                break;
                            case "prev":
                            case "next":
                                var o = f.modes[this.viewMode].navStep * ("prev" === i[0].className ? -1 : 1);
                                switch (this.viewMode) {
                                    case 0:
                                        this.viewDate = this.moveMonth(this.viewDate, o), this._trigger("changeMonth", this.viewDate);
                                        break;
                                    case 1:
                                    case 2:
                                        this.viewDate = this.moveYear(this.viewDate, o), 1 === this.viewMode && this._trigger("changeYear", this.viewDate)
                                }
                                this.fill();
                                break;
                            case "today":
                                var s = new Date;
                                s = e(s.getFullYear(), s.getMonth(), s.getDate(), 0, 0, 0), this.showMode(-2);
                                var l = "linked" === this.o.todayBtn ? null : "view";
                                this._setDate(s, l);
                                break;
                            case "clear":
                                var c;
                                this.isInput ? c = this.element : this.component && (c = this.element.find("input")), c && c.val("").change(), this.update(), this._trigger("changeDate"), this.o.autoclose && this.hide()
                        }
                        break;
                    case "span":
                        i.is(".disabled") || (this.viewDate.setUTCDate(1), i.is(".month") ? (r = 1, a = i.parent().find("span").index(i), n = this.viewDate.getUTCFullYear(), this.viewDate.setUTCMonth(a), this._trigger("changeMonth", this.viewDate), 1 === this.o.minViewMode && this._setDate(e(n, a, r))) : (r = 1, a = 0, n = parseInt(i.text(), 10) || 0, this.viewDate.setUTCFullYear(n), this._trigger("changeYear", this.viewDate), 2 === this.o.minViewMode && this._setDate(e(n, a, r))), this.showMode(-1), this.fill());
                        break;
                    case "td":
                        i.is(".day") && !i.is(".disabled") && (r = parseInt(i.text(), 10) || 1, n = this.viewDate.getUTCFullYear(), a = this.viewDate.getUTCMonth(), i.is(".old") ? 0 === a ? (a = 11, n -= 1) : a -= 1 : i.is(".new") && (11 === a ? (a = 0, n += 1) : a += 1), this._setDate(e(n, a, r)))
                }
                this.picker.is(":visible") && this._focused_from && $(this._focused_from).focus(), delete this._focused_from
            },
            _toggle_multidate: function(t) {
                var e = this.dates.contains(t);
                if (t ? -1 !== e ? this.dates.remove(e) : this.dates.push(t) : this.dates.clear(), "number" == typeof this.o.multidate)
                    for (; this.dates.length > this.o.multidate;) this.dates.remove(0)
            },
            _setDate: function(t, e) {
                e && "date" !== e || this._toggle_multidate(t && new Date(t)), e && "view" !== e || (this.viewDate = t && new Date(t)), this.fill(), this.setValue(), this._trigger("changeDate");
                var i;
                this.isInput ? i = this.element : this.component && (i = this.element.find("input")), i && i.change(), !this.o.autoclose || e && "date" !== e || this.hide()
            },
            moveMonth: function(e, i) {
                if (!e) return t;
                if (!i) return e;
                var n = new Date(e.valueOf()),
                    a = n.getUTCDate(),
                    r = n.getUTCMonth(),
                    o = Math.abs(i),
                    s, l;
                if (i = i > 0 ? 1 : -1, 1 === o) l = -1 === i ? function() {
                    return n.getUTCMonth() === r
                } : function() {
                    return n.getUTCMonth() !== s
                }, s = r + i, n.setUTCMonth(s), (0 > s || s > 11) && (s = (s + 12) % 12);
                else {
                    for (var c = 0; o > c; c++) n = this.moveMonth(n, i);
                    s = n.getUTCMonth(), n.setUTCDate(a), l = function() {
                        return s !== n.getUTCMonth()
                    }
                }
                for (; l();) n.setUTCDate(--a), n.setUTCMonth(s);
                return n
            },
            moveYear: function(t, e) {
                return this.moveMonth(t, 12 * e)
            },
            dateWithinRange: function(t) {
                return t >= this.o.startDate && t <= this.o.endDate
            },
            keydown: function(t) {
                if (this.picker.is(":not(:visible)")) return void(27 === t.keyCode && this.show());
                var e = !1,
                    n, a, r, o = this.focusDate || this.viewDate;
                switch (t.keyCode) {
                    case 27:
                        this.focusDate ? (this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.fill()) : this.hide(), t.preventDefault();
                        break;
                    case 37:
                    case 39:
                        if (!this.o.keyboardNavigation) break;
                        n = 37 === t.keyCode ? -1 : 1, t.ctrlKey ? (a = this.moveYear(this.dates.get(-1) || i(), n), r = this.moveYear(o, n), this._trigger("changeYear", this.viewDate)) : t.shiftKey ? (a = this.moveMonth(this.dates.get(-1) || i(), n), r = this.moveMonth(o, n), this._trigger("changeMonth", this.viewDate)) : (a = new Date(this.dates.get(-1) || i()), a.setUTCDate(a.getUTCDate() + n), r = new Date(o), r.setUTCDate(o.getUTCDate() + n)), this.dateWithinRange(a) && (this.focusDate = this.viewDate = r, this.setValue(), this.fill(), t.preventDefault());
                        break;
                    case 38:
                    case 40:
                        if (!this.o.keyboardNavigation) break;
                        n = 38 === t.keyCode ? -1 : 1, t.ctrlKey ? (a = this.moveYear(this.dates.get(-1) || i(), n), r = this.moveYear(o, n), this._trigger("changeYear", this.viewDate)) : t.shiftKey ? (a = this.moveMonth(this.dates.get(-1) || i(), n), r = this.moveMonth(o, n), this._trigger("changeMonth", this.viewDate)) : (a = new Date(this.dates.get(-1) || i()), a.setUTCDate(a.getUTCDate() + 7 * n), r = new Date(o), r.setUTCDate(o.getUTCDate() + 7 * n)), this.dateWithinRange(a) && (this.focusDate = this.viewDate = r, this.setValue(), this.fill(), t.preventDefault());
                        break;
                    case 32:
                        break;
                    case 13:
                        o = this.focusDate || this.dates.get(-1) || this.viewDate, this._toggle_multidate(o), e = !0, this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.setValue(), this.fill(), this.picker.is(":visible") && (t.preventDefault(), this.o.autoclose && this.hide());
                        break;
                    case 9:
                        this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.fill(), this.hide()
                }
                if (e) {
                    this._trigger(this.dates.length ? "changeDate" : "clearDate");
                    var s;
                    this.isInput ? s = this.element : this.component && (s = this.element.find("input")), s && s.change()
                }
            },
            showMode: function(t) {
                t && (this.viewMode = Math.max(this.o.minViewMode, Math.min(2, this.viewMode + t))), this.picker.find(">div").hide().filter(".datepicker-" + f.modes[this.viewMode].clsName).css("display", "block"), this.updateNavArrows()
            }
        };
        var c = function(t, e) {
            this.element = $(t), this.inputs = $.map(e.inputs, function(t) {
                return t.jquery ? t[0] : t
            }), delete e.inputs, $(this.inputs).datepicker(e).bind("changeDate", $.proxy(this.dateUpdated, this)), this.pickers = $.map(this.inputs, function(t) {
                return $(t).data("datepicker")
            }), this.updateDates()
        };
        c.prototype = {
            updateDates: function() {
                this.dates = $.map(this.pickers, function(t) {
                    return t.getUTCDate()
                }), this.updateRanges()
            },
            updateRanges: function() {
                var t = $.map(this.dates, function(t) {
                    return t.valueOf()
                });
                $.each(this.pickers, function(e, i) {
                    i.setRange(t)
                })
            },
            dateUpdated: function(t) {
                if (!this.updating) {
                    this.updating = !0;
                    var e = $(t.target).data("datepicker"),
                        i = e.getUTCDate(),
                        n = $.inArray(t.target, this.inputs),
                        a = this.inputs.length;
                    if (-1 !== n) {
                        if ($.each(this.pickers, function(t, e) {
                                e.getUTCDate() || e.setUTCDate(i)
                            }), i < this.dates[n])
                            for (; n >= 0 && i < this.dates[n];) this.pickers[n--].setUTCDate(i);
                        else if (i > this.dates[n])
                            for (; a > n && i > this.dates[n];) this.pickers[n++].setUTCDate(i);
                        this.updateDates(), delete this.updating
                    }
                }
            },
            remove: function() {
                $.map(this.pickers, function(t) {
                    t.remove()
                }), delete this.element.data().datepicker
            }
        };
        var u = $.fn.datepicker;
        $.fn.datepicker = function(e) {
            var i = Array.apply(null, arguments);
            i.shift();
            var n;
            return this.each(function() {
                var o = $(this),
                    s = o.data("datepicker"),
                    u = "object" == typeof e && e;
                if (!s) {
                    var h = a(this, "date"),
                        p = $.extend({}, d, h, u),
                        f = r(p.language),
                        g = $.extend({}, d, f, h, u);
                    if (o.is(".input-daterange") || g.inputs) {
                        var m = {
                            inputs: g.inputs || o.find("input").toArray()
                        };
                        o.data("datepicker", s = new c(this, $.extend(g, m)))
                    } else o.data("datepicker", s = new l(this, g))
                }
                return "string" == typeof e && "function" == typeof s[e] && (n = s[e].apply(s, i), n !== t) ? !1 : void 0
            }), n !== t ? n : this
        };
        var d = $.fn.datepicker.defaults = {
                autoclose: !1,
                beforeShowDay: $.noop,
                calendarWeeks: !1,
                clearBtn: !1,
                daysOfWeekDisabled: [],
                endDate: 1 / 0,
                forceParse: !0,
                format: "mm/dd/yyyy",
                keyboardNavigation: !0,
                language: "en",
                minViewMode: 0,
                multidate: !1,
                multidateSeparator: ",",
                orientation: "auto",
                rtl: !1,
                startDate: -1 / 0,
                startView: 0,
                todayBtn: !1,
                todayHighlight: !1,
                weekStart: 0
            },
            h = $.fn.datepicker.locale_opts = ["format", "rtl", "weekStart"];
        $.fn.datepicker.Constructor = l;
        var p = $.fn.datepicker.dates = {
                en: {
                    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                    daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                    daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
                    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                    monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                    today: "Today",
                    clear: "Clear"
                }
            },
            f = {
                modes: [{
                    clsName: "days",
                    navFnc: "Month",
                    navStep: 1
                }, {
                    clsName: "months",
                    navFnc: "FullYear",
                    navStep: 1
                }, {
                    clsName: "years",
                    navFnc: "FullYear",
                    navStep: 10
                }],
                isLeapYear: function(t) {
                    return t % 4 === 0 && t % 100 !== 0 || t % 400 === 0
                },
                getDaysInMonth: function(t, e) {
                    return [31, f.isLeapYear(t) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][e]
                },
                validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
                nonpunctuation: /[^ -\/:-@\[\u3400-\u9fff-`{-~\t\n\r]+/g,
                parseFormat: function(t) {
                    var e = t.replace(this.validParts, "\x00").split("\x00"),
                        i = t.match(this.validParts);
                    if (!e || !e.length || !i || 0 === i.length) throw new Error("Invalid date format.");
                    return {
                        separators: e,
                        parts: i
                    }
                },
                parseDate: function(i, n, a) {
                    function r() {
                        var t = this.slice(0, s[d].length),
                            e = s[d].slice(0, t.length);
                        return t === e
                    }
                    if (!i) return t;
                    if (i instanceof Date) return i;
                    "string" == typeof n && (n = f.parseFormat(n));
                    var o = /([\-+]\d+)([dmwy])/,
                        s = i.match(/([\-+]\d+)([dmwy])/g),
                        c, u, d;
                    if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(i)) {
                        for (i = new Date, d = 0; d < s.length; d++) switch (c = o.exec(s[d]), u = parseInt(c[1]), c[2]) {
                            case "d":
                                i.setUTCDate(i.getUTCDate() + u);
                                break;
                            case "m":
                                i = l.prototype.moveMonth.call(l.prototype, i, u);
                                break;
                            case "w":
                                i.setUTCDate(i.getUTCDate() + 7 * u);
                                break;
                            case "y":
                                i = l.prototype.moveYear.call(l.prototype, i, u)
                        }
                        return e(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate(), 0, 0, 0)
                    }
                    s = i && i.match(this.nonpunctuation) || [], i = new Date;
                    var h = {},
                        g = ["yyyy", "yy", "M", "MM", "m", "mm", "d", "dd"],
                        m = {
                            yyyy: function(t, e) {
                                return t.setUTCFullYear(e)
                            },
                            yy: function(t, e) {
                                return t.setUTCFullYear(2e3 + e)
                            },
                            m: function(t, e) {
                                if (isNaN(t)) return t;
                                for (e -= 1; 0 > e;) e += 12;
                                for (e %= 12, t.setUTCMonth(e); t.getUTCMonth() !== e;) t.setUTCDate(t.getUTCDate() - 1);
                                return t
                            },
                            d: function(t, e) {
                                return t.setUTCDate(e)
                            }
                        },
                        v, y;
                    m.M = m.MM = m.mm = m.m, m.dd = m.d, i = e(i.getFullYear(), i.getMonth(), i.getDate(), 0, 0, 0);
                    var w = n.parts.slice();
                    if (s.length !== w.length && (w = $(w).filter(function(t, e) {
                            return -1 !== $.inArray(e, g)
                        }).toArray()), s.length === w.length) {
                        var b;
                        for (d = 0, b = w.length; b > d; d++) {
                            if (v = parseInt(s[d], 10), c = w[d], isNaN(v)) switch (c) {
                                case "MM":
                                    y = $(p[a].months).filter(r), v = $.inArray(y[0], p[a].months) + 1;
                                    break;
                                case "M":
                                    y = $(p[a].monthsShort).filter(r), v = $.inArray(y[0], p[a].monthsShort) + 1
                            }
                            h[c] = v
                        }
                        var x, S;
                        for (d = 0; d < g.length; d++) S = g[d], S in h && !isNaN(h[S]) && (x = new Date(i), m[S](x, h[S]), isNaN(x) || (i = x))
                    }
                    return i
                },
                formatDate: function(t, e, i) {
                    if (!t) return "";
                    "string" == typeof e && (e = f.parseFormat(e));
                    var n = {
                        d: t.getUTCDate(),
                        D: p[i].daysShort[t.getUTCDay()],
                        DD: p[i].days[t.getUTCDay()],
                        m: t.getUTCMonth() + 1,
                        M: p[i].monthsShort[t.getUTCMonth()],
                        MM: p[i].months[t.getUTCMonth()],
                        yy: t.getUTCFullYear().toString().substring(2),
                        yyyy: t.getUTCFullYear()
                    };
                    n.dd = (n.d < 10 ? "0" : "") + n.d, n.mm = (n.m < 10 ? "0" : "") + n.m, t = [];
                    for (var a = $.extend([], e.separators), r = 0, o = e.parts.length; o >= r; r++) a.length && t.push(a.shift()), t.push(n[e.parts[r]]);
                    return t.join("")
                },
                headTemplate: '<thead><tr><th class="prev">&laquo;</th><th colspan="5" class="datepicker-switch"></th><th class="next">&raquo;</th></tr></thead>',
                contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
                footTemplate: '<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'
            };
        f.template = '<div class="datepicker"><div class="datepicker-days"><table class=" table-condensed">' + f.headTemplate + "<tbody></tbody>" + f.footTemplate + '</table></div><div class="datepicker-months"><table class="table-condensed">' + f.headTemplate + f.contTemplate + f.footTemplate + '</table></div><div class="datepicker-years"><table class="table-condensed">' + f.headTemplate + f.contTemplate + f.footTemplate + "</table></div></div>", $.fn.datepicker.DPGlobal = f, $.fn.datepicker.noConflict = function() {
            return $.fn.datepicker = u, this
        }, $(document).on("focus.datepicker.data-api click.datepicker.data-api", '[data-provide="datepicker"]', function(t) {
            var e = $(this);
            e.data("datepicker") || (t.preventDefault(), e.datepicker("show"))
        }), $(function() {
            $('[data-provide="datepicker-inline"]').datepicker()
        })
    }(window.jQuery), jQuery(document).ready(function($) {
        $(window).scroll(function() {
            $(this).scrollTop() >= 50 ? $(".header,.headerSearchContainer").addClass("scrolledHeader") : $(".header,.headerSearchContainer").removeClass("scrolledHeader")
        }), $(".whitechapelHamburger").live("click", function() {
            $("body").toggleClass("mobileNavOpen")
        }), $(".whitechapelMobileSearch").live("click", function() {
            $("body").toggleClass("mobileSearchOpen")
        }), $(".revealSearchBar").click(function() {
            return $(".basket").removeClass("activeBasket"), $(".headerSearchContainer,.header").toggleClass("activeSearch"), !1
        }), $(".basket").live("click", function() {
            return $(".headerSearchContainer,.header").removeClass("activeSearch"), $(this).toggleClass("activeBasket"), !1
        }), $(".mobileBasket").live("click", function() {
            return $(this).toggleClass("activeMobileBasket"), !1
        })
    });
